import PGridMatrices from './pgridMatrices.js'
import EnhancedParser from '../formula-parser/enhanced-parser.js'
// import { extractLabel } from '../formula-parser/helper/cell'
import { extractLabel, toLabel, columnLabelToIndex, rowLabelToIndex } from '../formula-parser/helper/cell.js';

import BatchingToposort from '../batching-toposort/batching-toposort.js'
import lodash from 'lodash'
import { detailedDiff } from 'deep-object-diff'
import { QueryPGridGetGrid } from './pgridBackendAccess.js'

import PGridDynExtract from './pgridDynExtract.js'

// const PGridDynExtract = require("./pgridDynExtract");
// import cycle from '../../lib/cycle/cycle.js'

import PGridCell, { Insert_Calculated_Cell, Get_Val_For_FormulaParser, Get_PGridCell_Value, expandIfNeeded, MaybieCopyObj } from './pgridCell.js'

const SUPERWISE_TAB_UPDATE_DELAY = 750; //MS

if (typeof window == 'undefined') {
    global['window'] = {};
}

let detDiff = detailedDiff;

export function Diff_PgridData(pgridDataLeft, pgridDataRight) {

    let detailedDiff = detDiff(pgridDataLeft, pgridDataRight);

    return detailedDiff;
}
export function Translate_ViewModeToMergeType(vMode) {

    if (vMode == null) {
        throw `vMode is not specified`;
    }

    var ret = null;

    switch (vMode) {
        case "Default":
            ret = "default"
            break;
        case "Design":
            ret = "default_static"
            break;
        case "Raw":
            ret = "default_raw"
            break;
        // case "Content":
        //     ret = "default"
        //     break;
        case "Formats":
            ret = "Format"
            break;
        case "Formulas":
            ret = "Formula"
            break;
        case "Refs":
            ret = "RefType"
            break;
        case "JSON":
            ret = "Json"
            break;
        default:
            ret = null
            throw "ModeToRefType(): Invalid type of data: \"" + mode + "\""
            break;
    };

    return ret;
}



/*
*
*   Input: pgrid table data
*   Operation: Calculate formulas
*   Output:
*        pgridTableCalculated
*        , cellsWithFormulas
*        , cellsThatWasReferenced
*        , cellsToUpdate
*
*/
export async function Calculate_All_Formulas(context, pgridTable, { cellsThatAreReferenced, cellsThatAreReferenced_Inv, changedReferedCells, changedFormulaCells, cellsThatAreReferencingLinkedRangeOverlays, source }) {


    let ret = {
        pgridTableCalculated: null,
        cellsThatWasReferenced: null,
        cellsToUpdate: null
    };



    let objTxtLen = function (obj) {

        return `${obj != null ? JSON.stringify(obj).length : 0}`
    }


    if (window && window.PGridClientDebugMode >= 3) {


        console.log(`MUX:Calculate_All_Formulas() cellsThatAreReferenced: ${objTxtLen(cellsThatAreReferenced)}, changedReferedCells: ${objTxtLen(changedReferedCells)}, changedFormulaCells: ${objTxtLen(changedFormulaCells)}:${JSON.stringify(changedFormulaCells)}, cellsThatAreReferencingLinkedRangeOverlays: ${objTxtLen(cellsThatAreReferencingLinkedRangeOverlays)}`);
    }

    if (typeof changedFormulaCells === 'undefined') {
        var changedFormulaCells = [];
    }
    if (typeof source === 'undefined') {
        var source = `(unknonwn source)`;
    }

    window && window.PGridClientDebugMode >= 1 && console.debug(`Calculate_All_Formulas() source: ${source}`);//, pgridTable);

    let cellsThatAreReferenced_Clone = lodash.cloneDeep(cellsThatAreReferenced);

    let pgridTableCopy = lodash.clone(pgridTable);
    let cellsWithFormulas = []; // cels that have Formula
    let cellsToUpdate = [];



    //Add newly (after init) added formulas (Example "=A1")
    if (changedFormulaCells != null) {
        for (let i = 0; i < changedFormulaCells.length; i++) {

            let changedCell = changedFormulaCells[i].split(":");

            //Insert formula cell (not needed)
            pgridTableCopy[changedCell[0]][changedCell[1]].Formula = changedCell[2];

        }
    }


    for (let y = 0; y < pgridTableCopy.length; y++) {
        for (let x = 0; x < pgridTableCopy[y].length; x++) {

            let cellIter = pgridTableCopy[y][x];

            if (cellIter != null) {
                if ("Formula" in cellIter
                    && cellIter.Formula != null
                    && String(cellIter.Formula).trim() !== ""
                ) {
                    //Put formula cell in list for processing
                    cellsWithFormulas.push(`${y}:${x}`);

                }
            }
        }
    }


    let cellsWithFormulas_hasNoRefs = [];
    //1:st determin references to other cells
    for (let i = 0; i < cellsWithFormulas.length; i++) {
        // let cellF =
        let cellFKey = cellsWithFormulas[i];

        let cellY = parseInt(cellFKey.split(":")[0]);
        let cellX = parseInt(cellFKey.split(":")[1]);
        let formula = pgridTableCopy[cellY][cellX].Formula;
        let refsKeys = GetRefsFromFormula(formula, cellY, cellX);
        // if (!(cellFKey in cellIsReferencedFrom)) {
        // }

        // if (!EnhancedParser) {
        //     throw new Error(`EnhancedParser is (false)`);
        // }

        // let eParseSrcCell = [{ index: cellY, dim: 'row' }, { index: cellX, dim: 'col' }];

        // let getRng_eParser = "default" in EnhancedParser ? new EnhancedParser.default(eParseSrcCell) : new EnhancedParser(eParseSrcCell);


        // let formulaToCalc = pgridTableCopy[cellY][cellX].Formula;


        // //Remove any "="
        // if (formulaToCalc != null && String(formulaToCalc).length > 0 && String(formulaToCalc)[0] === '=') {
        //     formulaToCalc = formulaToCalc.substr(1);
        // }

        // let refs = null
        // try {



        //     getRng_eParser.on('reCallCellValue', (cell, done) => {
        //         const { label, row, column } = cell;
        //         let value = 1;
        //         done(value);
        //     });

        //     getRng_eParser.on('reCallRangeValue', (startCell, endCell, done) => {
        //         // value = 1000 * (row.index + 1) + 1 * (column.index + 1);
        //         // if (startCell.label === 'K9' && endCell.label === 'L11') {
        //         done([[1, 2]
        //             , [3, 4]]);
        //         // }
        //     });



        //     refs = getRng_eParser.getRefs(formulaToCalc);

        // } catch (error) {
        //     console.warn("Got error in formula parsing:", error.message);
        // }
        // getRng_eParser = null;


        // let refsKeys = Object.keys(refs);

        for (let j = 0; j < refsKeys.length; j++) {

            let refCell = refsKeys[j];


            if (!cellsThatAreReferenced_Clone) {
                throw new Error(`cellsThatIsReferencedFromCells is (false) 1`);
            }

            if (!(refCell in cellsThatAreReferenced_Clone)) {
                cellsWithFormulas_hasNoRefs.push(refCell);

                //Not sure this is needed
                cellsThatAreReferenced_Clone[refCell] = [];
            }

            // Add this current cellFKey to level 2 array, if not present
            if (cellsThatAreReferenced_Clone[refCell].indexOf(cellFKey) === -1) {
                cellsThatAreReferenced_Clone[refCell].push(cellFKey);
            }

        }
        // if (refsKeys.length == 0) {
        //     cellsThatAreReferenced_Clone[cellFKey] = [];
        // }
    }

    //1.5 filter by changed cells


    window.PGridClientDebugMode >= 3 && console.debug("MUX:Calculate_All_Formulas() cellsWithFormulas:", cellsWithFormulas);
    window.PGridClientDebugMode >= 3 && console.debug("MUX:Calculate_All_Formulas() changedReferedCells:", changedReferedCells);
    window.PGridClientDebugMode >= 3 && console.debug("MUX:Calculate_All_Formulas() cellsThatIsReferencedFromCells BEFORE", cellsThatAreReferenced_Clone);


    let recursiveFilterReference = function (cellsThatIsReferencedFromCells, cellsThatAreReferenced_Reversed, changedRefCells, changedFormulaCells, res = {}) {
        let didAdd = false;

        //Only in first iteration then changedRefCellsCpy = []
        for (let i = 0; i < changedRefCells.length; i++) {
            let changedRefCell = changedRefCells[i];

            if (!cellsThatIsReferencedFromCells) {
                throw new Error(`cellsThatIsReferencedFromCells is (false) 2`);
            }

            if (changedRefCell in cellsThatIsReferencedFromCells) {
                res[changedRefCell] = cellsThatIsReferencedFromCells[changedRefCell];
                didAdd = true;
            }
        }

        //Only in first iteration then changedFormulaCell = []
        for (let i = 0; i < changedFormulaCells.length; i++) {
            let changedFormulaCell = changedFormulaCells[i];
            let changedFormulaCellSplit = changedFormulaCell.split(":");
            let changedFormulaCellOnlyAddr = changedFormulaCellSplit[0] + ":" + changedFormulaCellSplit[1];


            if (!cellsThatIsReferencedFromCells) {
                throw new Error(`cellsThatIsReferencedFromCells is (false) 3`);
            }

            if (changedFormulaCellOnlyAddr in cellsThatIsReferencedFromCells) {


                res[changedFormulaCellOnlyAddr] = cellsThatIsReferencedFromCells[changedFormulaCellOnlyAddr];
                didAdd = true;
            } else {
                //Add empty
                res[changedFormulaCellOnlyAddr] = [];
            }
        }



        let resKeys = Object.keys(res);
        for (let i = 0; i < resKeys.length; i++) {

            let resKey = resKeys[i];

            if (resKey in cellsThatAreReferenced_Reversed) {

                for (let j = 0; j < cellsThatAreReferenced_Reversed[resKey].length; j++) {

                    let newResKey = cellsThatAreReferenced_Reversed[resKey][j];

                    res[newResKey] = (newResKey in cellsThatIsReferencedFromCells) ? cellsThatIsReferencedFromCells[newResKey] : [];
                }

            }


            let resKeyRefs = res[resKey];

            for (let j = 0; j < resKeyRefs.length; j++) {


                let resKeyRefsVal = resKeyRefs[j];


                if (!(resKeyRefsVal in res)) {

                    //Must add this from non filtered;

                    if ((resKeyRefsVal in cellsThatIsReferencedFromCells)) {
                        res[resKeyRefsVal] = cellsThatIsReferencedFromCells[resKeyRefsVal];
                    } else {
                        res[resKeyRefsVal] = [];
                    }

                    // res[resKeyRefsVal] = (resKeyRefsVal in cellsThatIsReferencedFromCells) ? cellsThatIsReferencedFromCells[resKeyRefsVal] : [];
                    didAdd = true;
                }

            }
        }


        if (didAdd) {
            return recursiveFilterReference(cellsThatIsReferencedFromCells, cellsThatAreReferenced_Reversed, [], [], res);
        } else {
            return res;
        }
    }


    // update cellsThatIsReferencedFromCells

    if (false && changedReferedCells != null) {

        let cellsThatIsReferencedFromCells_Reversed = InvertObjArr(cellsThatAreReferenced_Clone);

        window.PGridClientDebugMode >= 3 && console.log("MUX:cellsThatIsReferencedFromCells recursiveFilterRecerence() BEFORE length:", objTxtLen(cellsThatAreReferenced_Clone));

        cellsThatAreReferenced_Clone = recursiveFilterReference(cellsThatAreReferenced_Clone, cellsThatIsReferencedFromCells_Reversed, changedReferedCells, changedFormulaCells, {});

        window.PGridClientDebugMode >= 3 && console.log("MUX:cellsThatIsReferencedFromCells recursiveFilterRecerence()  AFTER length:", objTxtLen(cellsThatAreReferenced_Clone));

    }


    let calcOrder = null;

    if (context.state.pgridSettings.calcOrderCache) {
        window.PGridClientDebugMode >= 3 && console.log(`Calculate_all_Formulas() soure: ${source} using cached calculation order`)
        calcOrder = context.state.pgridSettings.calcOrderCache;
    } else {
        let foundCircular = null;
        let batchingToposortOrder = null;
        try {

            batchingToposortOrder = "default" in BatchingToposort ? BatchingToposort.default(cellsThatAreReferenced_Clone, true) : BatchingToposort(cellsThatAreReferenced_Clone, true);
            calcOrder = batchingToposortOrder.sorted;
            foundCircular = batchingToposortOrder.circles;
        }
        catch (err) {
            console.warn`BatchingToposort() throwed an exception: ${err.message}`;
        }



        let calcOrder_BatchingToposort = lodash.cloneDeep(calcOrder);
        window.PGridClientDebugMode >= 3 && console.debug("Calculate_All_Formulas() calcOrder", calcOrder);
        window.PGridClientDebugMode >= 3 && console.debug("Calculate_All_Formulas() calcOrder", calcOrder);

        //Copy known formula cells
        let formulaCellsWithNoRefs = lodash.clone(cellsWithFormulas);



        //Remove any listed in calcOrder
        if (Array.isArray(calcOrder)) {
            for (let j = 0; j < calcOrder.length; j++) {
                const lvlTasks = calcOrder[j];

                for (let k = 0; k < lvlTasks.length; k++) {

                    const calcCell = lvlTasks[k]

                    //Filter if in list
                    // window.PGridClientDebugMode >= 3 && console.debug(`MUX:Calculate_All_Formulas() formulaCellsWithNoRefs before [${j}][${k}] filter "${calcCell}"`, formulaCellsWithNoRefs);
                    //Remove if found
                    // formulaCellsWithNoRefs = formulaCellsWithNoRefs.filter(val => val !== calcCell);
                    for (let i = formulaCellsWithNoRefs.length; i >= 0; i--) {
                        if (formulaCellsWithNoRefs[i] === calcCell) {
                            formulaCellsWithNoRefs.splice(i, 1);
                            // window.PGridClientDebugMode >= 3 && console.debug(`Calculate_All_Formulas() formulaCellsWithNoRefs filter "${calcCell}"`);
                        }
                    }

                    // window.PGridClientDebugMode >= 3 && console.debug(`MUX:Calculate_All_Formulas() formulaCellsWithNoRefs  after [${j}][${k}] filter "${calcCell}"`, formulaCellsWithNoRefs);
                }
            }
        }


        // //Add formula cells that has no refs
        // calcOrder.unshift(cellsWithFormulas_hasNoRefs);
        // // calcOrder.unshift(formulaCellsWithNoRefs);


        //Handle any circular refs
        if (Array.isArray(foundCircular) && foundCircular.length > 0) {
            //Removing foundCircular reference cells
            // formulaCellsWithNoRefs = formulaCellsWithNoRefs.filter(val => foundCircular.indexOf(val) === -1);
            for (let i = formulaCellsWithNoRefs.length; i >= 0; i--) {
                if (foundCircular.indexOf(formulaCellsWithNoRefs[i]) !== -1) {
                    formulaCellsWithNoRefs.splice(i, 1);
                }
            }



            // let cellsThatAreReferenced_Inv = InvertObjArr(cellsThatAreReferenced_Clone);

            for (let a = 0; a < foundCircular.length; a++) {
                let circCell = foundCircular[a];

                let insCircCellError = Calculate_Cell_Error(circCell, null, "#CIRCULAR!");
                let { hotValue, error } = Insert_Calculated_Cell(insCircCellError, pgridTableCopy);

                let circRefCells = cellsThatAreReferenced_Inv[circCell];
                for (let b = 0; b < circRefCells.length; b++) {

                    let circCell2 = circRefCells[b];

                    let insCircCellError2 = Calculate_Cell_Error(circCell2, null, "#CIRCULAR!");

                    let { hotValue, error } = Insert_Calculated_Cell(insCircCellError2, pgridTableCopy);

                }

            }
        }

        window.PGridClientDebugMode >= 3 && console.debug("MUX:Calculate_All_Formulas() formulaCellsWithNoRefs", formulaCellsWithNoRefs);


        //New calc order, add self referenced formulas to the top;


        window.PGridClientDebugMode >= 2 && console.debug(`MUX:Calculate_All_Formulas() Calculate almost  order length: ${calcOrder.length}`);

        if (true || changedReferedCells == null) { //Only add formulaCellsWithNoRefs when calculating all

            if (formulaCellsWithNoRefs.length > 0) {
                calcOrder.unshift(formulaCellsWithNoRefs);
            }
        }

        // if (Array.isArray(foundCircular) && foundCircular.length > 0) {
        //     //Some formulas is broken
        //     console.error("DEBUG: foundCircular: " + JSON.stringify(foundCircular));
        //     //Still adding this, makes some formulas still work, dispite the circular calculation
        //     calcOrder.push(foundCircular);
        // }


        // context. add calcOrder
        window.PGridClientDebugMode >= 2 && console.debug(`MUX:Calculate_All_Formulas() update calcOrderCache: calcOrder.len = ${objTxtLen(calcOrder)}`);



        // source
        context.commit('Mutation_UpdatePGridSettings', { prop: 'calcOrderCache', val: calcOrder, source: `${source} -> Calculate_All_Cormulas()` });

    }


    try {
        window.PGridClientDebugMode >= 3 && console.debug("DEBUG: calcOrder: " + JSON.stringify(calcOrder));

        PGridTimerStart('calculatingCellsInCorrectOrder');

        for (let lvl = 0; lvl < calcOrder.length; lvl++) {
            const lvlTasks = calcOrder[lvl];

            let calcResults = null;
            try {
                // calcResults = await Promise.all(lvlTasks.map(async cellKey => Calculate_Cell(cellKey, pgridTableCopy)));
                calcResults = lvlTasks.map(cellKey => Calculate_Cell(cellKey, pgridTableCopy));
            }
            catch (err) {
                let errMsg = `> Promise.all(cellKey => Calculate_Cell() ${lvl} got exception ${err.message || err}`;
                console.warn(errMsg);
            }
            // debug && console.debug(`DEBUG: calcResults (lvl: ${lvl}) ${JSON.stringify(calcResults)}`);
            window.PGridClientDebugMode >= 4 && console.debug("DEBUG: calcResults: " + JSON.stringify(calcResults));

            //Pre update cells in table, for the final calculation of affected cells

            for (let a = 0; a < calcResults.length; a++) {
                let affCell = calcResults[a];

                if (affCell.updated) {
                    //Insert calculated values in temp table

                    cellsToUpdate.push(affCell);

                    let { hotValue, error } = Insert_Calculated_Cell(affCell, pgridTableCopy);
                }
            }

        }

        PGridTimerStop('calculatingCellsInCorrectOrder');

    } catch (err) {
        let errMsg = `> Calculate_All_Formulas() got exception: ${err.message || err}`;
        throw errMsg;
    }

    ret.cellsThatWasReferenced = cellsThatAreReferenced_Clone;
    ret.pgridTableCalculated = pgridTableCopy
    ret.cellsToUpdate = cellsToUpdate;

    return ret;
}

function Calculate_Cell_Error(cellKey, pgridTable, errorLabel) {
    let retCell = { value: null, y: null, x: null, updated: null, error: null, formula: null };

    try {

        let y = parseInt(cellKey.split(':')[0]);
        let x = parseInt(cellKey.split(':')[1]);

        retCell.y = y;
        retCell.x = x;
        retCell.value = errorLabel
        retCell.error = errorLabel;

    }
    catch (err) {
        let errMsg = `> Calculate_Cell_Error() got exception: ${err.message || err}`;
        console.error(errMsg);
    }

    return retCell
}

export function GetRefsFromFormula(inFormula, cellY, cellX) {

    let ret_refsKeys = [];

    if (!inFormula) {
        return ret_refsKeys;
    }

    if (!EnhancedParser) {
        throw new Error(`EnhancedParser is (false)`);
    }

    let eParseSrcCell = [{ index: cellY, dim: 'row' }, { index: cellX, dim: 'col' }];

    let getRng_eParser = "default" in EnhancedParser ? new EnhancedParser.default(eParseSrcCell) : new EnhancedParser(eParseSrcCell);


    let formulaToCalc = inFormula; //pgridTableCopy[cellY][cellX].Formula;


    //Remove any "="
    if (formulaToCalc != null && String(formulaToCalc).length > 0 && String(formulaToCalc)[0] === '=') {
        formulaToCalc = formulaToCalc.substr(1);
    }

    let refs = null
    try {



        getRng_eParser.on('reCallCellValue', (cell, done) => {
            const { label, row, column } = cell;
            let value = 1;
            done(value);
        });

        getRng_eParser.on('reCallRangeValue', (startCell, endCell, done) => {
            // value = 1000 * (row.index + 1) + 1 * (column.index + 1);
            // if (startCell.label === 'K9' && endCell.label === 'L11') {
            done([[1, 2]
                , [3, 4]]);
            // }
        });



        refs = getRng_eParser.getRefs(formulaToCalc);

    } catch (error) {
        console.warn("Got error in formula parsing:", error.message);
    }
    getRng_eParser = null;


    ret_refsKeys = Object.keys(refs);

    return ret_refsKeys
}

function Calculate_Cell(cellKey, pgridTable) {

    let retCell = { value: null, y: null, x: null, updated: null, error: null, formula: null };

    try {

        let y = parseInt(cellKey.split(':')[0]);
        let x = parseInt(cellKey.split(':')[1]);

        retCell.y = y;
        retCell.x = x;

        if (y == 3 && x == 7) {
            let foo = "Here it is";
        }

        if ((y < 0 || y + 1 > pgridTable.length)
            || (x < 0 || x + 1 > pgridTable[y].length > x)) {
            let errMsg = `> Calculate_Cell() illegal dimension reference y: ${y} x: ${x}`;
            throw new Error(errMsg);
        }

        let cellToCalc = pgridTable[y][x];


        if (cellToCalc != null && "Formula" in cellToCalc) {

            let formulaToCalc = cellToCalc.Formula;

            let oldValue = null;

            if (cellToCalc.Val != null) {
                oldValue = cellToCalc.Val;
            } else if (cellToCalc.ValStr != null) {
                oldValue = cellToCalc.ValStr;
            }


            //Has formula, calculate value

            let eParseSrcCell = [
                {
                    index: y,
                    dim: 'row'
                },
                {
                    index: x,
                    dim: 'col'
                }
            ];

            //Remove "=" in formula
            if (formulaToCalc != null && String(formulaToCalc).length > 0 && String(formulaToCalc)[0] === '=') {
                formulaToCalc = formulaToCalc.substr(1);
            }

            let retParse = null
            try {

                let eParser = "default" in EnhancedParser ? new EnhancedParser.default(eParseSrcCell) : new EnhancedParser(eParseSrcCell);

                eParser.on('reCallCellValue', (cell, done) => {
                    const { label, row, column } = cell;
                    let pGridCell = pgridTable[row.index][column.index];
                    // let parseValue = Get_Val_For_FormulaParser(pGridCell);
                    let parseValue = Get_Val_For_FormulaParser(pGridCell, `on.(reCallCellValue) srcCell: ${y}:${x} ---> ${row.index}:${column.index}`);
                    done(parseValue);
                });

                eParser.on('reCallRangeValue', (startCell, endCell, done) => {

                    //Handle formula ranges
                    let retRange = [[]];
                    const { label: start_label, row: start_row, column: start_column } = startCell;
                    const { label: end_label, row: end_row, column: end_column } = endCell;

                    expandIfNeeded(retRange, end_row.index - start_row.index, end_column.index - start_column.index, undefined);

                    let rangeY = 0
                    for (let irY = start_row.index; irY <= end_row.index; irY++) {
                        let rangeX = 0;
                        for (let irX = start_column.index; irX <= end_column.index; irX++) {

                            let pGridCell = pgridTable[irY][irX];
                            let parseValue = Get_Val_For_FormulaParser(pGridCell, `on.(reCallRangeValue) ${start_row.index}:${start_column.index}:${end_row.index}:${end_column.index} ---> ${irY}:${irX}`);
                            // let parseValue = Get_Val_For_FormulaParser(pGridCell);

                            if (parseValue === null || parseValue === undefined) {
                                parseValue = 0;
                            }

                            retRange[rangeY][rangeX] = parseValue;
                            rangeX++;
                        }
                        rangeY++;
                    }
                    done(retRange);
                });

                retCell.formula = formulaToCalc;

                retParse = eParser.parse(formulaToCalc);
                if (retParse.error !== null) {
                    // retCell.value = retParse.error;
                    retCell.error = retParse.error;
                    retCell.updated = true;
                } else if (retParse.result == null) {
                    retCell.error = "#NULL!" //value is null
                    retCell.updated = true;
                }
                else {

                    if (Array.isArray(retParse.result)) {
                        console.error(`This happended!!!!`)
                        let retNonArray = lodash.get(retParse, "result[0]", 0);

                        if (retNonArray !== oldValue) {
                            retCell.value = retNonArray;
                            retCell.updated = true;
                        }
                    }
                    else {
                        //Only update if value has changed
                        if (retParse.result !== oldValue) {
                            retCell.value = retParse.result;
                            retCell.updated = true;
                        }
                    }
                }
                eParser = null;
            } catch (error) {
                let errMsg = `> Got error in formula parsing formula (${formulaToCalc}) in cell y: ${y} x: ${x}: ${error.message}`;
                retCell.updated = true;
                retCell.error = `#ERROR! (4) ${errMsg})`
            }
        } else {
            retCell.updated = false;
        }

    }
    catch (err) {
        let errMsg = `> Caclculate_Cell() got exception: ${err.message || err}`;
        // console.error(errMsg);

        retCell.error = `#ERROR! (5) ${errMsg}`;
        retCell.updated = true;
        retCell.value = null;
    }

    //Returing retCell
    // console.debug("retCell: " + JSON.stringify(retCell));
    return retCell;
}

/*
*
*   Input: HOT data (or only changes) , pgrid table data, refType
*   Operation: Merge
*   Output: Pgrid table data
*
* Note, Handsontalbe escapes all \n, \r and \t
*/
export function Merge_HotTableToPgridTable(hotTable, changes, pgridTable, mType, source = "unknown-Merge_HotTableToPgridTable") {

    //Homogenize add new rows?
    let expandIfNeeded = function (pgridTable, newY, newX) {
        //Add extra rows
        if (pgridTable.length < (newY + 1)) {
            for (let yNewIter = 0; yNewIter < (newY + 1) - pgridTable.length; yNewIter++) {
                pgridTable.push(new Array(pgridTable[0].length).fill({}));  //Is Should this be undeined insted?
            }
        }

        //Add extra cols
        if (pgridTable[0].length < (newX + 1)) {
            for (let yNewIter = 0; yNewIter < pgridTable.length; yNewIter++) { //All rows
                pgridTable[yNewIter] = pgridTable[yNewIter].concat(Array((newX + 1) - pgridTable[yNewIter].length).fill({}));
            }
        }

        return pgridTable;
    }


    if (changes == null) {
        console.debug("Merge_HotTableToPgridTable() Warning slow section: changes is null");
    }


    if (changes != null && changes.length > 0) {  //Only use changes
        for (var k = 0; k < changes.length; k++) {

            let yMerge = changes[k][0]
            let xMerge = changes[k][1]
            let newValue = changes[k][3];

            pgridTable = expandIfNeeded(pgridTable, yMerge, xMerge);
            let newValueUnesc = newValue;

            pgridTable[yMerge][xMerge] = Get_PGridCell_Value(yMerge, xMerge, newValueUnesc, mType, pgridTable, source)
        }
    }
    else if (hotTable != null && hotTable.length > 0 && hotTable[0].length > 0) { //Update all

        pgridTable = expandIfNeeded(pgridTable, hotTable.length - 1, hotTable[0].length - 1);

        for (var y = 0; y < hotTable.length; y++) {
            for (var x = 0; x < hotTable[0].length; x++) {

                let newValueUnesc = hotTable[y][x];

                pgridTable[y][x] = Get_PGridCell_Value(y, x, newValueUnesc, mType, pgridTable, source);
            }
        }
    } else {
        throw `Merge_HotTableToPgridTable() (): no data to change`;
    }


    return pgridTable;
}



export function Compile_CellFromPanel(panel_cell) {

    console.debug(`Compile_CellFromPanel()`);

    var ret_cell = {};

    let new_cell_keys = Object.keys(panel_cell);

    for (let i = 0; i < new_cell_keys.length; i++) {

        let doAdd = true;

        console.debug(`Compile_CellFromPanel() i: ${i}`);

        let panel_cell_key = new_cell_keys[i];

        console.debug(`Compile_CellFromPanel() k_src: ${panel_cell_key}`);

        /*
        Cell_Val -> Val
        Cell_ValStr -> ValStr
        Cell_Format -> Format
        Cell_Formula -> Formula
        Cell_RefType -> RefType
        Cell_Meta -> Meta
        */
        let new_cell_key = panel_cell_key.replace("Cell_", "");


        let k_new_val = null;

        if (new_cell_key == "Meta") {
            k_new_val = JSON.parse(panel_cell[panel_cell_key]);
        } else {
            k_new_val = panel_cell[panel_cell_key];
        }

        if (k_new_val == null || k_new_val == "") {
            doAdd = false;
        }

        if (doAdd) {
            console.debug(`Setting property '${new_cell_key} with ${k_new_val}`);
            ret_cell[new_cell_key] = k_new_val;
        }
    }

    if (("Val" in ret_cell) && ("ValStr" in ret_cell)) {
        delete ret_cell.ValStr
    }


    if (Object.keys(ret_cell).length == 0) {
        ret_cell = null;
    }

    return ret_cell;
}

export function Merge_CellFromPanel(oldCell, mType, value) {

    if (oldCell === undefined) {
        oldCell = {};
    }

    var retCell = JSON.parse(JSON.stringify(oldCell));

    if (value == "") {
        delete retCell[mType]
    }

    if (mType == "Val") {
        delete retCell.ValStr
        retCell.Val = value;
    } else if (mType == "ValStr") {
        delete retCell.Val
        retCell.ValStr = value;
    } else if (mType == "Format") {
        retCell.Format = value;
    } else if (mType == "Formula") {
        retCell.Formula = value;
    } else if (mType == "RefType") {
        retCell.RefType = value;
    }

    return retCell;
}

/*

Input pgridData table and mType (default, default_raw, default_static, Format, Format, Formula, RefType, Json )

output pgridData

*/

export function Convert_PgridDataToHotTable(pgridData, mType, source) {

    let ret = { data: null, spanCells: null, errors: [] };


    let y = null, x = null;

    try {

        // console.log("Convert_PgridDataToHotTable() -> pgridTable:");
        // console.log(pgridTable);
        if (pgridData == null) {
            Error(`Convert_PgridDataToHotTable() pgridTable == null`);
        }

        // var ret = JSON.parse(JSON.stringify(pgridData));
        var retHotData = new Array();
        var retSpanCells = new Array();

        if (mType == null) {
            console.log("refType is null");
        }

        for (y = 0; y < pgridData.length; y++) {
            let emptyRowAdded = false;
            for (x = 0; x < pgridData[0].length; x++) {

                if (PGridVueStore.state.LowestRightNonHiddenCell && PGridVueStore.state.LowestRightOptimization
                    &&
                    (
                        y > PGridVueStore.state.LowestRightNonHiddenCell.y
                        ||
                        x > PGridVueStore.state.LowestRightNonHiddenCell.x
                    )
                ) {
                    //Skip if not in visible box
                } else {

                    let pcell = pgridData[y][x]


                    if (pcell && "Format" in pgridData[y][x]) {

                        let pCellFormat = pgridData[y][x].Format;

                        let pCellFormat_classes = pCellFormat.split(",");

                        for (let s = 0; s < pCellFormat_classes.length; s++) {
                            let pCell_Class = pCellFormat_classes[s];
                            if (pCell_Class.indexOf("pg-pre-span-") != -1) {
                                let [ignore0, ignore2, ignore3, spanDown, spanRight] = pCell_Class.split("-");
                                retSpanCells.push({ row: y, col: x, rowspan: Number(spanDown), colspan: Number(spanRight) });
                                // context.commit('Mutation_UpdateHOTSettings', { prop: 'spanCells', op: "push", val: spanCell, source: `${source} -> Action_PreProcessCellStyles` });
                            }
                        }
                    }



                    if (emptyRowAdded == false) {
                        retHotData.push(new Array());
                        emptyRowAdded = true;
                    }

                    retHotData[y].push(undefined);

                    let hotValue = undefined;
                    // let pcell = pgridData[y][x]

                    if (pcell == null) {
                        //Keep undefined hotValue = undefined
                    } else {



                        //Extract the apropiate value
                        hotValue = PGridCell.getHotValue2(pcell, mType);

                        //Set the value in the returning HOT table
                        retHotData[y][x] = hotValue;


                        // Extract SpanColumns, SpanRows and FreezeCol
                        if ("Meta" in pcell) {

                            let spanHorizontal = lodash.get(pcell, "Meta.SpanColumns", 0);
                            let spanVetical = lodash.get(pcell, "Meta.SpanRows", 0);

                            if (spanHorizontal != 0 || spanVetical != 0) {
                                retSpanCells.push({ row: y, col: x, rowspan: spanVetical + 1, colspan: spanHorizontal + 1 });

                            }
                        }

                    }
                }
            }
        }

        //Check if span overflows available rows, if true, add the rows
        for (let sp1 = 0; sp1 < retSpanCells.length; sp1++) {
            let spanCell = retSpanCells[sp1];

            let missingRows = (spanCell.row + spanCell.rowspan - 1) - retHotData.length;

            while (missingRows > 0) {
                missingRows--;
                let newRow = new Array();
                for (let c = 0; c < retHotData[0].length; c++) {
                    newRow.push(undefined);
                }
                retHotData.splice(spanCell.row, 0, newRow);
            }
        }

        //Add nulls in retHotData where span is about. This is important for correct sizeing of columns (is it because 'undefined' is longer than 'null' ??)

        if (window.PGridPerformanceMode) {
            for (let sp2 = 0; sp2 < retSpanCells.length; sp2++) {
                let spanCell = retSpanCells[sp2];
                for (let vert_spanStep = 0; vert_spanStep <= (spanCell.rowspan - 1); vert_spanStep++) {
                    for (let horiz_spanStep = 0; horiz_spanStep <= (spanCell.colspan - 1); horiz_spanStep++) {
                        if (vert_spanStep == 0 && horiz_spanStep == 0) {
                            //Don´t nullify origin span cell
                        } else {
                            PGridCell.expandHOTIfNeeded(retHotData, spanCell.row + vert_spanStep, retHotData[0].length - 1);
                            retHotData[spanCell.row + vert_spanStep][spanCell.col + horiz_spanStep] = null;
                        }
                    }
                }
            }
        }

        ret.data = retHotData;
        ret.spanCells = retSpanCells;
    }
    catch (err) {
        // console.error(`Convert_PgridDataToHotTable_error at cell y: x:  : " + Convert_PgridDataToHotTable_error \n`;
        let errMsg = `> Convert_PgridDataToHotTable() y: ${y} x: ${x} source: '${source}' got exception: ${err.message || err}`;
        console.error(errMsg);
        ret.errors.push(errMsg);
        throw errMsg;
    }

    return ret;
}



export function Convert_PGridRowsToPgridData(dataRows, kindsStr = "Val:ValStr:Format:Formula:RefType") {

    var pgridData = Array();

    var tblDimX = 0
    var tblDimY = 0

    try {

        //Determine the dimensions
        for (var i = 0; i < dataRows.Rows.length; i++) {
            var rowNum = dataRows.Rows[i].Row;
            var colNum = dataRows.Rows[i].Col;
            tblDimX = colNum > tblDimX ? colNum : tblDimX;
            tblDimY = rowNum > tblDimY ? rowNum : tblDimY;
        }

        //Nullify matrix
        for (var i = 0; i <= tblDimY; i++) {
            pgridData.push(new Array());
            for (var j = 0; j <= tblDimX; j++) {
                pgridData[i].push(undefined);
            }
        }

        //Fill with data
        for (var i = 0; i < dataRows.Rows.length; i++) {
            var rowData = dataRows.Rows[i];
            // if (rowData[kind] !== undefined) {


            var kinds = ('' + kindsStr).split(":");
            for (var k = 0; k < kinds.length; k++) {
                var kind = kinds[k];
                // if (pgridData[rowData.Row][rowData.Col] === undefined) {
                if (rowData[kind] !== undefined) {
                    if (pgridData[rowData.Row][rowData.Col] == undefined) {
                        pgridData[rowData.Row][rowData.Col] = {};
                    }
                    pgridData[rowData.Row][rowData.Col][kind] = rowData[kind];
                }
            }
        }
    } catch (err) {
        throw new Error(`Convert_PGridRowsToPgridData() got error: ${err.message || err}`);
    }

    return pgridData;
}

export function Convert_PgridDataToPGridRows(pgridData, isDynamic, state, kindsStr = "Val:ValStr:Format:Formula:RefType") {

    var retRowData = new Array();

    let onlyStaticSrc = isDynamic;


    for (var y = 0; y < pgridData.length; y++) {

        let pgridRow = [];

        for (var x = 0; x < pgridData.length; x++) {

            let addCell = true;

            var cell = { Row: y, Col: x };

            if (onlyStaticSrc) {

                let y_static = lodash.get(pgridData[y][x], "Meta.StaticSrc.y", null);
                let x_static = lodash.get(pgridData[y][x], "Meta.StaticSrc.x", null);
                let srcData_static = lodash.get(pgridData[y][x], "Meta.StaticSrc.Data", null);

                if (y_static == null || x_static == null) {
                    addCell = false;
                } else {
                    cell.Row = y_static;
                    cell.Col = x_static;
                }
            }

            if (addCell) {

                let kinds = kindsStr.split(":");


                if (pgridData[y][x] === undefined || pgridData[y][x] !== null) {

                    for (let i = 0; i < kinds.length; i++) {
                        let kind = kinds[i];
                        // kinds.forEach(kind => {

                        if (onlyStaticSrc) {

                            if (kind == "RefType") {
                                if (kind in pgridData[y][x]) {
                                    cell[kind] = pgridData[y][x][kind];
                                }
                            } else {
                                let cellTypeData = lodash.get(pgridData[y][x], `Meta.StaticSrc.Data[${kind}]`, undefined);
                                if (cellTypeData !== undefined) {
                                    cell[kind] = lodash.clone(pgridData[y][x].Meta.StaticSrc.Data[kind]);
                                }
                            }
                        } else {
                            if (kind in pgridData[y][x]) {
                                cell[kind] = pgridData[y][x][kind];
                            }
                        }
                        // });
                    }

                    pgridRow.push(cell);
                }
            }
        }

        if (pgridRow.length > 0) {
            retRowData.push(pgridRow);
        }

    }
    return retRowData;
}

function getLinkedRangeFromCordinates(pgridData, y, x) {
    var ret = null;
    ret = JSON.parse(pgridData[y][x].RefType);

    //Also add the position of th Linked Range
    ret.Meta = {
        yLR: pgridData[y][x].Meta.yLR,
        xLR: pgridData[y][x].Meta.xLR
    };
    return ret;
}


export function Parse_FormatField(inValue) {
    var ret = {};

    if (inValue != null) {

        if (inValue.length > 1) {
            if (inValue[0] === '{')// is probably a complex json, then parse
            {
                ret = JSON.parse(inValue);
            } else {
                ret.class = inValue;
            }
        }
    }
    return ret;
}


export function Parse_TrueFalseNull(inVal) {
    let ret = null;

    if (inVal === null) {
        ret = null;
    }
    else if (typeof inVal == "number") {
        if (inVal > 1) {
            ret = true;
        } else if (inVal == 0) {
            ret = false;
        } else {
            ret = null;
        }
    } else if (typeof inVal == "string") {
        if (inVal.toLowerCase() == "null") {
            ret = null
        } else if (inVal.toLowerCase() == "true") {
            ret = true
        } else {
            ret = false;
        }
    } else {
        window.PGridClientDebugMode >= 3 && console.warn(`Parse_TrueFalseNull() got unknown value and type`);
        ret = false;
    }
    return ret;
}


export function JustifyDataKey(dataKey) {
    dataKey.sort(dynamicSort("Name"));
    return dataKey;
}


export function JustifyDataKeyExcludeFields(inDataKey, excludeFields) {
    var outDataKey = JSON.parse(JSON.stringify(inDataKey))
    outDataKey.sort(dynamicSort("Name"));

    (excludeFields.split("§")).forEach(excludeFld => {
        outDataKey = outDataKey.filter(function (el) { return el.Name != excludeFld; });
    });

    return outDataKey;
}

export function JustifyDataKeyIncludeFields(inDataKey, includeFields) {

    // var outDataKey = JSON.parse(JSON.stringify(inDataKey))
    var outDataKey = JSON.parse(JSON.stringify(inDataKey))

    outDataKey.sort(dynamicSort("Name"));

    outDataKey = outDataKey.filter(function (el) {
        var found = false;
        (includeFields.split("§")).forEach(includeFld => {
            if (el.Name == includeFld) {
                found = true;
            }
        });
        return found;
    });

    return outDataKey;
}


export function CleanupFilterKey(dirtyFilterKey) {



    //Filter out dublicates
    let dirtyFilterKeyUnique = lodash.uniqBy(dirtyFilterKey, function (f) {
        return JSON.stringify(f);
    });

    if (dirtyFilterKey.length != dirtyFilterKeyUnique.length) {
        console.debug("Removed dublicate key value (HierId)");
    }

    let cleanedUp = dirtyFilterKey.sort(dynamicSort("Name"));

    cleanedUp = cleanedUp.map(x => {
        return { "Name": x.Name, "Val": x.Val };

    });

    return cleanedUp;
}

export function CleanupFilterKeyStr(dirtyFilterKeyStr) {

    let dirtyFilterKey = JSON.parse(dirtyFilterKeyStr);

    let cleanedUp = CleanupFilterKey(dirtyFilterKey);

    let cleanedUpStr = JSON.stringify(cleanedUp);

    return cleanedUpStr;
}


function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a, b) {
        /* next line works with strings and numbers,
         * and you may want to customize it to your needs
         */
        var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * sortOrder;
    }
}



function Extract_AccountTypeFromJWT(jwt) {
    var ret = "MICROSOFT_ACCOUNT";
    if (jwt && jwt.iss) {
        if (jwt.iss.indexOf("https://sts.windows.net/") != -1) {
            ret = "WORK_OR_SCHOOL_ACCOUNT";
        }
    }
}


export function Is_DynamicMode(state) {

    let ret = false;
    if (state.pgridSettings.viewMode === "Default") {
        ret = true;
    }

    return ret;
}

export function Get_DynamicMode_PGridDataKey(state) {

    let ret = null;
    if (Is_DynamicMode(state)) {
        ret = "pgridDataDynContent";
    } else {
        ret = "pgridData";
    }

    return ret;
}

export function Get_CurrentPGridData({ state, commit, source }) {

    let ret = null;

    if (Is_DynamicMode(state)) {
        /* Insert dimension data if in Default mode */

        if (state.pgridDataDynContent == null) {

            throw new Error("Get_CurrentPGridData cannot generate pgridDataDynContent only Get_CurrentPGridData_ASYNC can");
            if (state.pgridData == null) {
                console.debug('Get_CurrentPGridData(): pgridData == null');
                return;
            }
            if (state.pgridDim == null) {
                throw 'Get_CurrentPGridData(): pgridDim == null'
            }

            if (commit == null) {
                throw 'Get_CurrentPGridData(): state.pgridDataDynContent == null && commit == null'
            }


            // let pgridData = MaybieCopyObj(state.pgridData, 3); //FUB Is this neede? is cloned in Load_Phase2...
            // let pgridDim = MaybieCopyObj(state.pgridDim, 3);
            let pgridData = state.pgridData; //FUB Is this neede? is cloned in Load_Phase2...
            let pgridDim = state.pgridDim;


            // let [pgridDataDynContent, fixedRowsTop] = ...
            let pgridDataDynContent = PGridMatrices.Load_Phase2to4(pgridData, pgridDim, state, commit, `${source} -> Get_CurrentPGridData`)


            //Is this optimal, setting state data in a Get function? //FUB
            commit('Mutation_UpdateRoot', { prop: 'pgridDataDynContent', val: pgridDataDynContent, source: `${source} -> Get_CurrentPGridData` });
        }

        ret = state.pgridDataDynContent;
    } else {
        ret = state.pgridData;
    }

    return ret;
}

export async function Get_CurrentPGridData_ASYNC({ state, commit, source }) {

    let ret = null;

    if (Is_DynamicMode(state)) {
        /* Insert dimension data if in Default mode */

        if (state.pgridDataDynContent == null) {


            if (state.pgridData == null) {
                console.debug('Get_CurrentPGridData(): pgridData == null');
                return;
            }
            if (state.pgridDim == null) {
                throw 'Get_CurrentPGridData(): pgridDim == null'
            }

            if (commit == null) {
                throw 'Get_CurrentPGridData(): state.pgridDataDynContent == null && commit == null'
            }


            // let pgridData = MaybieCopyObj(state.pgridData, 3); //FUB Is this neede? is cloned in Load_Phase2...
            // let pgridDim = MaybieCopyObj(state.pgridDim, 3);
            let pgridData = state.pgridData; //FUB Is this neede? is cloned in Load_Phase2...
            let pgridDim = state.pgridDim;


            // let [pgridDataDynContent, fixedRowsTop] = ...
            let pgridDataDynContent = await PGridMatrices.Load_Phase2to4(pgridData, pgridDim, state, commit, `${source} -> Get_CurrentPGridData`)


            //Is this optimal, setting state data in a Get function? //FUB
            commit('Mutation_UpdateRoot', { prop: 'pgridDataDynContent', val: pgridDataDynContent, source: `${source} -> Get_CurrentPGridData` });
        }

        ret = state.pgridDataDynContent;
    } else {
        ret = state.pgridData;
    }

    return ret;
}

export function Get_HOTUncalcedDataAndSettings(context, {
    source = null,
    viewMode = null,
    pgridDataToUse = null
}) {

    false && console.debug(`Get_HOTUncalcedDataAndSettings() source: ${source}`);

    let pgridDataHT = null;
    let mType = null;
    try {

        if (viewMode == null) {
            viewMode = context.state.pgridSettings.viewMode;
        }

        mType = Translate_ViewModeToMergeType(viewMode);

        if (pgridDataToUse == null) {
            pgridDataToUse = Get_CurrentPGridData({ state: context.state, commit: context.commit, source: `${source} -> Get_HOTUncalcedDataAndSettings` });
        }

        pgridDataHT = Convert_PgridDataToHotTable(pgridDataToUse, mType, context.state.pgridSettings.viewMode, source);
    }
    catch (err) {
        let errMsg = `> Get_HOTUncalcedDataAndSettings() got exception: ${err.message || err} source: ${source}`;
        console.error(errMsg);
        throw errMsg;
    }

    return pgridDataHT;
}


export function Get_HotCellSelection(hot = null, selectedCells = null) {

    let ret = { isSelected: false, isMultipleCells: false, x: null, y: null, x2: null, y2: null };

    try {
        // let selectedCells = null;
        if (selectedCells === null) {
            try {
                if (hot != null) {
                    selectedCells = hot.getSelected();
                } else {
                    console.warn(`Get_HotCellSelection: hot == null`);
                }
            } catch {
                //May be normal, if no cell is selected
            }
        }

        if (selectedCells == null) {
            ret.isSelected = false;
        } else if (selectedCells[0][0] != selectedCells[0][2] || selectedCells[0][1] != selectedCells[0][3]) {
            ret.isSelected = true;
            ret.isMultipleCells = true;
            ret.x = selectedCells[0][1];
            ret.y = selectedCells[0][0];
            ret.x2 = selectedCells[0][2];
            ret.y2 = selectedCells[0][3];
        } else if (selectedCells[0][0] == selectedCells[0][2] && selectedCells[0][1] == selectedCells[0][3]) {
            ret.isSelected = true;
            ret.x = selectedCells[0][1];
            ret.y = selectedCells[0][0];
        }
    } catch (err) {
        console.warn("getSelectedCells(): Could not get selected cells");
    }

    return ret;
}



export function extractCellDataForPanel(store, propName) {
    var ret = null;

    var hot = null;
    var x = null, y = null;


    if (store.state.pgridSettings.DisableEvents || store.state.pgridSettings.DisableEventsSetDataAtCellNTimes) {
        return;
    }

    try {
        let pgridDataToUse = null;

        try {
            pgridDataToUse = Get_CurrentPGridData({ state: store.state, commit: store.commit, source: `extractCellDataForPanel(prop = '${propName}')` });
        } catch {
            // This throws when switching tabs, and can be ignored
        }

        if (pgridDataToUse !== null) {

            hot = store.state.hotRef;


            let selectedCells = Get_HotCellSelection(hot);

            if (selectedCells.isSelected /* != null && selectedCells[0][0] == selectedCells[0][2] && selectedCells[0][1] == selectedCells[0][3]*/) {
                x = selectedCells.x;
                y = selectedCells.y;

                if (pgridDataToUse) {

                    if (y < pgridDataToUse.length && x < pgridDataToUse[y].length) {
                        var cell = pgridDataToUse[y][x];
                        if (cell !== undefined && cell !== null)
                            if (propName in cell) {
                                ret = cell[propName];
                            }
                    }
                    else {
                        throw `could not lookup cell as table is to small for cell coordinates y: ${y} x: ${x}`
                    }
                }
            }
            return ret;
        } else {
            return null;
        }

        return ret;
    } catch (extractCellData_error) {
        console.warn("extractCellData_error: " + extractCellData_error);
        return null
    }
}

// returnd linked range name and
export function extractRefTypeFromCoord(y, x, context, source = "(source is unknon)") {
    let ret = { RefType: null, y: null, x: null };

    try {
        let pgridDataToUse = null;

        try {
            pgridDataToUse = Get_CurrentPGridData({ state: context.state, commit: context.commit, source: `${source} -> extractRelativLRNameAndAddressForPanel()` });
        } catch {
            // This throws when switching tabs, and can be ignored
        }


        let hints_Keys = Object.keys(context.state.pgridLRCoordinatesHints);

        for (let i = 0; ret.RefType == null && i < hints_Keys.length; i++) {

            let hint = context.state.pgridLRCoordinatesHints[hints_Keys[i]];

            false && console.debug("extractLRNFromCoord() examine hint")

            let examineCell = pgridDataToUse[hint.y][hint.x];

            let refTypeText = lodash.get(examineCell, "RefType", null)


            if (refTypeText != null && refTypeText != "") {

                let refType = JSON.parse(refTypeText);

                // "Load": {
                //     "DimSizeY": 195,
                //     "DimSizeX": 14,
                //     "HeadersSizeY": 2,
                //     "HeadersSizeX": 4

                let DimSizeY = lodash.get(examineCell, "Meta.Load.DimSizeY", -1);
                let DimSizeX = null; //lodash.get(examineCell, "Meta.Load.DimSizeX", -1);
                let HeadersSizeY = lodash.get(examineCell, "Meta.Load.HeadersSizeY", 0);
                let HeadersSizeX = null; //lodash.get(examineCell, "Meta.Load.HeadersSizeX", 0);

                let topY = hint.y - HeadersSizeY;
                let bottomY = hint.y + DimSizeY;
                let leftX = null;//hint.x - HeadersSizeX;
                let rightX = null; //hint.x + DimSizeX;


                if (y >= topY && y <= bottomY) {

                    DimSizeX = lodash.get(examineCell, "Meta.Load.DimSizeX", -1);
                    HeadersSizeX = lodash.get(examineCell, "Meta.Load.HeadersSizeX", 0);

                    leftX = hint.x - HeadersSizeX;
                    rightX = hint.x + DimSizeX;


                    if (x >= leftX && x <= rightX) {

                        ret.RefType = refType;
                        ret.y = hint.y;
                        ret.x = hint.x;

                    }
                }
            }
        }
    } catch (err) {
        console.warn(`extractLRNFromCoord got exception  ${err.message}`);
        // return null
    }

    return ret;
}


// returnd linked range name and
export function extractRelativLRNameAndAddressForPanel(y, x, context, source = "(source is unknon)") {
    let ret = { lrName: null, cellAddressR0C0: null, isInFactArea: false };

    try {
        let pgridTable = Get_CurrentPGridData({ state: context.state, commit: context.commit, source: `${source} -> extractRelativLRNameAndAddressForPanel()` });

        // let refTypeAndCoord = // extractRefTypeFromCoord(y, x, context, `${source} -> extractRelativLRNameAndAddressForPanel()`)
        let refTypeAndCoords = PGridMatrices.Get_LRsFromTable(pgridTable, { source: `pgridUtils.js extractRelativLRNameAndAddressForPanel()` });
        let refTypeAndCoords_Keys = Object.keys(refTypeAndCoords);
        for (let i = 0; i < refTypeAndCoords_Keys.length; i++) {
            let lrName = refTypeAndCoords_Keys[i];
            let refTypeAndCoord = refTypeAndCoords[lrName];
            if (refTypeAndCoord.y == y && refTypeAndCoord.x == x) {
                ret.lrName = lrName;
                // ret.cellAddressR0C0 = `R${y - refTypeAndCoord.y}C${x - refTypeAndCoord.x}`;
                ret.cellAddressR0C0 = "R" + (y - refTypeAndCoord.y) + "C" + (x - refTypeAndCoord.x);
            }
        }

        // if (refTypeAndCoord.RefType != null) {
        //     ret.lrName = refTypeAndCoord.RefType.LinkedRangeName;
        //     ret.cellAddressR0C0 = `R${y - refTypeAndCoord.y}C${x - refTypeAndCoord.x}`;
        // }

    } catch (extractRelativLRNameAndAddressForPanel_error) {
        console.warn(`extractRelativLRNameAndAddressForPanel got exception  ${extractRelativLRNameAndAddressForPanel_error.message}`);
        // return null
    }

    return ret;
}




export function saveCellDataForPanel(store, cell_props, cell_corrd, { source }) {

    console.debug(`saveCellDataForPanel()`);

    var hotRef = null;
    var x = null, y = null;
    try {
        hotRef = store.state.hotRef;

        x = cell_corrd.x;
        y = cell_corrd.y;

        //If only one cell is selected
        // if ( selectedCells != null
        //     && selectedCells[0][0] == selectedCells[0][2]
        //     && selectedCells[0][1] == selectedCells[0][3]) {
        //     x = selectedCells[0][1];
        //     y = selectedCells[0][0];

        let staticOrDynPgridData = Get_CurrentPGridData({ state: store.state, commit: store.commit, source: `saveCellDataForPanel(y: ${y}, x: ${x})` });

        if (staticOrDynPgridData) {

            const newRow = staticOrDynPgridData[y].slice(0);
            let old_cell = staticOrDynPgridData[y][x];
            let newCell = Compile_CellFromPanel(cell_props, { source: `{source} > saveCellDataForPanel()` });

            // newRow[x] = newCell;

            console.debug(`[[[ saveCellDataForPanel ]]]  y: ${y} y, x: ${x}, value: ${JSON.stringify(newCell).slice(0, 25)} source: ${source}`);

            staticOrDynPgridData[y][x] = newCell
        }
        return;
    } catch (err) {
        let errMsg = `> saveCellDataForPanel() x: ${x} y: ${y} got exception: ${err.message || err}`
        throw new Error(errMsg);
    }
}




export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}



export function applyRules(tmplOrIns, pgridAxis, keywordsDB, prevUsed, nodeData, lateRule = false, topColCell = null) {

    let useIt = false;
    let forceDontUseIt = false;

    const Rule = lateRule ? "LateRule" : "Rule";

    let Disabled = lodash.get(tmplOrIns, "Disabled", false);
    let If_Axis = lodash.get(tmplOrIns, Rule + ".If_Axis", "RowsAndColumns");
    let If_Level = String(lodash.get(tmplOrIns, Rule + ".If_Level", "any"));
    let If_Value_True = lodash.get(tmplOrIns, Rule + ".If_Value_True", null);
    let If_Value_NotNull = lodash.get(tmplOrIns, Rule + ".If_Value_NotNull", null);
    let If_All_Values_True = lodash.get(tmplOrIns, Rule + ".If_All_Values_True", null);
    let If_Any_Value_True = lodash.get(tmplOrIns, Rule + ".If_Any_Value_True", null);
    let If_IsGroup = lodash.get(tmplOrIns, Rule + ".If_IsGroup", null);
    let If_ColCell = lodash.get(tmplOrIns, Rule + ".If_ColCell", null);
    let If_Match_RegEx = lodash.get(tmplOrIns, Rule + ".If_Match.RegEx", null);
    let If_Match_Value = lodash.get(tmplOrIns, Rule + ".If_Match.Value", null);
    let If_Match_Inverse = lodash.get(tmplOrIns, Rule + ".If_Match.Inverse", false);
    let If_Not_Prev_Used = lodash.get(tmplOrIns, Rule + ".If_Not_Prev_Used", false);

    let name = lodash.get(tmplOrIns, "Name", "NoName");

    if (If_Not_Prev_Used) {
        if (prevUsed) {
            forceDontUseIt = true;
        } else {
            useIt = true;
        }
    }

    if (If_Axis.indexOf(pgridAxis.mapsTo) != -1) { //Filter out the axis type (including Facts)


        if (If_Value_True != null) {

            lodash.merge(keywordsDB, nodeData);
            let [If_Value_True_comp,] = applyKeywordsDb(keywordsDB, If_Value_True);

            if (IsNumeric(If_Value_True_comp) ? Number(If_Value_True_comp) > 0 : If_Value_True_comp == 'true') {
                useIt = true;
            } else {
                forceDontUseIt = true;
            }
        }

        if (If_Value_NotNull != null) {

            lodash.merge(keywordsDB, nodeData);
            let [If_Value_NotNull_comp,] = applyKeywordsDb(keywordsDB, If_Value_NotNull);

            if (If_Value_NotNull_comp != null && If_Value_NotNull_comp != "null") {
                useIt = true;
            } else {
                forceDontUseIt = true;
            }
        }



        if (If_All_Values_True != null) {

            let allIsTrue = true;

            lodash.merge(keywordsDB, nodeData);
            let [If_All_Values_True_comp,] = applyKeywordsDb(keywordsDB, If_All_Values_True);

            let If_All_Values_True_comp_Arr = If_All_Values_True_comp.split("§");  //Separator <----- '§'

            If_All_Values_True_comp_Arr.forEach(isValTru => {
                if (IsNumeric(isValTru) ? Number(isValTru) > 0 : isValTru == 'true') {
                    useIt = true;
                } else {
                    forceDontUseIt = true;
                    allIsTrue = false;
                }
            });

            if (allIsTrue == false) {
                useIt = false;
            }
        }

        if (If_Any_Value_True != null) {

            let someIsTrue = false;

            lodash.merge(keywordsDB, nodeData);
            let [If_Any_Value_True_comp,] = applyKeywordsDb(keywordsDB, If_Any_Value_True);

            let If_Any_Value_True_comp_Arr = If_Any_Value_True_comp.split("§");  //Separator <----- '§'

            If_Any_Value_True_comp_Arr.forEach(isValTru => {
                if (IsNumeric(isValTru) ? Number(isValTru) > 0 : isValTru == 'true') {
                    someIsTrue = true;
                }
            });

            if (someIsTrue) {
                useIt = true;
            } else {
                forceDontUseIt = true;
            }
        }


        if (If_IsGroup != null) {
            if (IsNumeric(nodeData.IsGroup) ? Number(nodeData.IsGroup) > 0 : nodeData.IsGroup == 'true') {
                useIt = true;
            } else {
                forceDontUseIt = true;
            }
        }




        if (If_Match_RegEx != null) {

            let wasMatch = null;

            lodash.merge(keywordsDB, nodeData);
            let [val,] = applyKeywordsDb(keywordsDB, If_Match_Value);
            let re = new RegExp(If_Match_RegEx);

            wasMatch = re.test(val);

            if (If_Match_Inverse) {
                wasMatch = !wasMatch;
            }

            if (wasMatch) {
                useIt = true;
            } else {
                forceDontUseIt = true;
            }
        }

        if (If_ColCell) {


            if ("Path" in If_ColCell) {

                let local_forceDontUseIt = forceDontUseIt;
                let local_useIt = useIt;

                let pathVal = lodash.get(topColCell, If_ColCell.Path, undefined);
                if (pathVal !== undefined) {
                    if ("Equals" in If_ColCell) {
                        if (pathVal == If_ColCell.Equals) {
                            local_useIt = true;
                        } else {
                            local_forceDontUseIt = true;
                        }
                    } else {
                        local_useIt = true;
                    }
                } else {
                    local_forceDontUseIt = true;
                }

                let inv = lodash.get(If_ColCell, "Inverse", false);

                if (inv) {
                    if (local_useIt) {
                        forceDontUseIt = true;
                    }
                    if (local_forceDontUseIt) {
                        useIt = true;
                    }
                } else {
                    useIt = local_useIt;
                    forceDontUseIt = local_forceDontUseIt;
                }

            }
        }

        if (If_Axis == "Facts") {

            useIt = true;


        } else { //X & Y axis


            if (If_Level == "any"

                || If_Level.split(",").indexOf(String(keywordsDB.CURRENT_LEVEL)) != -1

                || If_Level == "PrematureLeaf" && (
                    keywordsDB.REMAINING_LEVELS > 0
                    &&
                    keywordsDB.CHILDREN_COUNT == 0
                )
                || If_Level == "Leaf" && (
                    keywordsDB.REMAINING_LEVELS == 0
                    &&
                    keywordsDB.CHILDREN_COUNT == 0
                )

            ) {

                //OK to use template
                useIt = true;

            } else {
                forceDontUseIt = true;
            }


        }
    }


    if (forceDontUseIt || Disabled) {
        useIt = false;
    }

    let retPrevUsed = prevUsed;

    //Only update prevUsed if defined in tmplinsert
    if (If_Not_Prev_Used) {
        retPrevUsed = prevUsed || useIt
    }

    return [useIt, retPrevUsed];
}

export function genCellFromTempls(pgridLR, pgridTableDynCopy, nodeData, pgridAxis, keywordsDB) {

    let ret = { insertCellsFromTempl: null };

    let insertCellsFromTempl = [];

    let lrTempl = pgridLR.Templates;



    if (!lrTempl) {
        console.error("lrTempl is null!");
    }

    let lrFreeCellMap = null;
    if (pgridLR.type == "FreeCell") {
        lrFreeCellMap = pgridLR.FreeCellMap;
    }



    let prevUsedTmpl = false;
    let lrTempToApply = lrTempl.filter((templ) => {

        let [useTempl, prevUsedTmplIter] = applyRules(templ, pgridAxis, keywordsDB, prevUsedTmpl, nodeData);
        prevUsedTmpl = prevUsedTmplIter;

        return useTempl;
    }).sort((a, b) => {
        return a.Sort - b.Sort;
    });



    let lrTempToApply_length = lrTempToApply.length;

    if (window.PGridClientDebugMode >= 4) {
        console.debug(`FWE: genCellFromTempls: ${lrTempToApply_length}`);
    }

    for (let k = 0; k < lrTempToApply_length; k++) {
        let tmpl = lrTempToApply[k];
        // lrTempToApply.forEach(tmpl => {

        let templateName = lodash.get(tmpl, "Name", null);
        let templateDescription = lodash.get(tmpl, "Description", null);

        let prevUsedInsert = false;

        for (let i = 0; i < lodash.get(tmpl, "Insert.length", 0); i++) {

            let tmplInsert = lodash.get(tmpl, `Insert[${i}]`, {});

            // if (window.PGridClientDebugMode >= 4 && templateName == "Rad formel") {
            //     console.debug(`FWE: ${templateName} k: ${k} i: ${i}`);
            // }

            let [useInsert, prevUsedInsertIter] = applyRules(tmplInsert, pgridAxis, keywordsDB, prevUsedInsert, nodeData);
            prevUsedInsert = prevUsedInsertIter;

            if (useInsert) {

                let templateInsertName = lodash.get(tmplInsert, "Name", null);
                let templateInsertDescription = lodash.get(tmplInsert, "Description", null);


                let insert_cell = {}, y_offset = 0, x_offset = 0, mergeStrategies = null, InNewRow = false, shiftCellsDown = false, shiftCellsDownIfHasChildren = false, shiftCellsDownIfIsRemainingLevels = null;

                let LevelPosition = lodash.get(tmplInsert, "LevelPosition", "CurrentLevel");
                let KeepExisting = lodash.get(tmplInsert, "KeepExisting", false);

                let manualRepeat = lodash.get(tmplInsert, "Repeat", -1);
                let manualOffsetOffsetX = lodash.get(tmplInsert, "OffsetX", null);
                let manualOffsetOffsetY = lodash.get(tmplInsert, "OffsetY", null);


                // let manualOffsetOffsetX = lodash.get(itm, "AddressOffsetYOverrride", null);
                // let targetAddressOffsetXOverrride = lodash.get(itm, "AddressOffsetXOverrride", null);


                //FUB Put into general translate function?
                if (manualOffsetOffsetY != null) {
                    if (!IsNumeric(manualOffsetOffsetY)) {
                        manualOffsetOffsetY = JSON.parse(JSON.stringify(manualOffsetOffsetY).replaceAll('<<SAFE_OFFSET_DISTANCE_Y>>', keywordsDB.SAFE_OFFSET_DISTANCE_Y));

                        if (!IsNumeric(manualOffsetOffsetY)) {
                            throw new Error(`genCellFromTempls() got exception: Could not parse manualOffsetOffsetY number from: ${manualOffsetOffsetY}`);
                        }
                        manualOffsetOffsetY = Number(manualOffsetOffsetY);
                    }
                }
                else {
                    manualOffsetOffsetY = 0;
                }

                //FUB Put into general translate function?
                if (manualOffsetOffsetX != null) {
                    if (!IsNumeric(manualOffsetOffsetX)) {
                        manualOffsetOffsetX = JSON.parse(JSON.stringify(manualOffsetOffsetX).replaceAll('<<SAFE_OFFSET_DISTANCE_X>>', keywordsDB.SAFE_OFFSET_DISTANCE_Y));

                        if (!IsNumeric(manualOffsetOffsetX)) {
                            throw new Error(`genCellFromTempls() got exception: Could not parse manualOffsetOffsetX number from: ${manualOffsetOffsetX}`);
                        }
                        manualOffsetOffsetX = Number(manualOffsetOffsetX);
                    }
                } else {
                    manualOffsetOffsetX = 0;
                }

                InNewRow = lodash.get(tmplInsert, "InNewRow", false);
                shiftCellsDown = lodash.get(tmplInsert, "ShiftCellsDown", false);
                shiftCellsDownIfHasChildren = lodash.get(tmplInsert, "ShiftCellsDownIfHasChildren", false);
                shiftCellsDownIfIsRemainingLevels = lodash.get(tmplInsert, "ShiftCellsDownIsRemainingLevels", null);

                if (shiftCellsDownIfIsRemainingLevels) {
                    shiftCellsDown = shiftCellsDownIfIsRemainingLevels < keywordsDB.REMAINING_LEVELS;
                }

                let Merge = lodash.get(tmplInsert, "Merge", false);
                let MergeStrategies = lodash.get(tmplInsert, "MergeStrategies", []);

                //Will merge when put on grid

                if (Merge) {
                    mergeStrategies = MergeStrategies;
                } else {
                    mergeStrategies = null;
                }



                let repeat = 1


                if (LevelPosition.indexOf("FreeCellMap") != -1) {

                    if (!lrFreeCellMap) {
                        throw new Error("Missing FreeCellMap object");
                    }

                    if (nodeData.NODE_ID in lrFreeCellMap) {


                        if (LevelPosition == "FreeCellMapOneRight") {
                            x_offset = 1;
                        } else if (LevelPosition == "FreeCellMapOneLeft") {
                            x_offset = -1;
                        } else if (LevelPosition == "FreeCellMapOneUp") {
                            y_offset = -1;
                        } else if (LevelPosition == "FreeCellMapOneDown") {
                            y_offset = 1;
                        }


                        let exlStyleAddr = lrFreeCellMap[nodeData.NODE_ID];


                        let regEx = /R(-?\d+)?C(-?\d+)/;
                        let match = regEx.exec(exlStyleAddr);

                        if (match != null && match.length > 1) {
                            y_offset = y_offset + Number(match[1]);
                            x_offset = x_offset + Number(match[2]);
                        } else {

                            let cellCorrd = extractLabel(exlStyleAddr);

                            y_offset = y_offset + cellCorrd[0].index - pgridLR.y;
                            x_offset = x_offset + cellCorrd[1].index - pgridLR.x;
                        }

                    }

                } else if (LevelPosition == "LastLevel") {
                    if (pgridAxis.mapsTo == "Columns") {
                        y_offset = keywordsDB.REMAINING_LEVELS;
                    } else {
                        x_offset = keywordsDB.REMAINING_LEVELS;
                    }
                } else if (LevelPosition == "OneToRight") {
                    x_offset = 1;
                } else if (LevelPosition == "TwoToRight") {
                    x_offset = 2;
                } else if (LevelPosition == "OneToLeft") {
                    x_offset = -1;
                } else if (LevelPosition == "TwoToLeft") {
                    x_offset = -2;
                } else if (LevelPosition == "OneDown") {
                    y_offset = 1;
                } else if (LevelPosition == "OneUp") {
                    y_offset = -1;
                } else if (LevelPosition == "TwoUp") {
                    y_offset = -2;
                } else if (LevelPosition == "CurrentLevel") {
                    y_offset = 0;
                } else if (LevelPosition == "CurrentFact") {
                    y_offset = 0;
                } else if (LevelPosition == "ChildrenCountUp") {
                    y_offset = -keywordsDB.CHILDREN_COUNT;
                } else if (LevelPosition.indexOf("FactRows") != -1) {
                    y_offset = 0;
                    x_offset = keywordsDB.REMAINING_LEVELS;
                    repeat = keywordsDB.PIVOTFACT_WIDTH;

                    if (LevelPosition == "FactRowsOneUp") {
                        y_offset = -1;
                    } else if (LevelPosition.indexOf("FactRowsOnlyColNTimesX_") != -1) {
                        repeat = 1
                    }
                }


                //Overrides
                x_offset += manualOffsetOffsetX;
                y_offset += manualOffsetOffsetY;
                if (manualRepeat != -1) {
                    repeat = manualRepeat;
                }


                for (let r = 0; r < repeat; r++) {
                    let insert_cell_repeat = null;


                    if (LevelPosition.indexOf("FactRows") != -1) {
                        x_offset += 1;
                    }


                    let cellTmplJson = JSON.stringify(tmplInsert.CellTemplate);
                    let CellTemplateReplace = lodash.get(tmplInsert, "CellTemplateReplace", null);

                    let copyFromColumn = lodash.get(tmplInsert, "CopyFromColumn", null);


                    if (cellTmplJson != null) { //Only add cell template part if has CellTemplate definition
                        insert_cell_repeat = {};

                        let mergedKeywordDb = lodash.merge({}, nodeData, keywordsDB);

                        let keywordsApplied = null;
                        [cellTmplJson, keywordsApplied] = applyKeywordsDb(mergedKeywordDb, cellTmplJson)

                        //Only pares JSON if keyword was applied
                        let single_template_result = null;

                        if (keywordsApplied) {
                            single_template_result = JSON.parse(cellTmplJson);
                        } else {
                            if (tmplInsert.CellTemplate) {
                                single_template_result = tmplInsert.CellTemplate;
                            } else {
                                single_template_result = {};
                            }
                        }

                        if (KeepExisting) {

                            //Not sure if this is working!!
                            let customizerKeepExisting = function (objValue, srcValue) {
                                if (objValue) {
                                    return objValue;
                                }
                            }

                            insert_cell_repeat = lodash.mergeWith(insert_cell_repeat, single_template_result, customizerKeepExisting);
                        } else {
                            insert_cell_repeat = lodash.merge(insert_cell_repeat, single_template_result);
                        }

                        //Don't span cell or rows if span == 1
                        if (lodash.get(insert_cell_repeat, "Meta.SpanRows", Number.MAX_SAFE_INTEGER) < 1) {
                            delete insert_cell_repeat.Meta.SpanRows;
                        }
                        if (lodash.get(insert_cell_repeat, "Meta.SpanColumns", Number.MAX_SAFE_INTEGER) < 1) {
                            delete insert_cell_repeat.Meta.SpanColumns;
                        }


                    } else if (keywordsDB.OPPOSITE_AXIS == "Columns" && copyFromColumn != null) {
                        // insert_cell_repeat = {};

                        let fromCell = pgridTableDynCopy[pgridLR.y - 1][pgridLR.x + r];


                        let fromStuff = lodash.get(fromCell, `${copyFromColumn.From}`, null);
                        let fromCopy = JSON.parse(JSON.stringify(fromStuff));
                        let fromCopy2 = JSON.parse(JSON.stringify(fromStuff));
                        let toCopy = {};
                        lodash.set(toCopy, `${copyFromColumn.To}`, fromCopy);
                        // let insert_cell_repeat_foo = lodash.merge(insert_cell_repeat, toCopy);
                        lodash.set(toCopy, `Meta.CopyFromColumnAppliedWith`, fromCopy2); //To avoid multiple applies

                        //This avoid some special overwriting
                        let copyFromColumnMergeStrat = lodash.get(copyFromColumn, "MergeStrategies")

                        // let copyFromColumnMergeStrat = lodash.get(copyFromColumn, "MergeStrategies", ["CustomKeep:Meta.Validator.Type", "CustomKeep:Meta.Save.Writable"])
                        // let copyFromColumnMergeStrat = lodash.get(copyFromColumn, "MergeStrategies")

                        let insert_cell_repeat_foo = PGridCell.mergeCells(insert_cell_repeat, toCopy, copyFromColumnMergeStrat);

                        //Add Reference for cell template debugging (but seems to be overwritten later)
                        let refInsert = lodash.get(insert_cell_repeat_foo, "Meta.References", []);
                        refInsert.push("CopyFromColumn was applied"); //FUB Does not seems to be included after an mergeCells
                        lodash.set(insert_cell_repeat_foo, "Meta.References", refInsert);

                        let insert_cell_repeat_foo_copy = JSON.parse(JSON.stringify(insert_cell_repeat_foo));

                        insert_cell_repeat = insert_cell_repeat_foo_copy;

                    }


                    if (lodash.get(tmplInsert, "LateRule.If_ColCell", null)) {

                        let topColCell = pgridTableDynCopy[pgridLR.y - 1][pgridLR.x + r];

                        let [lateUseInsert,] = applyRules(tmplInsert, pgridAxis, keywordsDB, prevUsedInsert, nodeData, true, topColCell);

                        if (lateUseInsert == false) {
                            false && console.debug("Dismiss cell insert because of LateRule");
                            insert_cell_repeat = null;
                        }
                    }


                    if (insert_cell_repeat != null) {


                        if (CellTemplateReplace) {

                            let insert_cell_repeat_Text = JSON.stringify(insert_cell_repeat);
                            CellTemplateReplace.forEach(o => {

                                if ("ReplaceAll" in o) {
                                    insert_cell_repeat_Text = insert_cell_repeat_Text.replaceAll(o.ReplaceAll, o.Replacement);
                                }
                                else {
                                    let re = new RegExp(o.RegEx, (("Flags" in o) ? o.Flags : "g"));
                                    insert_cell_repeat_Text = insert_cell_repeat_Text.replace(re, o.Replacement);
                                }
                            });
                            insert_cell_repeat = JSON.parse(insert_cell_repeat_Text)
                        }


                        //Add Reference metadata for tracing changes in cells
                        let currentReferences = null;
                        let insertReferenseText = null;
                        if (templateInsertName || templateInsertDescription) {
                            insertReferenseText = ``;

                            if (templateInsertName && !templateInsertDescription) {
                                insertReferenseText += `${templateInsertName}`;
                            } else if (!templateInsertName && templateInsertDescription) {
                                insertReferenseText += `${templateInsertDescription}`;
                            }
                            else { //has both
                                insertReferenseText += `${templateInsertName}: ${templateInsertDescription}`;
                            }
                        }

                        // if (insertReferenseText) {
                        //     let currentReferences = lodash.get(pgridTableDynCopy[lrY + insertYOffsetFinal][lrX + insertXOffsetFinal], "Meta.References", []);
                        //     if (currentReferences.indexOf(insertReferenseText) == -1) {
                        //         currentReferences.push(insertReferenseText);
                        //     }
                        //     // lodash.set(insert_cell, "Meta.References", currentReferences);
                        // }


                        insertCellsFromTempl.push({ insert_cell: insert_cell_repeat, insertReference: insertReferenseText, y_offset, x_offset, mergeStrategies, InNewRow, templateName, templateDescription, shiftCellsDown })
                    }
                }
            }
        }
    }
    // });


    ret.insertCellsFromTempl = insertCellsFromTempl;

    // FUB Sanity cleanup of irrelevant cell spans

    return ret;
}



/* input
        lr, grid, level 0...x
 
 
*/
export async function spinningTreeNet(
    state
    , pgridLR
    , pgridTable_Recurse
    , currentAxis
    , pgridAxis
    , currLvlZ
    , startIdx
    , AppendVirtualRootNode
    , inOffsetY
    , inOffsetX
    , addedRowsTracking
    , shiftCellsDownOffset
    , shiftCellsDownOffset2
    , shiftRowsDownTracker
    , traceBackNodeData
    , addedRowsOffsetLR
) {

    let lrY = pgridLR.y;
    let lrX = pgridLR.x;

    if (lrY === undefined || lrY === null) {
        throw new Error(`Missing value for LrY`);
    }
    if (lrX === undefined || lrX === null) {
        throw new Error(`Missing value for LrX`);
    }

    let ret = {
        span: 1, span2: 0, childspans: null
        , usedMaxOffsetY: null, usedMaxOffsetX: null
        , usedMinOffsetY: null, usedMinOffsetX: null
        , addedRowsOffset: 0, shiftCellsDownOffset2: shiftCellsDownOffset2
    }; //span always at least 1

    let latest_shiftCellsDownOffset2 = null;

    // let childLvl = null;
    let currDimLvl = currentAxis[currLvlZ];

    let insertOffsetY = null;
    let insertOffsetX = null;

    let accSpanRec = 0;
    let accSpanRec2 = 0;
    let childspans = {}
    let accAddedRowsOffsetRec = 0;

    //Have children?

    let hasChildren = false;
    hasChildren = currentAxis.length > currLvlZ + 1


    //First get "node" data

    let nodeData = null;
    if (pgridAxis.mapsTo != "Facts") {
        nodeData = PGridCell.extractDimNodeData(pgridLR, currDimLvl, startIdx);
    }

    // let debug_pgridTable_Recurse_Before = null;
    // let debug_pgridTable_Recurse_After = null;


    let calculateSpanByFollowingChildren = function (currentAxis, currLvlZ, currIdx) {

        let ret_hasChildren = false;
        let ret_accChildSpan = 0;

        if (currentAxis.length - 1 == currLvlZ) {
            ret_accChildSpan = 1;
            return [ret_accChildSpan, ret_hasChildren];
        }


        let LookupIdx_ParentToMe = null;

        if ("LookupIdx_ParentToMe" in currentAxis[currLvlZ + 1]) {
            LookupIdx_ParentToMe = currentAxis[currLvlZ + 1].LookupIdx_ParentToMe;
        } else {
            ret_accChildSpan = 1;
            return [ret_accChildSpan, ret_hasChildren];
        }

        if (currIdx in LookupIdx_ParentToMe) {

            let myChildren = LookupIdx_ParentToMe[currIdx];


            hasChildren = myChildren.length > 0;

            for (let i = 0; i < myChildren.length; i++) {
                let childId = myChildren[i];

                ret_hasChildren = childId;


                let [resp_accChildSpan, resp_hasChildren] = calculateSpanByFollowingChildren(currentAxis, currLvlZ + 1, childId);
                ret_accChildSpan += resp_accChildSpan;

                if (resp_hasChildren /*currLvlZ == 0 && Object.keys(LookupIdx_ParentToMe).length == 1*/) {
                    //Add for the sum row if only one root node
                    ret_accChildSpan++;
                }

            }

            return [ret_accChildSpan, hasChildren];

        } else {
            ret_accChildSpan = 1;
            return [ret_accChildSpan, ret_hasChildren];
        }

        throw new Error(`Logic error, this state chould not be`)
    }


    let nodeDataClone = lodash.clone(nodeData);
    traceBackNodeData.push(nodeDataClone);


    if (hasChildren) { // Check that not last level (as then you can't have children)
        let childLvl = currentAxis[currLvlZ + 1];

        if (!childLvl.LookupIdx_ParentToMe) {
            throw new Error(`LookupIdx_ParentToMe was not found. Wrong Parent.SrcCol in dataset definition?`);
        }

        if (startIdx in childLvl.LookupIdx_ParentToMe) {
            //Yes have children
            hasChildren = true;


            let children = childLvl.LookupIdx_ParentToMe[startIdx];

            for (let childCount = 0; childCount < children.length; childCount++) {
                let childIdx = children[childCount];


                let nextOffsetY;
                let nextOffsetX;


                if (accSpanRec) {
                    traceBackNodeData.pop();
                }
                if (pgridAxis.type == "COLUMNS") {
                    nextOffsetY = inOffsetY;
                    nextOffsetX = inOffsetX + accSpanRec;

                }
                if (pgridAxis.type == "ROWS") {
                    nextOffsetY = inOffsetY + accSpanRec;

                    nextOffsetX = inOffsetX;

                }

                // if (window.PGridClientDebugMode >= 3) {
                //     debug_pgridTable_Recurse_Before = JSON.parse(JSON.stringify(pgridTable_Recurse));
                // }

                // if (lrY % 5 == 0) {
                // await sleep(10);
                // }

                // await sleep(10);
                let retSTN = await spinningTreeNet(
                    state
                    , pgridLR
                    , pgridTable_Recurse
                    , currentAxis
                    , pgridAxis
                    , currLvlZ + 1
                    , childIdx
                    , AppendVirtualRootNode
                    , nextOffsetY
                    , nextOffsetX
                    , addedRowsTracking
                    , shiftCellsDownOffset
                    , shiftCellsDownOffset2
                    , shiftRowsDownTracker
                    , traceBackNodeData
                    , addedRowsOffsetLR
                )


                // if (window.PGridClientDebugMode >= 3) {

                //     DebugDetectTableChanges(`spinningTreeNet()`, pgridTable_Recurse);
                // }

                if (window.PGridClientDebugMode >= 4) {
                    // debug_pgridTable_Recurse_After = JSON.parse(JSON.stringify(pgridTable_Recurse));
                    // DebugSomePGridTableChanges(debug_pgridTable_Recurse_Before, debug_pgridTable_Recurse_After);
                    DebugDetectTableChanges(`spinningTreeNet() start ${pgridLR.name}` /*, pgridTable_Recurse, pgridTable_Recurse_Before_Str */);
                }




                let cLvl = currLvlZ;

                accSpanRec += retSTN.span;
                accSpanRec2 += retSTN.span2;

                childspans[childCount] = retSTN.span;

                ret.usedMaxOffsetY = Math.max(nextOffsetY, retSTN.usedMaxOffsetY);
                ret.usedMaxOffsetX = Math.max(nextOffsetX, retSTN.usedMaxOffsetX);
                ret.usedMinOffsetY = Math.min(nextOffsetY, retSTN.usedMinOffsetY);
                ret.usedMinOffsetX = Math.min(nextOffsetX, retSTN.usedMinOffsetX);

                latest_shiftCellsDownOffset2 = retSTN.shiftCellsDownOffset2;

                accAddedRowsOffsetRec += retSTN.addedRowsOffset;

            }


            if (AppendVirtualRootNode /* && currLvlZ == 0 */) {

                //Special case for virtual root node

                let [retsp_accChildSpan, retsp_hasChildren] = calculateSpanByFollowingChildren(currentAxis, currLvlZ, startIdx);
                ret.span = retsp_accChildSpan;
            } else {

                //Normal
                if (accSpanRec > 0) {
                    ret.span = accSpanRec;
                }
            }

            if (accSpanRec2 > 0) {
                ret.span2 = accSpanRec2;
            }
        }
    }




    if (pgridAxis.type == "COLUMNS") {

        if (pgridLR.type == "FreeCell") {
            //Exception when FreeCell
            insertOffsetY = inOffsetY;
            insertOffsetX = 0 + inOffsetX;
        } else {
            insertOffsetY = inOffsetY - currentAxis.length + currLvlZ;
            insertOffsetX = 0 + inOffsetX;
        }
    } else if (pgridAxis.type == "ROWS") {
        insertOffsetY = inOffsetY;
        insertOffsetX = inOffsetX - currentAxis.length + currLvlZ;
    }
    else if (pgridAxis.type == "LOOKUPS") {
    }
    else {
        throw new Error(`Invalid axisType ${JSON.stringify(pgridAxis)}`);
    }


    //Now write to cell


    let lrTempl = pgridLR.Templates;
    let lrFreeCellMap = pgridLR.FreeCellMap;


    let keywordsDB = {};

    keywordsDB.CURRENT_AXIS = pgridAxis.mapsTo;
    keywordsDB.OPPOSITE_AXIS = pgridAxis.type == "COLUMNS" ? "Rows" : "Columns";
    keywordsDB.OPPOSITE_AXIS_PLUS_ONE = keywordsDB.OPPOSITE_AXIS + 1
    keywordsDB.CURRENT_LEVEL = (currLvlZ + 1);
    keywordsDB.TOTAL_LEVELS = currentAxis.length;
    keywordsDB.IS_LAST_LEVEL = currentAxis.length == (currLvlZ + 1);
    keywordsDB.REMAINING_LEVELS = currentAxis.length - (currLvlZ + 1);
    keywordsDB.REMAINING_LEVELS_PLUS_ONE = keywordsDB.REMAINING_LEVELS + 1
    keywordsDB.REMAINING_LEVELS_MINUS_ONE = keywordsDB.REMAINING_LEVELS - 1
    keywordsDB.REMAINING_LEVELS_PLUS_TWO = keywordsDB.REMAINING_LEVELS + 2
    keywordsDB.REMAINING_LEVELS_MINUS_TWO = keywordsDB.REMAINING_LEVELS - 2
    keywordsDB.CHILDREN_COUNT = (AppendVirtualRootNode && currLvlZ == 0 ? ret.span : accSpanRec);
    keywordsDB.CHILDREN_COUNT_MINUS_ONE = (AppendVirtualRootNode && currLvlZ == 0 ? ret.span - 1 : accSpanRec - 1);
    keywordsDB.DIMENSION_NAME = currDimLvl.Name;
    keywordsDB.PIVOTHIERARARCHY_NAME = pgridLR.linkedRange[`${pgridAxis.mapsTo}`].PivotHierarchy
    keywordsDB.LINKEDRANGE_NAME = pgridLR.name;
    keywordsDB.LINKEDRANGE_TYPE = pgridLR.type;
    keywordsDB.PIVOTFACT_WIDTH = pgridLR.xLength;
    keywordsDB.PGRID_CK = state.pgridVars.CustomerKey;
    keywordsDB.PGRID_TK = state.pgridVars.TabKey;
    keywordsDB.CHILD_SPANS = JSON.stringify(childspans).replace(/\{/g, "<").replace(/\}/g, ">").replace(/:/g, ">").replace(/\"/g, "'");
    keywordsDB.TRACEBACK_NODE_VALUES = traceBackNodeData.map((o, idx) => `lvl:${idx}¤value:${o.NODE_NAME}¤name:${o.NODE_NAME}`).join('§');
    keywordsDB.START_INDEX = startIdx;
    keywordsDB.IS_FIRST_INDEX = startIdx == 0;
    keywordsDB.SIBLINGS_COUNT = currDimLvl["DataSet"].length;
    keywordsDB.SIBLINGS_COUNT_PLUS_ONE = currDimLvl["DataSet"].length + 1;
    keywordsDB.SIBLINGS_COUNT_MINUS_ONE = currDimLvl["DataSet"].length - 1;

    keywordsDB.SAFE_OFFSET_DISTANCE_X = SumAllRowForAxis(pgridLR, "COLUMNS");
    keywordsDB.SAFE_OFFSET_DISTANCE_Y = SumAllRowForAxis(pgridLR, "ROWS");


    if (pgridAxis.mapsTo == "Rows") {

        false && console.debug(`pgridAxis: ${pgridAxis.mapsTo}, currLvlZ: ${currLvlZ}, startIdx: ${startIdx}, inOffsetYX: ${inOffsetY}:${inOffsetX}, keywordsDB.TRACEBACK_NODE_VALUES: ${keywordsDB.TRACEBACK_NODE_VALUES}`);
    }


    let vqsKV = QueryString_GetKeyValuePairs(state.pgridVars.VirtualQueryString);

    let vqsKV_Keys = Object.keys(vqsKV);
    for (let v = 0; v < vqsKV_Keys.length; v++) {
        let kvParir_Key_Key = vqsKV_Keys[v];
        let kvParir_Key = vqsKV[kvParir_Key_Key].key;
        let kvParir_Val = vqsKV[kvParir_Key_Key].val;
        // vqsKV.forEach(kvParir => {
        // keywordsDB[`VQS_${kvParir.key}`] = kvParir.val;
        keywordsDB[`VQS_${kvParir_Key}`] = kvParir_Val;
        // });
    }

    let theChildrensSumRows =
        // lodash.get(shiftCellsDownOffset, `[${keywordsDB.CURRENT_LEVEL}]`, 0)
        lodash.get(latest_shiftCellsDownOffset2, `[${keywordsDB.CURRENT_LEVEL + 1}]`, 0);



    // let addShiftCellsOffset = lodash.get(shiftCellsDownOffset, `[${currLvlZ}]`, 0);

    keywordsDB.CHILDREN2 = accSpanRec + accSpanRec2 - 1 /*+ theChildrensSumRows/* + lodash.get(shiftCellsDownOffset, `[${currLvlZ}]`, 0)*/;

    keywordsDB.CHILDREN2_MINUS_ONE = keywordsDB.CHILDREN2 - 1;

    let generateFormuSumChildren = function (childspans, refOffsetY = 1, refOffsetX = 0, extraOffsetY = 0  /*the actual sum row*/) {

        let ret = "="

        let nextRelRow = 0;

        let spanAcc = 0;

        let childspans_Keys = Object.keys(childspans);

        if (childspans_Keys.length == 0) {
            // console.warn(`childspans_Keys.length == 0, isn't that strage?`); //FUB
            ret += `R0C${refOffsetX}`;
        } else {


            let notAllChildspansAreOnes = childspans_Keys.find(o => childspans[o] != 1);

            if (keywordsDB.REMAINING_LEVELS == 1 && !notAllChildspansAreOnes && childspans_Keys.length > 1) {
                ret += `SUM(R${refOffsetY}C${refOffsetX}:R${refOffsetY + childspans_Keys.length - 1}C${refOffsetX})`;
            }
            else {
                for (let s = 0; s < childspans_Keys.length; s++) {



                    let isLast = s + 1 == childspans_Keys.length;
                    let myChildsSpan = childspans[childspans_Keys[s]];

                    // if (myChildsSpan != 1 || isLast) {
                    if (myChildsSpan == 0) {
                        console.warn(`myChildsSpan == 0, may be strage?`); //FUB
                    }
                    else if (myChildsSpan >= 1) {
                        ret += `R${refOffsetY + nextRelRow}C${refOffsetX}`
                        // nextRelRow += myChildsSpan + (AppendVirtualRootNode && currLvlZ == 0 ? refOffsetY : 0) + extraOffsetY;
                        //nextRelRow += myChildsSpan + (currLvlZ == 0 ? refOffsetY : 0) + extraOffsetY;
                        // nextRelRow += myChildsSpan + (AppendVirtualRootNode && currLvlZ == 0 ? 0 : refOffsetY) + extraOffsetY;
                        nextRelRow += myChildsSpan + (currLvlZ == 0 ? 0 : refOffsetY) + extraOffsetY;
                    }

                    if (!isLast) {
                        ret += "+"
                    }

                }
            }


        }

        ret += "";

        if (ret == "=R0C0") {
            false && console.debug("Avoiding reference to self (R0C0)");
            ret = "=0";
        }

        return ret;
    }


    keywordsDB.FORMULA_SUM_CHILDREN = generateFormuSumChildren(childspans, 1, 0);

    keywordsDB.FORMULA_SUM_CHILDREN_PLUS_ONE = generateFormuSumChildren(childspans, 1, 0, 1); //FUB Is this used?
    keywordsDB.FORMULA_SUM_CHILDREN_PLUS_ONE_OFFSET_SAFE_OFFSET_DISTANCE_Y = generateFormuSumChildren(childspans, keywordsDB.SAFE_OFFSET_DISTANCE_Y, 0, 1); //FUB Is this used?
    keywordsDB.FORMULA_SUM_CHILDREN_PLUS_ONE_OFFSET_SAFE_OFFSET_DISTANCE_X = generateFormuSumChildren(childspans, 0, keywordsDB.SAFE_OFFSET_DISTANCE_X, 1); //FUB Is this used?
    keywordsDB.FORMULA_SUM_CHILDREN_PLUS_ONE_Y_PLUS_TREE_OFFSET_SAFE_OFFSET_DISTANCE_X = generateFormuSumChildren(childspans, 3, keywordsDB.SAFE_OFFSET_DISTANCE_X, 1); //FUB Is this used?

    ////////////////////////////////
    ////       Insert cell
    ////////////////////////////////


    // if (nodeData) {
    //     if (JSON.stringify(nodeData).indexOf("Investering kvartalet") != -1) {
    //         console.log("Foooooooooooooobar");
    //     }
    // }

    let { insertCellsFromTempl } = genCellFromTempls(pgridLR, pgridTable_Recurse, nodeData, pgridAxis, keywordsDB);


    let myAddedRows = 0;

    for (let k = 0; k < insertCellsFromTempl.length; k++) {
        let insertCellAndOffset = insertCellsFromTempl[k];


        let { insert_cell, insertReference, y_offset, x_offset, mergeStrategies, InNewRow, templateName, templateDescription, shiftCellsDown } = insertCellAndOffset;

        let addShiftCellsOffset = lodash.get(shiftCellsDownOffset, `[${currLvlZ}]`, 0);

        let insertYOffsetFinal = insertOffsetY + y_offset + addedRowsOffsetLR + addShiftCellsOffset  /*accShiftCellsDownOffset/*+ ret.shiftCellsDownOffset*/;
        let insertXOffsetFinal = insertOffsetX + x_offset;

        // let rowSkippedAsHasNoChildren = false;

        window.PGridClientDebugMode >= 4 && console.debug("spinningTree(): " + JSON.stringify({ pgridAxis, name: pgridLR.name, insertYOffsetFinal, insertOffsetY, y_offset, addShiftCellsOffset }));

        if (templateName == "Default" && k == 0 && keywordsDB.CURRENT_AXIS == "Rows") {

            // if (keywordsDB.NODE_ISGROUP == 1 && keywordsDB.CHILDREN_COUNT == 0 && keywordsDB.IS_LAST_LEVEL == false) {
            //     console.debug("Skipping adding y group row that does not have any children");
            //     rowSkippedAsHasNoChildren = true;
            // }
            // else
            {

                let yRowKey = lrY + insertYOffsetFinal;

                if (!(yRowKey in shiftRowsDownTracker)) {


                    expandIfNeeded(pgridTable_Recurse, lrY + insertYOffsetFinal + 1, 0);

                    pgridTable_Recurse = PGridCell.insertRowAt(pgridTable_Recurse, lrY + insertYOffsetFinal + 1 /* + 1*/, undefined /*, JSON.stringify({ type: "shiftCellsDown", k, currLevel: keywordsDB.CURRENT_LEVEL, insertYFinal, insertXFinal, templateName })*/);

                    shiftRowsDownTracker[yRowKey] = true;
                }
            }
        }




        if (shiftCellsDown) {

            pgridTable_Recurse = PGridCell.insertRowAt(pgridTable_Recurse, lrY + insertYOffsetFinal/* + 1*/, undefined /*, JSON.stringify({ type: "shiftCellsDown", k, currLevel: keywordsDB.CURRENT_LEVEL, insertYFinal, insertXFinal, templateName })*/);

            if (insertYOffsetFinal == 0) {

                let moveTableProp = function (propName, copy = false, dstPropName = null) {

                    if (dstPropName == null) {
                        dstPropName = propName;
                    }

                    if (propName in pgridTable_Recurse[lrY + 1][lrX]) {
                        if (pgridTable_Recurse[lrY][lrX] === undefined) {
                            pgridTable_Recurse[lrY][lrX] = {};
                        }

                        if (copy) {
                            pgridTable_Recurse[lrY][lrX][dstPropName] = JSON.parse(JSON.stringify(pgridTable_Recurse[lrY + 1][lrX][propName]));
                        } else {
                            pgridTable_Recurse[lrY][lrX][dstPropName] = pgridTable_Recurse[lrY + 1][lrX][propName];
                        }

                        delete pgridTable_Recurse[lrY + 1][lrX][propName]
                    }
                }

                moveTableProp("RefType");
                moveTableProp("Meta");
            }

            let add2shiftCellsDownOffset = function (lvl) {
                if (!((lvl) in shiftCellsDownOffset)) {
                    shiftCellsDownOffset[lvl] = 0;
                }
                shiftCellsDownOffset[lvl] += 1;


                if (!((lvl) in shiftCellsDownOffset2)) {
                    shiftCellsDownOffset2[lvl] = 0;
                }
                shiftCellsDownOffset2[lvl] += 1;

            }

            for (let iLvl = currLvlZ; iLvl < currentAxis.length; iLvl++) {
                add2shiftCellsDownOffset(iLvl);
            }
            ret.span2 += 1


        }



        let pgridTable_Recurse_Before_Str = null;

        if (window.PGridClientDebugMode >= 4) {
            pgridTable_Recurse_Before_Str = JSON.parse(JSON.stringify(pgridTable_Recurse));
        }


        // if (rowSkippedAsHasNoChildren == false) {

        //     if (window.PGridClientDebugMode >= 2) {
        //         console.debug(`Skipping adding skipped cell`);
        //     }
        // }
        {
            PGridCell.expandIfNeeded(pgridTable_Recurse, lrY + insertYOffsetFinal, lrX + insertXOffsetFinal, undefined);


            // ret.maxY = Math.max(ret.maxY, insertYFinal);
            // ret.maxX = Math.max(ret.maxX, insertXFinal);

            ret.usedMaxOffsetY = Math.max(ret.usedMaxOffsetY, insertYOffsetFinal);
            ret.usedMaxOffsetX = Math.max(ret.usedMaxOffsetX, insertXOffsetFinal);
            ret.usedMinOffsetY = Math.min(ret.usedMinOffsetY, insertYOffsetFinal);
            ret.usedMinOffsetX = Math.min(ret.usedMinOffsetX, insertXOffsetFinal);


            if (mergeStrategies != null) {
                insert_cell = PGridCell.mergeCells(pgridTable_Recurse[lrY + insertYOffsetFinal][lrX + insertXOffsetFinal], insert_cell, mergeStrategies);
            }


            //Add Reference metadata for tracing changes in cells
            let insertReferenseText = null;

            if (window.PGridClientDebugMode >= 3) {
                insertReferenseText = `spinningTreeNet(${lodash.get(window, "PGridDTC.CallCount", -1)}): `;
            } else {
                insertReferenseText = ``;
            }

            if (templateName || templateDescription) {
                // insertReferenseText = ``;

                if (templateName && !templateDescription) {
                    insertReferenseText += `${templateName}`;
                } else if (!templateName && templateDescription) {
                    insertReferenseText += `${templateDescription}`;
                }
                else { //has both
                    insertReferenseText += `${templateName}: ${templateDescription}`;
                }
            }


            if (insertReference) {
                insertReferenseText += ` > ${insertReference}`;
            }

            if (insertReferenseText != '') {

                let currentReferences = lodash.get(pgridTable_Recurse[lrY + insertYOffsetFinal][lrX + insertXOffsetFinal], "Meta.References", []);

                if (currentReferences.indexOf(insertReferenseText) == -1) {
                    currentReferences.push(insertReferenseText);
                }
                lodash.set(insert_cell, "Meta.References", currentReferences);
            }



            // let currentReferences2 = lodash.get(pgridTable_Recurse[lrY + insertYOffsetFinal][lrX + insertXOffsetFinal], "Meta.References", []);

            // if (currentReferences2.indexOf('spinningTreeNet(2773): Copy col to rows: Copy col meta (for Validation and savable) to all rows') != -1) {
            //     console.warn(`Found spinningTreeNet(2773)`);
            // }

            pgridTable_Recurse[lrY + insertYOffsetFinal][lrX + insertXOffsetFinal] = insert_cell;
        }



        if (window.PGridClientDebugMode >= 4) {
            // debug_pgridTable_Recurse_After = JSON.parse(JSON.stringify(pgridTable_Recurse));
            // DebugSomePGridTableChanges(debug_pgridTable_Recurse_Before, debug_pgridTable_Recurse_After);
            DebugDetectTableChanges(`spinningTreeNet() insert_cell ${templateName}`, pgridTable_Recurse, pgridTable_Recurse_Before_Str);
        }

    }

    ret.addedRowsOffset = accAddedRowsOffsetRec;

    return ret;
}





export function spinningTreeNetSYNC(
    state
    , pgridLR
    , pgridTable_Recurse
    , currentAxis
    , pgridAxis
    , currLvlZ
    , startIdx
    , AppendVirtualRootNode
    , inOffsetY
    , inOffsetX
    , addedRowsTracking
    , shiftCellsDownOffset
    , shiftCellsDownOffset2
    , shiftRowsDownTracker
    , traceBackNodeData
    , addedRowsOffsetLR
) {

    let lrY = pgridLR.y;
    let lrX = pgridLR.x;

    if (lrY === undefined || lrY === null) {
        throw new Error(`Missing value for LrY`);
    }
    if (lrX === undefined || lrX === null) {
        throw new Error(`Missing value for LrX`);
    }

    let ret = {
        span: 1, span2: 0, childspans: null
        , usedMaxOffsetY: null, usedMaxOffsetX: null
        , usedMinOffsetY: null, usedMinOffsetX: null
        , addedRowsOffset: 0, shiftCellsDownOffset2: shiftCellsDownOffset2
    }; //span always at least 1

    let latest_shiftCellsDownOffset2 = null;

    // let childLvl = null;
    let currDimLvl = currentAxis[currLvlZ];

    let insertOffsetY = null;
    let insertOffsetX = null;

    let accSpanRec = 0;
    let accSpanRec2 = 0;
    let childspans = {}
    let accAddedRowsOffsetRec = 0;

    //Have children?

    let hasChildren = false;
    hasChildren = currentAxis.length > currLvlZ + 1


    //First get "node" data

    let nodeData = null;
    if (pgridAxis.mapsTo != "Facts") {
        nodeData = PGridCell.extractDimNodeData(pgridLR, currDimLvl, startIdx);
    }

    // let debug_pgridTable_Recurse_Before = null;
    // let debug_pgridTable_Recurse_After = null;


    let calculateSpanByFollowingChildren = function (currentAxis, currLvlZ, currIdx) {

        let ret_hasChildren = false;
        let ret_accChildSpan = 0;

        if (currentAxis.length - 1 == currLvlZ) {
            ret_accChildSpan = 1;
            return [ret_accChildSpan, ret_hasChildren];
        }


        let LookupIdx_ParentToMe = null;

        if ("LookupIdx_ParentToMe" in currentAxis[currLvlZ + 1]) {
            LookupIdx_ParentToMe = currentAxis[currLvlZ + 1].LookupIdx_ParentToMe;
        } else {
            ret_accChildSpan = 1;
            return [ret_accChildSpan, ret_hasChildren];
        }

        if (currIdx in LookupIdx_ParentToMe) {

            let myChildren = LookupIdx_ParentToMe[currIdx];


            hasChildren = myChildren.length > 0;

            for (let i = 0; i < myChildren.length; i++) {
                let childId = myChildren[i];

                ret_hasChildren = childId;


                let [resp_accChildSpan, resp_hasChildren] = calculateSpanByFollowingChildren(currentAxis, currLvlZ + 1, childId);
                ret_accChildSpan += resp_accChildSpan;

                if (resp_hasChildren /*currLvlZ == 0 && Object.keys(LookupIdx_ParentToMe).length == 1*/) {
                    //Add for the sum row if only one root node
                    ret_accChildSpan++;
                }

            }

            return [ret_accChildSpan, hasChildren];

        } else {
            ret_accChildSpan = 1;
            return [ret_accChildSpan, ret_hasChildren];
        }

        throw new Error(`Logic error, this state chould not be`)
    }


    let nodeDataClone = lodash.clone(nodeData);
    traceBackNodeData.push(nodeDataClone);


    if (hasChildren) { // Check that not last level (as then you can't have children)
        let childLvl = currentAxis[currLvlZ + 1];

        if (!childLvl.LookupIdx_ParentToMe) {
            throw new Error(`LookupIdx_ParentToMe was not found. Wrong Parent.SrcCol in dataset definition?`);
        }

        if (startIdx in childLvl.LookupIdx_ParentToMe) {
            //Yes have children
            hasChildren = true;


            let children = childLvl.LookupIdx_ParentToMe[startIdx];

            for (let childCount = 0; childCount < children.length; childCount++) {
                let childIdx = children[childCount];


                let nextOffsetY;
                let nextOffsetX;


                if (accSpanRec) {
                    traceBackNodeData.pop();
                }
                if (pgridAxis.type == "COLUMNS") {
                    nextOffsetY = inOffsetY;
                    nextOffsetX = inOffsetX + accSpanRec;

                }
                if (pgridAxis.type == "ROWS") {
                    nextOffsetY = inOffsetY + accSpanRec;

                    nextOffsetX = inOffsetX;

                }

                // if (window.PGridClientDebugMode >= 3) {
                //     debug_pgridTable_Recurse_Before = JSON.parse(JSON.stringify(pgridTable_Recurse));
                // }

                // if (lrY % 5 == 0) {
                // await sleep(10);
                // }

                let retSTN = spinningTreeNetSYNC(
                    state
                    , pgridLR
                    , pgridTable_Recurse
                    , currentAxis
                    , pgridAxis
                    , currLvlZ + 1
                    , childIdx
                    , AppendVirtualRootNode
                    , nextOffsetY
                    , nextOffsetX
                    , addedRowsTracking
                    , shiftCellsDownOffset
                    , shiftCellsDownOffset2
                    , shiftRowsDownTracker
                    , traceBackNodeData
                    , addedRowsOffsetLR
                )


                // if (window.PGridClientDebugMode >= 3) {

                //     DebugDetectTableChanges(`spinningTreeNet()`, pgridTable_Recurse);
                // }

                if (window.PGridClientDebugMode >= 4) {
                    // debug_pgridTable_Recurse_After = JSON.parse(JSON.stringify(pgridTable_Recurse));
                    // DebugSomePGridTableChanges(debug_pgridTable_Recurse_Before, debug_pgridTable_Recurse_After);
                    DebugDetectTableChanges(`spinningTreeNetSYNC() start ${pgridLR.name}` /*, pgridTable_Recurse, pgridTable_Recurse_Before_Str */);
                }




                let cLvl = currLvlZ;

                accSpanRec += retSTN.span;
                accSpanRec2 += retSTN.span2;

                childspans[childCount] = retSTN.span;

                ret.usedMaxOffsetY = Math.max(nextOffsetY, retSTN.usedMaxOffsetY);
                ret.usedMaxOffsetX = Math.max(nextOffsetX, retSTN.usedMaxOffsetX);
                ret.usedMinOffsetY = Math.min(nextOffsetY, retSTN.usedMinOffsetY);
                ret.usedMinOffsetX = Math.min(nextOffsetX, retSTN.usedMinOffsetX);

                latest_shiftCellsDownOffset2 = retSTN.shiftCellsDownOffset2;

                accAddedRowsOffsetRec += retSTN.addedRowsOffset;

            }


            if (AppendVirtualRootNode /* && currLvlZ == 0 */) {

                //Special case for virtual root node

                let [retsp_accChildSpan, retsp_hasChildren] = calculateSpanByFollowingChildren(currentAxis, currLvlZ, startIdx);
                ret.span = retsp_accChildSpan;
            } else {

                //Normal
                if (accSpanRec > 0) {
                    ret.span = accSpanRec;
                }
            }

            if (accSpanRec2 > 0) {
                ret.span2 = accSpanRec2;
            }
        }
    }




    if (pgridAxis.type == "COLUMNS") {

        if (pgridLR.type == "FreeCell") {
            //Exception when FreeCell
            insertOffsetY = inOffsetY;
            insertOffsetX = 0 + inOffsetX;
        } else {
            insertOffsetY = inOffsetY - currentAxis.length + currLvlZ;
            insertOffsetX = 0 + inOffsetX;
        }
    } else if (pgridAxis.type == "ROWS") {
        insertOffsetY = inOffsetY;
        insertOffsetX = inOffsetX - currentAxis.length + currLvlZ;
    }
    else if (pgridAxis.type == "LOOKUPS") {
    }
    else {
        throw new Error(`Invalid axisType ${JSON.stringify(pgridAxis)}`);
    }


    //Now write to cell


    let lrTempl = pgridLR.Templates;
    let lrFreeCellMap = pgridLR.FreeCellMap;


    let keywordsDB = {};

    keywordsDB.CURRENT_AXIS = pgridAxis.mapsTo;
    keywordsDB.OPPOSITE_AXIS = pgridAxis.type == "COLUMNS" ? "Rows" : "Columns";
    keywordsDB.OPPOSITE_AXIS_PLUS_ONE = keywordsDB.OPPOSITE_AXIS + 1
    keywordsDB.CURRENT_LEVEL = (currLvlZ + 1);
    keywordsDB.TOTAL_LEVELS = currentAxis.length;
    keywordsDB.IS_LAST_LEVEL = currentAxis.length == (currLvlZ + 1);
    keywordsDB.REMAINING_LEVELS = currentAxis.length - (currLvlZ + 1);
    keywordsDB.REMAINING_LEVELS_PLUS_ONE = keywordsDB.REMAINING_LEVELS + 1
    keywordsDB.REMAINING_LEVELS_MINUS_ONE = keywordsDB.REMAINING_LEVELS - 1
    keywordsDB.REMAINING_LEVELS_PLUS_TWO = keywordsDB.REMAINING_LEVELS + 2
    keywordsDB.REMAINING_LEVELS_MINUS_TWO = keywordsDB.REMAINING_LEVELS - 2
    keywordsDB.CHILDREN_COUNT = (AppendVirtualRootNode && currLvlZ == 0 ? ret.span : accSpanRec);
    keywordsDB.CHILDREN_COUNT_MINUS_ONE = (AppendVirtualRootNode && currLvlZ == 0 ? ret.span - 1 : accSpanRec - 1);
    keywordsDB.DIMENSION_NAME = currDimLvl.Name;
    keywordsDB.PIVOTHIERARARCHY_NAME = pgridLR.linkedRange[`${pgridAxis.mapsTo}`].PivotHierarchy
    keywordsDB.LINKEDRANGE_NAME = pgridLR.name;
    keywordsDB.LINKEDRANGE_TYPE = pgridLR.type;
    keywordsDB.PIVOTFACT_WIDTH = pgridLR.xLength;
    keywordsDB.PGRID_CK = state.pgridVars.CustomerKey;
    keywordsDB.PGRID_TK = state.pgridVars.TabKey;
    keywordsDB.CHILD_SPANS = JSON.stringify(childspans).replace(/\{/g, "<").replace(/\}/g, ">").replace(/:/g, ">").replace(/\"/g, "'");
    keywordsDB.TRACEBACK_NODE_VALUES = traceBackNodeData.map((o, idx) => `lvl:${idx}¤value:${o.NODE_NAME}¤name:${o.NODE_NAME}`).join('§');
    keywordsDB.START_INDEX = startIdx;
    keywordsDB.IS_FIRST_INDEX = startIdx == 0;
    keywordsDB.SIBLINGS_COUNT = currDimLvl["DataSet"].length;
    keywordsDB.SIBLINGS_COUNT_PLUS_ONE = currDimLvl["DataSet"].length + 1;
    keywordsDB.SIBLINGS_COUNT_MINUS_ONE = currDimLvl["DataSet"].length - 1;

    keywordsDB.SAFE_OFFSET_DISTANCE_X = SumAllRowForAxis(pgridLR, "COLUMNS");
    keywordsDB.SAFE_OFFSET_DISTANCE_Y = SumAllRowForAxis(pgridLR, "ROWS");


    if (pgridAxis.mapsTo == "Rows") {

        false && console.debug(`pgridAxis: ${pgridAxis.mapsTo}, currLvlZ: ${currLvlZ}, startIdx: ${startIdx}, inOffsetYX: ${inOffsetY}:${inOffsetX}, keywordsDB.TRACEBACK_NODE_VALUES: ${keywordsDB.TRACEBACK_NODE_VALUES}`);
    }


    let vqsKV = QueryString_GetKeyValuePairs(state.pgridVars.VirtualQueryString);

    let vqsKV_Keys = Object.keys(vqsKV);
    for (let v = 0; v < vqsKV_Keys.length; v++) {
        let kvParir_Key_Key = vqsKV_Keys[v];
        let kvParir_Key = vqsKV[kvParir_Key_Key].key;
        let kvParir_Val = vqsKV[kvParir_Key_Key].val;
        // vqsKV.forEach(kvParir => {
        // keywordsDB[`VQS_${kvParir.key}`] = kvParir.val;
        keywordsDB[`VQS_${kvParir_Key}`] = kvParir_Val;
        // });
    }

    let theChildrensSumRows =
        // lodash.get(shiftCellsDownOffset, `[${keywordsDB.CURRENT_LEVEL}]`, 0)
        lodash.get(latest_shiftCellsDownOffset2, `[${keywordsDB.CURRENT_LEVEL + 1}]`, 0);



    // let addShiftCellsOffset = lodash.get(shiftCellsDownOffset, `[${currLvlZ}]`, 0);

    keywordsDB.CHILDREN2 = accSpanRec + accSpanRec2 - 1 /*+ theChildrensSumRows/* + lodash.get(shiftCellsDownOffset, `[${currLvlZ}]`, 0)*/;

    keywordsDB.CHILDREN2_MINUS_ONE = keywordsDB.CHILDREN2 - 1;

    let generateFormuSumChildren = function (childspans, refOffsetY = 1, refOffsetX = 0, extraOffsetY = 0  /*the actual sum row*/) {

        let ret = "="

        let nextRelRow = 0;

        let spanAcc = 0;

        let childspans_Keys = Object.keys(childspans);

        if (childspans_Keys.length == 0) {
            // console.warn(`childspans_Keys.length == 0, isn't that strage?`); //FUB
            ret += `R0C${refOffsetX}`;
        } else {


            let notAllChildspansAreOnes = childspans_Keys.find(o => childspans[o] != 1);

            if (keywordsDB.REMAINING_LEVELS == 1 && !notAllChildspansAreOnes && childspans_Keys.length > 1) {
                ret += `SUM(R${refOffsetY}C${refOffsetX}:R${refOffsetY + childspans_Keys.length - 1}C${refOffsetX})`;
            }
            else {
                for (let s = 0; s < childspans_Keys.length; s++) {



                    let isLast = s + 1 == childspans_Keys.length;
                    let myChildsSpan = childspans[childspans_Keys[s]];

                    // if (myChildsSpan != 1 || isLast) {
                    if (myChildsSpan == 0) {
                        console.warn(`myChildsSpan == 0, may be strage?`); //FUB
                    }
                    else if (myChildsSpan >= 1) {
                        ret += `R${refOffsetY + nextRelRow}C${refOffsetX}`
                        // nextRelRow += myChildsSpan + (AppendVirtualRootNode && currLvlZ == 0 ? refOffsetY : 0) + extraOffsetY;
                        //nextRelRow += myChildsSpan + (currLvlZ == 0 ? refOffsetY : 0) + extraOffsetY;
                        // nextRelRow += myChildsSpan + (AppendVirtualRootNode && currLvlZ == 0 ? 0 : refOffsetY) + extraOffsetY;
                        nextRelRow += myChildsSpan + (currLvlZ == 0 ? 0 : refOffsetY) + extraOffsetY;
                    }

                    if (!isLast) {
                        ret += "+"
                    }

                }
            }


        }

        ret += "";

        if (ret == "=R0C0") {
            false && console.debug("Avoiding reference to self (R0C0)");
            ret = "=0";
        }

        return ret;
    }


    keywordsDB.FORMULA_SUM_CHILDREN = generateFormuSumChildren(childspans, 1, 0);

    keywordsDB.FORMULA_SUM_CHILDREN_PLUS_ONE = generateFormuSumChildren(childspans, 1, 0, 1); //FUB Is this used?
    keywordsDB.FORMULA_SUM_CHILDREN_PLUS_ONE_OFFSET_SAFE_OFFSET_DISTANCE_Y = generateFormuSumChildren(childspans, keywordsDB.SAFE_OFFSET_DISTANCE_Y, 0, 1); //FUB Is this used?
    keywordsDB.FORMULA_SUM_CHILDREN_PLUS_ONE_OFFSET_SAFE_OFFSET_DISTANCE_X = generateFormuSumChildren(childspans, 0, keywordsDB.SAFE_OFFSET_DISTANCE_X, 1); //FUB Is this used?
    keywordsDB.FORMULA_SUM_CHILDREN_PLUS_ONE_Y_PLUS_TREE_OFFSET_SAFE_OFFSET_DISTANCE_X = generateFormuSumChildren(childspans, 3, keywordsDB.SAFE_OFFSET_DISTANCE_X, 1); //FUB Is this used?

    ////////////////////////////////
    ////       Insert cell
    ////////////////////////////////


    // if (nodeData) {
    //     if (JSON.stringify(nodeData).indexOf("Investering kvartalet") != -1) {
    //         console.log("Foooooooooooooobar");
    //     }
    // }

    let { insertCellsFromTempl } = genCellFromTempls(pgridLR, pgridTable_Recurse, nodeData, pgridAxis, keywordsDB);


    let myAddedRows = 0;

    for (let k = 0; k < insertCellsFromTempl.length; k++) {
        let insertCellAndOffset = insertCellsFromTempl[k];


        let { insert_cell, insertReference, y_offset, x_offset, mergeStrategies, InNewRow, templateName, templateDescription, shiftCellsDown } = insertCellAndOffset;

        let addShiftCellsOffset = lodash.get(shiftCellsDownOffset, `[${currLvlZ}]`, 0);

        let insertYOffsetFinal = insertOffsetY + y_offset + addedRowsOffsetLR + addShiftCellsOffset  /*accShiftCellsDownOffset/*+ ret.shiftCellsDownOffset*/;
        let insertXOffsetFinal = insertOffsetX + x_offset;

        // let rowSkippedAsHasNoChildren = false;

        window.PGridClientDebugMode >= 4 && console.debug("spinningTree(): " + JSON.stringify({ pgridAxis, name: pgridLR.name, insertYOffsetFinal, insertOffsetY, y_offset, addShiftCellsOffset }));

        if (templateName == "Default" && k == 0 && keywordsDB.CURRENT_AXIS == "Rows") {

            // if (keywordsDB.NODE_ISGROUP == 1 && keywordsDB.CHILDREN_COUNT == 0 && keywordsDB.IS_LAST_LEVEL == false) {
            //     console.debug("Skipping adding y group row that does not have any children");
            //     rowSkippedAsHasNoChildren = true;
            // }
            // else
            {

                let yRowKey = lrY + insertYOffsetFinal;

                if (!(yRowKey in shiftRowsDownTracker)) {


                    expandIfNeeded(pgridTable_Recurse, lrY + insertYOffsetFinal + 1, 0);

                    pgridTable_Recurse = PGridCell.insertRowAt(pgridTable_Recurse, lrY + insertYOffsetFinal + 1 /* + 1*/, undefined /*, JSON.stringify({ type: "shiftCellsDown", k, currLevel: keywordsDB.CURRENT_LEVEL, insertYFinal, insertXFinal, templateName })*/);

                    shiftRowsDownTracker[yRowKey] = true;
                }
            }
        }




        if (shiftCellsDown) {

            pgridTable_Recurse = PGridCell.insertRowAt(pgridTable_Recurse, lrY + insertYOffsetFinal/* + 1*/, undefined /*, JSON.stringify({ type: "shiftCellsDown", k, currLevel: keywordsDB.CURRENT_LEVEL, insertYFinal, insertXFinal, templateName })*/);

            if (insertYOffsetFinal == 0) {

                let moveTableProp = function (propName, copy = false, dstPropName = null) {

                    if (dstPropName == null) {
                        dstPropName = propName;
                    }

                    if (propName in pgridTable_Recurse[lrY + 1][lrX]) {
                        if (pgridTable_Recurse[lrY][lrX] === undefined) {
                            pgridTable_Recurse[lrY][lrX] = {};
                        }

                        if (copy) {
                            pgridTable_Recurse[lrY][lrX][dstPropName] = JSON.parse(JSON.stringify(pgridTable_Recurse[lrY + 1][lrX][propName]));
                        } else {
                            pgridTable_Recurse[lrY][lrX][dstPropName] = pgridTable_Recurse[lrY + 1][lrX][propName];
                        }

                        delete pgridTable_Recurse[lrY + 1][lrX][propName]
                    }
                }

                moveTableProp("RefType");
                moveTableProp("Meta");
            }

            let add2shiftCellsDownOffset = function (lvl) {
                if (!((lvl) in shiftCellsDownOffset)) {
                    shiftCellsDownOffset[lvl] = 0;
                }
                shiftCellsDownOffset[lvl] += 1;


                if (!((lvl) in shiftCellsDownOffset2)) {
                    shiftCellsDownOffset2[lvl] = 0;
                }
                shiftCellsDownOffset2[lvl] += 1;

            }

            for (let iLvl = currLvlZ; iLvl < currentAxis.length; iLvl++) {
                add2shiftCellsDownOffset(iLvl);
            }
            ret.span2 += 1


        }



        let pgridTable_Recurse_Before_Str = null;

        if (window.PGridClientDebugMode >= 4) {
            pgridTable_Recurse_Before_Str = JSON.parse(JSON.stringify(pgridTable_Recurse));
        }

        {
            PGridCell.expandIfNeeded(pgridTable_Recurse, lrY + insertYOffsetFinal, lrX + insertXOffsetFinal, undefined);


            // ret.maxY = Math.max(ret.maxY, insertYFinal);
            // ret.maxX = Math.max(ret.maxX, insertXFinal);

            ret.usedMaxOffsetY = Math.max(ret.usedMaxOffsetY, insertYOffsetFinal);
            ret.usedMaxOffsetX = Math.max(ret.usedMaxOffsetX, insertXOffsetFinal);
            ret.usedMinOffsetY = Math.min(ret.usedMinOffsetY, insertYOffsetFinal);
            ret.usedMinOffsetX = Math.min(ret.usedMinOffsetX, insertXOffsetFinal);


            if (mergeStrategies != null) {
                insert_cell = PGridCell.mergeCells(pgridTable_Recurse[lrY + insertYOffsetFinal][lrX + insertXOffsetFinal], insert_cell, mergeStrategies);
            }


            //Add Reference metadata for tracing changes in cells
            let insertReferenseText = null;

            if (window.PGridClientDebugMode >= 3) {
                insertReferenseText = `spinningTreeNetSYNC(${lodash.get(window, "PGridDTC.CallCount", -1)}): `;
            } else {
                insertReferenseText = ``;
            }

            if (templateName || templateDescription) {
                // insertReferenseText = ``;

                if (templateName && !templateDescription) {
                    insertReferenseText += `${templateName}`;
                } else if (!templateName && templateDescription) {
                    insertReferenseText += `${templateDescription}`;
                }
                else { //has both
                    insertReferenseText += `${templateName}: ${templateDescription}`;
                }
            }


            if (insertReference) {
                insertReferenseText += ` > ${insertReference}`;
            }

            if (insertReferenseText != '') {

                let currentReferences = lodash.get(pgridTable_Recurse[lrY + insertYOffsetFinal][lrX + insertXOffsetFinal], "Meta.References", []);

                if (currentReferences.indexOf(insertReferenseText) == -1) {
                    currentReferences.push(insertReferenseText);
                }
                lodash.set(insert_cell, "Meta.References", currentReferences);
            }



            // let currentReferences2 = lodash.get(pgridTable_Recurse[lrY + insertYOffsetFinal][lrX + insertXOffsetFinal], "Meta.References", []);

            // if (currentReferences2.indexOf('spinningTreeNetSYNC(2773): Copy col to rows: Copy col meta (for Validation and savable) to all rows') != -1) {
            //     console.warn(`Found spinningTreeNetSYNC(2773)`);
            // }

            pgridTable_Recurse[lrY + insertYOffsetFinal][lrX + insertXOffsetFinal] = insert_cell;
        }



        if (window.PGridClientDebugMode >= 4) {
            // debug_pgridTable_Recurse_After = JSON.parse(JSON.stringify(pgridTable_Recurse));
            // DebugSomePGridTableChanges(debug_pgridTable_Recurse_Before, debug_pgridTable_Recurse_After);
            DebugDetectTableChanges(`spinningTreeNetSYNC() insert_cell ${templateName}`, pgridTable_Recurse, pgridTable_Recurse_Before_Str);
        }

    }

    ret.addedRowsOffset = accAddedRowsOffsetRec;

    return ret;
}



function applyKeywordsDb(keywordsDB, inText) {

    let keywordsApplied = false;
    let retObj = inText;


    if (inText && String(inText).indexOf("<<") != -1) { //Performance optimization, only apply if indication of keyword

        keywordsApplied = true;
        let keywordsDB_Keys = Object.keys(keywordsDB);

        for (let i = 0; i < keywordsDB_Keys.length; i++) {

            let ndk = keywordsDB_Keys[i];

            let noParatheises = false;

            if (lodash.isNumber(keywordsDB[ndk])) { //Hack to insert as number if intext is "<<KEYBWORD>>"
                noParatheises = true;
            }
            else if (typeof keywordsDB[ndk] === "boolean") { //Hack to insert as bool if intext is "<<KEYBWORD>>"
                noParatheises = true;
            }

            let replaceKey = "<<" + ndk + ">>";
            let replaceKeyParanthesis = '"' + replaceKey + '"';
            if (retObj.indexOf(replaceKey) != -1) {

                if (noParatheises) {
                    retObj = retObj.replaceAll(replaceKeyParanthesis, keywordsDB[ndk]);
                }

                retObj = retObj.replaceAll(replaceKey, keywordsDB[ndk]);
            }
        }
    }

    // return ret;
    return [retObj, keywordsApplied];

}



export function IsNumeric(input) {
    let ret = null;
    if (typeof input === 'number') {
        ret = true;
    }
    else {
        let RE = new RegExp(String.raw`^-?\d+(\.\d{1,2})?$`);
        if (RE.test(input)) {
            ret = true;
        } else {
            ret = false;
        }
    }
    return ret;
}

function parseNumber(value, locale = navigator.language) {
    const example = Intl.NumberFormat(locale).format('1.1');
    const cleanPattern = new RegExp(`[^-+0-9${example.charAt(1)}]`, 'g');
    const cleaned = value.replace(cleanPattern, '');
    const normalized = cleaned.replace(example.charAt(1), '.');

    return parseFloat(normalized);
}

export function MakeNumericIfPossible(input) {
    let ret = null;
    if (typeof input === 'number') {
        ret = input;
    }
    else {
        let RE_enUS = new RegExp(String.raw`^-?\d+(\.\d{1,8})?$`);
        if (RE_enUS.test(input)) {
            ret = parseNumber(input, 'en-US');

        } else {

            let RE_svSE = new RegExp(String.raw`^-?\d+(\,\d{1,8})?$`);
            if (RE_svSE.test(input)) {
                ret = parseNumber(input, 'sv-SE');
            } else {
                ret = input; //Other cases
            }
        }
    }
    return ret;
}


export function DebugCountLRs(pgridDataIn) {

    let ret = 0;
    pgridDataIn.forEach((row, idx) => {

        if (JSON.stringify(row, null, 2).indexOf("LinkedRangeName") != -1) {

            ret++;
        }

    })

    console.log("Found LR was: " + ret);

    return ret;
}

// //Temporary hack, not an optimized way to find dynamix position. Should use "addedRowsOffset" insted //FUB
// export function findLRCoordinate(pgridTable, linkedRangeName) {

//     let ret = { y: -1, x: -1 };

//     for (let iy = 0; iy < pgridTable.length; iy++) {
//         for (let ix = 0; ix < pgridTable[0].length; ix++) {

//             let refTypeText = lodash.get(pgridTable[iy][ix], "RefType", null)
//             if (refTypeText != null && refTypeText != "") {

//                 let refType = JSON.parse(refTypeText);
//                 if (refType.LinkedRangeName == linkedRangeName) {
//                     ret.y = iy;
//                     ret.x = ix;
//                 }
//             }
//         }
//     }

//     if (ret.y == -1) {
//         throw new Error(`Could not find the LR with the name "${linkedRangeName}"`);
//     }
//     return ret;
// }

//Temporary hack, not an optimized way to find dynamix position. Should use "addedRowsOffset" insted //FUB
export function findLRCoordinateOFF(pgridTable, linkedRangeName, source = `<findLRCoordinate has no souce>`, context = null) {


    return PGridMatrices.Get_LRsFromTable(pgridTable, { onlyThisLR: linkedRangeName, source: `${source} -> findLRCoordinateOFF()` }).y;

}
export function findLRCoordinateOLD(pgridTable, linkedRangeName, source = `<findLRCoordinate has no souce>`, context = null) {

    let ret = null;

    //FUB
    if (!context && window.PGridVueStore) {
        context = window.PGridVueStore;
    }

    if (context) { //Use hints!
        let removeThisFromHints = [];
        for (let i = 0; i < context.state.pgridLRCoordinatesHints.lBAZength; i++) {

            let hint = context.state.pgridLRCoordinatesHints[i];

            if (hint.name == linkedRangeName) {
                false && console.debug("findLRCoordinate() findLRCoordinate() examine hint")

                // let refTypeText = lodash.get(pgridTable[hint.y][hint.x], "RefType", null)
                let refTypeText = "RefType" in pgridTable[hint.y][hint.x] ? pgridTable[hint.y][hint.x].RefType : null;

                let foundInHint = false;

                if (refTypeText != null && refTypeText != "") {

                    let refType = JSON.parse(refTypeText);

                    if (refType.LinkedRangeName == linkedRangeName) {
                        false && console.debug("findLRCoordinate() findLRCoordinate() hit!");

                        foundInHint = true;
                    }
                }

                if (foundInHint) {
                    //Found in hint!
                    ret = lodash.clone(hint);

                } else {
                    false && console.debug(`findLRCoordinate() hint for ${linkedRangeName} was wrong, will remove...`);
                    removeThisFromHints.push(i);
                }
            }
        }

        if (removeThisFromHints.length > 0) {
            let updatedLRCoordinatesHints = context.state.pgridLRCoordinatesHints.filter(item => !removeThisFromHints.includes(item));
            context.commit('Mutation_UpdateRoot', { prop: 'pgridLRCoordinatesHints', val: updatedLRCoordinatesHints, source: `${source} -> findLRCoordinate()` });
        }
    }


    if (ret == null) {
        // let allLRCorrdinates = PGridMatrices.FindLRCoordinates(pgridTable, { context, source: `${source} -> findLRCoordinate()` });
        let allLRCorrdinates = PGridMatrices.Get_LRsFromTable(pgridTable, { source: `${source} -> findLRCoordinate()` }); // Get all linked ranges
        let allFoundLRCorrdinates = allLRCorrdinates.filter(lr => lr.name == linkedRangeName);

        if (allFoundLRCorrdinates.length == 0) {
            throw new Error(`findLRCoordinate() Could not find any linked range with name '${linkedRangeName}'. Source: ${source}`);
        }
        else if (allFoundLRCorrdinates.length > 1) {
            throw new Error(`findLRCoordinate() Found multiple linked ranges with name '${linkedRangeName}'. Source: ${source}`);
        } else {
            return allFoundLRCorrdinates[0];
        }
    }

    return ret;

}

export function HandleDimensionOverrides(context, lr, pgridFilterSelection, overrideRemoveOrTranslateCellKeyDims) {
    let pgridFilterSelectionModded = [];
    let pgridPostFilter = null;

    let ret = null;
    pgridFilterSelection.forEach(filtDim => {

        let keep = true;

        let filtDimClone = lodash.clone(filtDim);

        let isHidden = lodash.get(filtDimClone, "HiddenToGrid", null);
        let keepHidden = false;

        for (let j = 0; j < overrideRemoveOrTranslateCellKeyDims.length; j++) {
            let translation = overrideRemoveOrTranslateCellKeyDims[j];
            let dimKeepHidden = lodash.get(translation, "KeepHidden", null);

            if (filtDimClone.Name == translation.From.Name) {

                if ("Remove" in translation) {

                    if (context) {
                        PGridDynExtract.UpdateDynProps_Generic(context, translation.Remove);
                    }

                    if (translation.Remove) { //Remove key from FilterKey
                        keep = false;
                    }


                }

                // "To": null, will not pass this, thus hiding the dimension
                if ("To" in translation && lodash.get(translation, "To.Name", null) != null) {
                    filtDimClone.Name = translation.To.Name;
                    if (lodash.get(translation, "To.HierId", null) != null) {
                        filtDimClone.HierId = translation.To.HierId;
                    }
                }

                else if ("To" in translation && (lodash.get(translation, "To.Val", null) != null || lodash.get(translation, "To.Val_DYN", null) != null)) //FUB Ugly, but working, for Val_DYN only
                {
                    if (context) {
                        PGridDynExtract.UpdateDynProps_Generic(context, translation.To);
                    }
                    filtDimClone.Val = translation.To.Val;
                }

                // "To": val


                // if ("To" in translation) {

                //     if (context) {
                //         PGridDynExtract.UpdateDynProps_Generic(context, translation.To);
                //     }

                //     if (lodash.get(translation, "To.Val", null) != null) {
                //         filtDimClone.Val = translation.To.Val;
                //     }

                //     if (lodash.get(translation, "To.Name", null) != null) {

                //         filtDimClone.Name = translation.To.Name;
                //         if (lodash.get(translation, "To.HierId", null) != null) {
                //             filtDimClone.HierId = translation.To.HierId;
                //         }
                //     }
                // }
                else if (isHidden && dimKeepHidden) {
                    keepHidden = true;  //If any translation dim matched KeepHidden, then keep
                } else {
                    keep = false;
                }

                //For renaming a dimension
                if ("To_PostFilter" in translation && lodash.get(translation, "To_PostFilter.Name", null) != null) {
                    if (pgridPostFilter == null) {
                        pgridPostFilter = [];
                    }
                    pgridPostFilter.push({ Name: translation.To_PostFilter.Name, Val: filtDimClone.Val });
                }

                // if ("Remove" in translation) {

                //     if (context) {
                //         PGridDynExtract.UpdateDynProps_Generic(context, translation.Remove);
                //     }

                //     if (translation.Remove) { //Remove key from FilterKey
                //         keep = false;
                //     }


                // }


            }
        }


        if (isHidden) {
            if (!keepHidden) {
                //Dont keep if hidden and not KeepHidden
                keep = false;
            }
        }

        if (keep) {
            delete filtDimClone.HiddenToGrid;
            pgridFilterSelectionModded.push(filtDimClone);
        }

    });

    //Filter out dublicates
    let pgridFilterSelectionUnique = lodash.uniqBy(pgridFilterSelectionModded, function (f) {
        return JSON.stringify(f);
    });

    if (pgridFilterSelectionModded.length != pgridFilterSelectionUnique.length) {
        console.debug("Removed dublicate key value (HierId)");
    }


    let OptionalCellFiltersClean = null;

    if (pgridPostFilter) {


        // "OverrideRemoveOrTranslateCellKeyDims": [
        //     {
        //         "From": {
        //             "Name": "FilterDim_GetPlanningAccountHierarchy"
        //         },
        //         "To": null,
        //         "To_PostFilter": {
        //             "Name": "Hierarki_GetPlanningAccountHierarchy"  <------- This will now be kept (and not cleaned up) in the "FilterKey"
        //         }
        //     }
        // ],

        let OptionalCellFilters = [/*...pgridFilterSelectionUnique, */...pgridPostFilter]; //Add
        //  pgridFilterSelectionUnique
        OptionalCellFiltersClean = CleanupFilterKey(OptionalCellFilters)
    }

    ret = [pgridFilterSelectionUnique, OptionalCellFiltersClean];

    return ret;
}

export function trimAndUpperCaseIfNotNull(inText) {

    let ret = null;

    if (inText != null) {
        if (IsNumeric(inText)) {
            ret = String(inText).toUpperCase().trim();
        } else {
            ret = inText.toUpperCase().trim();
        }
    }

    return ret;
}


export function getPGridCell(pgridData, row, col) {

    var retCel = null;

    if (pgridData != null) {
        if (pgridData.length > row) {
            if (pgridData[row].length > col) {
                if (pgridData[row][col] != null) {
                    retCel = pgridData[row][col];
                }
            }
        }
    }

    return retCel;
}


export function QueryString_GetKeyValuePairs(queryString) {

    let ret = [];

    if (queryString != null) {
        let querystringClean = queryString;
        if (querystringClean[0] == '?') {
            querystringClean = querystringClean.slice(1);
        }

        let qsPairsTxt = querystringClean.split('&');
        qsPairsTxt.forEach(qst => {
            let [key, val] = qst.split('=');
            ret.push({ key, val });
        })
    }
    return ret;
}

export function QueryString_GetKeyValueDict(queryString) {

    let ret = {};

    if (queryString != null) {
        let querystringClean = queryString;
        if (querystringClean[0] == '?') {
            querystringClean = querystringClean.slice(1);
        }

        let qsPairsTxt = querystringClean.split('&');
        qsPairsTxt.forEach(qst => {
            let [key, val] = qst.split('=');
            ret[key] = val;
        })
    }
    return ret;
}

//Will sort querystrin gpart in the form ?b=2&a=1 to ?a=1&b=2
export function QueryString_Sort(queryString) {

    let ret = null;

    // 1. Extract
    let kvpairs = QueryString_GetKeyValuePairs(queryString);

    // 2 .Sort
    let kvpairs_Sorted = kvpairs.sort((a, b) => {
        let ret = 0;

        let aKey = String(a.key).toUpperCase();
        let bKey = String(b.key).toUpperCase();

        //Put customer key and tab key first in line
        if (aKey == "CK") {
            aKey = 'AAAAAA'
        }
        if (aKey == "TK") {
            aKey = 'AAAAAB'
        }

        if (bKey == "CK") {
            bKey = 'AAAAAA'
        }
        if (bKey == "TK") {
            bKey = 'AAAAAB'
        }

        if (aKey < bKey) {
            ret = -1;
        }
        if (aKey > bKey) {
            ret = 1;
        }
        return ret;
    });

    // 3. Compile as QS
    let qsArr = kvpairs_Sorted.map(kvp => {
        return `${kvp.key}=${kvp.val}`;
    });

    ret = `?${qsArr.join('&')}`;

    if (ret != queryString) {
        false && console.log(`QueryString_Sort() sorted querystring:\nFrom: ${queryString}\n  To: ${ret}`);
    }

    return ret;

}

export function QueryString_UpdateByKey(queryString, key, value) {

    let ret = null;

    let kvpairs = QueryString_GetKeyValuePairs(queryString);

    //1. Remove any accurances of key
    kvpairs = kvpairs.filter(kvp => kvp.key != key); //Remove occurences of 'key'

    //2. Add key value if value is not null;
    if (value != null) {
        kvpairs.push({ key: key, val: value })
    }

    //3. Sort
    kvpairs = kvpairs.sort((a, b) => {
        let ret = 0;

        let aKey = String(a.key).toUpperCase();
        let bKey = String(b.key).toUpperCase();

        //Put customer key and tab key first in line
        if (aKey == "CK") {
            aKey = 'AAAAA'
        }
        if (aKey == "TK") {
            aKey = 'BBBBB'
        }

        if (bKey == "CK") {
            bKey = 'AAAAA'
        }
        if (bKey == "TK") {
            bKey = 'BBBBB'
        }

        if (aKey < bKey) {
            ret = -1;
        }
        if (aKey > bKey) {
            ret = 1;
        }
        return ret;
    });


    let qsArr = kvpairs.map(kvp => {
        return `${kvp.key}=${kvp.val}`;
    });

    //4. Compile as QS

    ret = `?${qsArr.join('&')}`;

    if (ret != queryString) {
        typeof window !== 'undefined' && window.PGridClientDebugMode >= 2 && console.debug(`QueryString_UpdateByKey() updated querystring`);
    }

    return ret;
}



export function Filter_ConvertPgridDefinitionToFilterNames(pgridDefinition) {

    let ret = null;

    let inFiltersDef = lodash.get(pgridDefinition, "Filter.Filters", []);
    ret = inFiltersDef.map(o => {
        if (!("Title" in o)) {

            throw new Error(`Missing title in filter definition ${JSON.stringify(o)}`);
        }
        return { filtertitle: o.Title, datasetnames: o.DataSets.map(ds => ds.DataSet) };
    });

    return ret;
}



/*
* Imputs: grid definitionfrom grid table, filtername and gridDim's, acc virtualQueryString
* Output: pgrid filter with pre-selected if available and updated virtualquerystring based on pre selection
*/
export function Filter_ConvertPgridDefinitionToPGridFilter(pgridDefinition, filterTitle, pgridDim, virtualQueryString, loadData = true) {

    let ret = { PGridFilter: null, VirtualQueryString: virtualQueryString };

    let filtDef = Filter_ExtractFilterDefinition(pgridDefinition, filterTitle);

    if (!("Title" in filtDef)) {
        throw new Error(`Filter_ConvertPgridDefinitionToPGridFilter(): missing property "Title"`)

    }
    if (!("Type" in filtDef)) {
        throw new Error(`Filter_ConvertPgridDefinitionToPGridFilter(): '${filtDef.Title}': missing property "Type" for filter`);
    }

    let filter = {
        order: null,
        dimName: null,
        title: null,
        displayTitle: null,
        type: null,
        hasChanged: null,
        hiddenToGrid: null,
        pageTitleTemplate: null,
        filterOptions: null,
        filterValue: null,
        filterIsLoading: false,
        old_filterValue: null,
        // old_wasReloadOnChangeWithQueryStringExceptFirst: false,
        settings_filterStyle: null, //default 330px
        select_preSelectColumn: null,
        select_reloadOnChangeWithQueryString: null,
        select_reloadOnChangeWithQueryStringExceptFirst: null,
        select_dontResetOnLeftFilterReset: null,
        select_dontResetOnLeftFilterResetExcept: [],
    };



    filter.title = filtDef.Title;

    filter.displayTitle = lodash.get(filtDef, "DisplayTitle", filtDef.Title);

    filter.type = filtDef.Type;

    filter.filterIsLoading = !loadData;

    filter.hasChanged = false;

    filter.hiddenToGrid = lodash.get(filtDef, "HiddenToGrid", false);
    filter.pageTitleTemplate = lodash.get(filtDef, "PageTitleTemplate", " - <<FILTER_SELECTED_TEXT>>");

    //FUB only the first dataset is considered for "Select" options
    filter.settings_filterStyle = lodash.get(filtDef.DataSets[0], "Settings.FilterStyle", { minWidth: '250' + 'px' }); //default 330px
    filter.select_reloadOnChangeWithQueryString = lodash.get(filtDef.DataSets[0], "Select.ReloadOnChangeWithQueryString", null);
    filter.select_reloadOnChangeWithQueryStringExceptFirst = lodash.get(filtDef.DataSets[0], "Select.ReloadOnChangeWithQueryStringExceptFirst", null);
    filter.select_dontResetOnLeftFilterReset = lodash.get(filtDef.DataSets[0], "Select.DontResetOnLeftFilterReset", null);
    filter.select_dontResetOnLeftFilterResetExcept = lodash.clone(lodash.get(filtDef.DataSets[0], "Select.DontResetOnLeftFilterResetExcept", []));

    if (filter.select_dontResetOnLeftFilterResetExcept != null) {
        //  console.warn(`filter.select_dontResetOnLeftFilterResetExcept is not null`);
    }
    else if (!Array.isArray(filter.select_dontResetOnLeftFilterResetExcept)) {
        console.warn(`filter.select_dontResetOnLeftFilterResetExcept is not an array`);
    }

    filter.select_preSelectColumn = lodash.get(filtDef.DataSets[0], "Select.PreSelectColumn", null);

    filter.hasFilterValue = false;

    if (loadData) {

        let dataSetToLoad = filtDef.DataSets[0].DataSet;
        let dataSet0 = lodash.get(pgridDim, dataSetToLoad, null); //Only first dataset for now

        // console.info(Object.keys(pgridDim).sort());

        if (!dataSet0) {
            console.warn("Could not find dataset by name:" + dataSetToLoad + " from", Object.keys(pgridDim));
        }

        let dimName = filtDef.DataSets[0].DataSet;

        filter.dimName = dimName;


        if (filter.type == "Dropdown") {
            filter.filterOptions = Array();

            let found = false;

            //FUB only one dataset is currently supported
            if (dataSet0 != null) {
                var colNames = dataSet0[0];

                let preSelIdx = null;
                if (filter.select_preSelectColumn != null) {


                    preSelIdx = colNames.indexOf(filter.select_preSelectColumn);

                    if (preSelIdx == -1) {
                        throw new Error(`Filter_ConvertPgridDefinitionToPGridFilter() '${filter.title}': Could not find pre-select column '${filter.select_preSelectColumn}' (${colNames.join(',')}) for filter dim '${filter.dimName}'`);
                    }
                }


                let hasQSKey = null;

                if (filter.select_reloadOnChangeWithQueryString != null) {

                    let kvp = QueryString_GetKeyValuePairs(ret.VirtualQueryString);
                    hasQSKey = kvp.find(o => o.key == filter.select_reloadOnChangeWithQueryString)
                }

                for (var rowIdx = 0; rowIdx < dataSet0.length; rowIdx++) {
                    if (rowIdx == 0) {
                        //First row is the headers
                        colNames = dataSet0[rowIdx] // <-- 0
                    } else {

                        let val = dataSet0[rowIdx][colNames.indexOf("Value")];
                        let name = dataSet0[rowIdx][colNames.indexOf("Name")];

                        let allFields = {};

                        for (let n = 0; n < colNames.length; n++) {
                            allFields[colNames[n]] = dataSet0[rowIdx][n];
                        }

                        var newOpt = {
                            value: val,
                            text: name,
                            index: rowIdx - 1, //as 0 is the header
                            isSelected: false,  //All NonSelected in this stage
                            allFields: allFields
                        }


                        // let extraData


                        if (hasQSKey != null) {

                            //Query string overrides default
                            if (newOpt.value == hasQSKey.val) {
                                found = true;
                                newOpt.isSelected = true;
                                filter.filterValue = { value: newOpt.value, text: newOpt.text, allFields: allFields };

                                // if (newOpt.text.toUpperCase().indexOf("PUBLISHED") != -1 || newOpt.text.toUpperCase().indexOf("PUBLICERAD") != -1) {
                                //     ret.isPublished = true;
                                // }

                                //Update virtualquerystring (but not realy neded expet for sorting keys)
                                let newVirtualQueryString = QueryString_UpdateByKey(ret.VirtualQueryString, filter.select_reloadOnChangeWithQueryString, hasQSKey.val);

                                if (newVirtualQueryString != ret.VirtualQueryString) {
                                    typeof window !== 'undefined' && window.PGridClientDebugMode >= 2 && console.debug(`Filter_ConvertPgridDefinitionToPGridFilter() updating query string:\nFrom: ${ret.VirtualQueryString}\n  To: ${newVirtualQueryString}`);
                                    ret.VirtualQueryString = newVirtualQueryString;
                                }
                            }
                        } else {

                            if (preSelIdx != null) {

                                let preSelected = dataSet0[rowIdx][preSelIdx];

                                if (preSelected) {
                                    found = true;
                                    newOpt.isSelected = true;
                                    filter.filterValue = { value: newOpt.value, text: newOpt.text, allFields: newOpt.allFields };
                                    if (filter.select_reloadOnChangeWithQueryString != null) { //Update virtualquerystring
                                        ret.VirtualQueryString = QueryString_UpdateByKey(ret.VirtualQueryString, filter.select_reloadOnChangeWithQueryString, val);
                                    }
                                }
                            }
                        }


                        filter.filterOptions.push(newOpt);
                    }
                }
            }

            // if (found == false) {
            //     if (filter.filterOptions.length > 0) {

            //         throw `Filter_ConvertPgridDefinitionToPGridFilter() '${filter.title}': missing default value, setting to first row filter`;
            //         console.warn(`Filter_ConvertPgridDefinitionToPGridFilter() '${filter.title}': missing default value, setting to first row filter`);

            //         filter.filterOptions[0].isSelected = true;
            //         filter.filterValue = { value: filter.filterOptions[0].value, text: filter.filterOptions[0].text, allFields: filter.filterOptions[0].allFields };

            //         if (filter.select_reloadOnChangeWithQueryString != null) {
            //             ret.VirtualQueryString = QueryString_UpdateByKey(ret.VirtualQueryString, filter.select_reloadOnChangeWithQueryString, filter.filterOptions[0].value);
            //         }
            //     }
            // }

        } else {
            throw new Error(`Filter_ConvertPgridDefinitionToPGridFilter() '${filter.title}': Filter type '${filter.type}' is not supported`);
        }


        Filter_ValidateFilterSelection(filter);

    } else {

        //Loading... loading
        var newOpt = {
            value: 0,
            text: "Laddar...",
            index: 0, //as 0 is the header
            isSelected: true  //All NonSelected in this stage
        }

        filter.filterOptions = Array();
        filter.filterOptions.push(newOpt);
        filter.filterValue = { value: newOpt.value, text: newOpt.text, allFields: newOpt.allFields };
    }


    ret.PGridFilter = filter;

    if (ret.VirtualQueryString != virtualQueryString) {
        // console.debug(`Filter_ConvertPgridDefinitionToPGridFilter() '${filter.title}': updated VirtualQueryString:\nFrom: ${virtualQueryString}\nTo:  ${ret.VirtualQueryString}`);
        typeof window !== 'undefined' && window.PGridClientDebugMode >= 2 && console.debug(`Filter_ConvertPgridDefinitionToPGridFilter() updated querystring`);
    }

    return ret;
}







export function Filter_ValidateFilterSelection(filter) {
    let ret = {
        text: null,
        value: null,
        allFields: null
    };

    //Look for value duplicates
    const lookup = filter.filterOptions.reduce((a, e) => {
        a[e.value] = ++a[e.value] || 0;
        return a;
    }, {});

    let duplicates = filter.filterOptions.filter(e => lookup[e.value]);
    if (duplicates.length > 0) {

        let errMsg = `Filter_ValidateFilterSelection() Multiple same values was found in rows, that is not allowed, but will continue: ${JSON.stringify(duplicates, null, 2)}`;
        (global && global.serverDebugMode >= 2) && console.warn(errMsg);
        (window && window.PGridClientDebugMode >= 2) && console.warn(errMsg);

        //  throw new Error(`Filter_ValidateFilterSelection() Multiple same values was found in rows, that is not allowed: ${JSON.stringify(duplicates, null, 2)}`);
    }

    let found = false;

    for (let i = 0; i < filter.filterOptions.length; i++) {
        let fOpt = filter.filterOptions[i];


        if (fOpt.isSelected) {
            if (found) {
                // throw new Error(`Filter_ValidateFilterSelection() Multiple isSelected found, this is not supported by this filter`);
                throw new Error(`Filter_ValidateFilterSelection() Multiple isSelected found, this is not supported by this filter`);
            }
            found = true;
            ret.text = fOpt.text;
            ret.value = fOpt.value;
            ret.allFields = fOpt.allFields;
        }
    }


    if (found == false) {
        if (filter.filterOptions.length > 0) {
            throw `Filter_ValidateFilterSelection() '${filter.title}': missing selected value`;
        }
    }

    //If no PrePre selected from DB, then choose first row;
    if (ret.value == null) {
        throw new Error(`Filter_ExtractClientSideSelection no default filter value found for filter ${filter.title}`);
    }
    return ret;
}

export function Filter_ExtractFilterSelection(filter) {

    let selected = filter.filterOptions.filter(x => x.isSelected); //.map(x => x.value).join(","); //Supports multiple values

    if (selected != null && selected > 1) {
        throw new Error("Filter_ExtractPGridFiltersSelection() multi value is not yet supported");
    }

    if (selected.length == 0) {
        // throw new Error("Filter_ExtractPGridFiltersSelection() non selected filter values isn not yet supported");
        console.warn("Filter_ExtractPGridFiltersSelection() non selected filter values isn not yet supported");
        return null;
    }

    return selected[0];
}

export function Filter_ExtractPGridFiltersSelection(pgridFilters, keepHidden = false) {
    const pgridFilterSelection = new Array();

    for (let i = 0; i < pgridFilters.Filters.length; i++) {

        let filter = pgridFilters.Filters[i];

        let filterSelection = Filter_ExtractFilterSelection(filter);

        if (filter.hiddenToGrid) {
            if (keepHidden) {
                pgridFilterSelection.push({ Name: filter.dimName, Val: filterSelection.value, HiddenToGrid: filter.hiddenToGrid });
            }
        } else {
            pgridFilterSelection.push({ Name: filter.dimName, Val: filterSelection.value });

        }
    }

    return pgridFilterSelection;
}

export function Filter_NewValueFromFilter(context, filterIdx, filter, inOptSelectedNullable, oldOptSelected) {

    let ret = { was_select_reloadOnChangeWithQueryStringExceptFirst: false }

    console.log("[FilterDropdown] Set newOptSelected: " + JSON.stringify(inOptSelectedNullable));


    //FUB Store the old value here
    context.state.pgridFilter.Filters[filterIdx].old_filterValue = oldOptSelected
    // context.state.pgridFilter.Filters[filterIdx].old_wasReloadOnChangeWithQueryStringExceptFirst = false;


    let filterSrcClone = lodash.clone(context.state.pgridFilter.Filters[filterIdx]); //JSON.parse(JSON.stringify(this.filter));


    /* extract selected by:
     * 1. dropdown selected object
     */

    let selectedValue = null;

    if (inOptSelectedNullable == null) {
        //
        selectedValue = null; //This will clear this filter


    } else {
        selectedValue = inOptSelectedNullable.value;
    }

    for (let i = 0; i < filterSrcClone.filterOptions.length; i++) {
        let fOpt = filterSrcClone.filterOptions[i];
        fOpt.isSelected = selectedValue != null && selectedValue == fOpt.value;
        // fOpt.isSelected = newOptSelected && newOptSelected.value && newOptSelected.value == fOpt.value;

        if (fOpt.isSelected) {
            if (window.PGridClientDebugMode >= 3) {
                console.log(`[FilterDropdown] Setting drop down ${fOpt.text} isSelected to: ${fOpt.isSelected}`);
            }
        }
    }

    if (selectedValue == null) {
        console.warn(`[FilterDropdown] selectedValue == null`);
    }


    let newAccVirtualQueryString = context.state.pgridVars.VirtualQueryString;


    //Update current
    newAccVirtualQueryString = QueryString_UpdateByKey(
        newAccVirtualQueryString,
        filterSrcClone.select_reloadOnChangeWithQueryString,
        selectedValue
    );


    let foundAtIdx = -1;

    filterSrcClone.filterOptions.forEach((o, idx) => { if (o.value == selectedValue) { foundAtIdx = idx } });



    if (filterSrcClone.select_reloadOnChangeWithQueryStringExceptFirst && inOptSelectedNullable != null && foundAtIdx == 0) {


        console.debug("ReloadOnChangeWithQueryStringExceptFirst: detected firts selection: Skipping goto new url");

        ret.was_select_reloadOnChangeWithQueryStringExceptFirst = true;

        //This wil enable the save button without needing to change any cells
        DirtyGridFlag(context, `Filter_NewValueFromFilter`);


        {
            console.log("NewUrl: " + newAccVirtualQueryString);
            console.log(`Should have window.location.href = ${newAccVirtualQueryString}`);

            // new URL() https://dmitripavlutin.com/parse-url-javascript/
            let gotoUrl = new URL(window.location.pathname + newAccVirtualQueryString, window.location.href);
            if (gotoUrl.search == null) {
                console.warn(`[FilterDropdown] filterIdx: ${filterIdx} gotoUrl.search == null`);
            } else {
                let url_newVirtualQueryString = gotoUrl.search;

                HistoryPushStateIfNotSame(gotoUrl.href, `Filter_NewValueFromFilter() A`);
                // console.debug(`VirtualQueryString is updating to: ${url_newVirtualQueryString}`);
                context.commit('Mutation_UpdatePGridVars', { prop: 'VirtualQueryString', val: url_newVirtualQueryString, source: 'pgrid-filter-dropdown.vue' });
                updateTabLinks(url_newVirtualQueryString, `Filter_NewValueFromFilter()`);
            }
        }
    } else {
        for (let i = 0; i < context.state.pgridFilter.Filters.length; i++) {

            if (i > filterIdx) {

                let filterDependClone = lodash.clone(context.state.pgridFilter.Filters[i]); //JSON.parse(JSON.stringify(this.filter));


                if (filterDependClone.select_dontResetOnLeftFilterReset === true) {
                    console.debug(`Will not reset filter ${filterDependClone.title} because of DontResetOnLeftFilterReset != null`);
                }
                else if (Array.isArray(
                    filterDependClone.select_dontResetOnLeftFilterResetExcept)
                    && filterDependClone.select_dontResetOnLeftFilterResetExcept.filter(o => o == filterSrcClone.title).length == 0) {
                    console.debug(`Will not reset filter ${filterDependClone.title} because of DontResetOnLeftFilterResetExcept[...] != filterSrcClone.title (${filterSrcClone.title})`);
                }
                else {
                    //Remove filter selections "to the right"
                    newAccVirtualQueryString = QueryString_UpdateByKey(
                        newAccVirtualQueryString,
                        filterDependClone.select_reloadOnChangeWithQueryString,
                        null
                    );
                    context.state.pgridFilter.Filters[i].filterIsLoading = true;
                }
            }
        }

        { //Same as above
            console.log("NewUrl: " + newAccVirtualQueryString);
            console.log(`Should have window.location.href = ${newAccVirtualQueryString}`);

            // // new URL() https://dmitripavlutin.com/parse-url-javascript/
            let gotoUrl = new URL(window.location.pathname + newAccVirtualQueryString, window.location.href);
            if (gotoUrl.search == null) {
                console.warn(`[FilterDropdown] filterIdx: ${filterIdx} gotoUrl.search == null`);
            } else {
                let url_newVirtualQueryString = gotoUrl.search;

                HistoryPushStateIfNotSame(gotoUrl.href, `Filter_NewValueFromFilter() B`);

                context.commit('Mutation_UpdatePGridVars', { prop: 'VirtualQueryString', val: url_newVirtualQueryString, source: 'pgrid-filter-dropdown.vue' });
                updateTabLinks(url_newVirtualQueryString, `Filter_NewValueFromFilter`);
            }
        }

        //Reload everything

        let asyncReloadGrid = async function () {
            try {
                // await context.dispatch("Action_PgridRESET", { type: "filter", source: "Filter_NewValueFromFilter()" });
                await context.dispatch("Action_InjectAndRendrFilters", { source: "Filter_NewValueFromFilter()" });

            } catch (err) {
                let source = `Filter_NewValueFromFilter()`;
                let errMsg = `asyncReloadGrid() got error that was muted source: ${source} exception: ${err.message}`;
                console.error(errMsg);
            }

        }
        asyncReloadGrid();
    }




    return ret;

}
/*
Handle filter change
*/
export function HandleFilterSelectionChange(context, filterUpdate) {
    if (window.PGridClientDebugMode >= 2) {
        console.debug("pgrid-filter: HandleFilterSelectionChange() got filterUpdate:", filterUpdate);
    }

    let filter = context.state.pgridFilter.Filters[filterUpdate.filterIdx];

    try {
        // if (filter.dimName == "FilterDim_GetPlanningVersionHierarchy") {
        // let filterIndicateIsPublished = PGridDynExtract.Filter_CurrentSelectionTextHasStr(filter, ["PUBLISHED", "PUBLISERAD"]);

        // context.commit("Mutation_UpdatePGridSettings", { prop: "isPublished", val: filterIndicateIsPublished });
        // }

        // let enableSaveButton = PGridUtils.CalculateEnableSaveButtons(context);
        // context.commit("Mutation_FiltersUpdate", { prop: "EnableSaveButton", val: enableSaveButton });

        let oldOptSelected = lodash.get(filterUpdate, "oldOptSelected", null)

        let newFiltRes = Filter_NewValueFromFilter(context, filterUpdate.filterIdx, filter, filterUpdate.newOptSelected, oldOptSelected);
        if (newFiltRes.was_select_reloadOnChangeWithQueryStringExceptFirst) {
            if (window.PGridClientDebugMode >= 2) {
                console.debug(`Will not update as selection has: was_select_reloadOnChangeWithQueryStringExceptFirst`);
            }
        } else {
            //In the normal case, make grid loading indicator go on

            // let initTimestamp = Date.now();

            // context.commit("Mutation_UpdatePGridSettings", {
            //   prop: "initOfLastQuery_Timestamp",
            //   val: initTimestamp,
            //   source: `pgrid-filters.vue mounted()`,
            // });

            context.commit("Mutation_UpdatePGridSettings", {
                prop: "isLoading",
                val: true,
                source: "HandleFilterSelectionChange()",
            });
        }

        //Handle button props
        let dynFilterButtons = lodash.get(context, "state.pgridFilter.DynamicButtons", null);
        if (dynFilterButtons == null) {
            throw new Error(`dynFilterButtons == null`);
        }
        PGridDynExtract.UpdateDynProps_ButtonList(context, dynFilterButtons);
        context.commit("Mutation_FiltersUpdate", { prop: "DynamicButtons", val: dynFilterButtons, source: "HandleFilterSelectionChange()" });
    } catch (err) {
        let source = `HandleFilterSelectionChange()`;
        let errMsg = `PGridUtils.Filter_NewValueFromFilter() got error that source: ${source} exception: ${err.message}`;
        console.error(errMsg);
    }
}


// export function HandleUpdateSaveDate(context, initTimestamp ) {
//     if (window.PGridClientDebugMode >= 2) {
//         console.debug("pgrid-filter: HandleSaveDateChange() got filterUpdate:", filterUpdate);
//     }

//     let filter = context.state.pgridFilter.Filters[context.state.pgridFilter.Filters.length - 1 /* The Version filter is always the last */];

//     let filterSrcClone = lodash.clone(filter); //JSON.parse(JSON.stringify(this.filter));


//     for (let i = 0; i < filterSrcClone.filterOptions.length; i++) {
//         let fOpt = filterSrcClone.filterOptions[i];
//         fOpt.isSelected = selectedValue != null && selectedValue == fOpt.value;
//         // fOpt.isSelected = newOptSelected && newOptSelected.value && newOptSelected.value == fOpt.value;

//         if (fOpt.isSelected) {
//             if (window.PGridClientDebugMode >= 3) {
//                 console.log(`[FilterDropdown] Setting drop down ${fOpt.text} isSelected to: ${fOpt.isSelected}`);
//             }
//         }
//     }


//     try {

//         // let oldOptSelected = lodash.get(filterUpdate, "oldOptSelected", null)

//         let newFiltRes = Filter_NewValueFromFilter(context, filterUpdate.filterIdx, filter, filterUpdate.newOptSelected, oldOptSelected);
//         if (newFiltRes.was_select_reloadOnChangeWithQueryStringExceptFirst) {
//             if (window.PGridClientDebugMode >= 2) {
//                 console.debug(`Will not update as selection has: was_select_reloadOnChangeWithQueryStringExceptFirst`);
//             }
//         }
//     } catch (err) {
//         let source = `HandleFilterSelectionChange()`;
//         let errMsg = `PGridUtils.Filter_NewValueFromFilter() got error that source: ${source} exception: ${err.message}`;
//         console.error(errMsg);
//     }
// }



export function Filter_ExtractFilterDefinition(pgridDefinition, filterTitle) {

    //Filter def
    let inFiltersDef = lodash.get(pgridDefinition, "Filter.Filters", []);

    let filtDefFound = inFiltersDef.find(o => {
        if (!("Title" in o)) {

            throw new Error(`Missing title in filter definition ${JSON.stringify(o)}`);
        }
        return o.Title == filterTitle;
    });

    if (filtDefFound == null) {
        throw new Error(`Could not find filter with name ${filterTitle} in pgridDefinition`);
    }

    let filtDef = lodash.clone(filtDefFound);

    return filtDef
}


export function updateTabLinks(url_newVirtualQueryString, source) {
    window.PGridClientDebugMode >= 2 && console.debug(`updateTabLinks() ${url_newVirtualQueryString}       called from: ${source}`);

    if (document) {

        let allHtmlTab = document.querySelectorAll(".app-tabs li");

        let newVQSDict = QueryString_GetKeyValueDict(url_newVirtualQueryString);
        let ckQs = QueryString_GetKeyValuePairs(url_newVirtualQueryString).find(o => o.key.toUpperCase() == "CK");
        let tkQs = QueryString_GetKeyValuePairs(url_newVirtualQueryString).find(o => o.key.toUpperCase() == "TK");


        //Hack to get and update inline set (by ELM) colors on tabs  
        let tabColors = {
            colorNormal: { color: null, backgroundColor: null },
            colorSelected: { color: null, backgroundColor: null }
        }

        for (let i = 0; i < allHtmlTab.length; i++) {
            // allHtmlTab.forEach(htmlTab => {
            let isSelected = null;
            let htmlTab = allHtmlTab[i];
            isSelected = htmlTab.classList.contains("selected");

            tabColors[isSelected ? 'colorSelected' : 'colorNormal'].color = htmlTab.firstChild.style.color;
            tabColors[isSelected ? 'colorSelected' : 'colorNormal'].backgroundColor = htmlTab.style.backgroundColor;
        }

        if (tabColors.colorSelected.color == null) {
            window.PGridClientDebugMode >= 2 && console.error(`Faild to determin selected tab colors`);
        }
        if (tabColors.colorNormal.color == null) {
            window.PGridClientDebugMode >= 2 && console.error(`Faild to determin normal tab colors`);
        }

        for (let i = 0; i < allHtmlTab.length; i++) {
            // allHtmlTab.forEach(htmlTab => {

            let htmlTab = allHtmlTab[i];

            let orgTabLinkElement = lodash.get(htmlTab, `childNodes[0]`, null);
            let orgTabLink = lodash.get(orgTabLinkElement, `href`, null);

            if (orgTabLink != null && orgTabLink.indexOf("/grid") != -1) {

                //Update url

                let [orgTabPath, oldTabSearch] = orgTabLink.split('?');

                let tabQSDict = QueryString_GetKeyValueDict(oldTabSearch);

                let finalQSKyes = {};

                let domCustomerKey = tabQSDict['ck'];
                let domTabKey = tabQSDict['tk'];

                let newVQSDict_Keys = Object.keys(newVQSDict);

                for (let j = 0; j < newVQSDict_Keys.length; j++) {

                    let key = newVQSDict_Keys[j];

                    if (key == 'AccountId' && tabQSDict['tk'] == '33213E10-087F-4A2F-BFBE-3D5A6DF06842') {
                        //FUB skipp this
                    } else if (key in tabQSDict && key == 'ck' || key == 'tk') {
                        //Keep
                        finalQSKyes[key] = tabQSDict[key];
                    }
                    else {
                        finalQSKyes[key] = newVQSDict[key];
                    }
                }

                let newLinkUrl = orgTabPath + QueryString_Sort(Object.keys(finalQSKyes).map(k => `${k}=${finalQSKyes[k]}`).join('&'));

                false && console.debug(`Old orgTabLink: ${orgTabLink}\nOld newLinkUrl: ${newLinkUrl}`);
                orgTabLinkElement.setAttribute('href', newLinkUrl);


                //Update selected
                let isSelected = false;

                // for (let val of entries()) {

                //     if (val == "selected") {
                //     }
                //     isSelected = true;
                // }
                isSelected = htmlTab.classList.contains("selected");

                let shouldBeSelected = false;
                if (domCustomerKey == ckQs.val && domTabKey == tkQs.val) {
                    shouldBeSelected = true;
                }

                if (isSelected && shouldBeSelected == false) {
                    htmlTab.classList.remove("selected");
                    htmlTab.firstChild.style.color = tabColors.colorNormal.color;
                    htmlTab.style.backgroundColor = tabColors.colorNormal.backgroundColor;
                }

                if (isSelected == false && shouldBeSelected) {
                    htmlTab.classList.add("selected");
                    htmlTab.firstChild.style.color = tabColors.colorSelected.color;
                    htmlTab.style.backgroundColor = tabColors.colorSelected.backgroundColor;
                }

            }
        }
        // });
    } else {
        console.warn(`updateTabLinks() document was not defined`);
    }
};

/*
    Try find witch tab is selected
    Extract tabkey, customerKey from tab url
 
*/


export async function clickTabOrLinkEvent(o) {
    //FUB add an delay so selection can update
    window.PGridClientDebugMode >= 3 && console.log(`ReOrLoadInitialCustomerTabKey() addEventListener('click')`, o);
    let url = null;

    if ((typeof o) == "string") {
        url = o;
    } else {
        url = lodash.get(o, "target.attributes['href'].baseURI", null);
    }

    if (url) {
        updateTabLinks('?' + url.split('?')[1], `ReOrLoadInitialCustomerTabKey()`);
        await sleep(750);
        await ReOrLoadInitialCustomerTabKey(null, `ReOrLoadInitialCustomerTabKey():addEventListener('click')`);
    }
}

export async function ReOrLoadInitialCustomerTabKey(initInterv = null, source = 'unknown source') {
    window.PGridClientDebugMode >= 2 && console.debug(`ReOrLoadInitialCustomerTabKey() called initInterv: ${initInterv} source: ${source}`);

    let filterIsLoaded = false;

    let triesCount = 0

    let clickTabEvent = async function (eventOrUrl) {
        //FUB add an delay so selection can update
        window.PGridClientDebugMode >= 2 && console.log(`clickTabEvent() typeof eventOrUrl: ${typeof eventOrUrl}`, eventOrUrl);
        let url = null;

        if ((typeof eventOrUrl) == "string") {
            url = eventOrUrl;
        } else {
            url = lodash.get(eventOrUrl, "target.attributes['href'].baseURI", null);
        }

        if (url) {
            updateTabLinks('?' + url.split('?')[1], `ReOrLoadInitialCustomerTabKey()`);
            await sleep(SUPERWISE_TAB_UPDATE_DELAY);
            await ReOrLoadInitialCustomerTabKey(null, `ReOrLoadInitialCustomerTabKey():addEventListener('click')`);
        }
    }


    while (filterIsLoaded == false) {

        triesCount++;


        if (triesCount % 10 == 0) {
            window.PGridClientDebugMode >= 1 && console.debug(`ReOrLoadInitialCustomerTabKey() loaded == false, triesCount: ${triesCount}`);
        }

        try {


            let selectedHtmlTab = document.querySelectorAll(".app-tabs li.selected");

            let tabLink = null;
            tabLink = lodash.get(selectedHtmlTab, `[0].childNodes[0].baseURI`, null);

            if (tabLink != null && tabLink.indexOf("/grid") != -1) {


                let [, searchPart] = tabLink.split('?');

                let qsKeys = QueryString_GetKeyValueDict(searchPart);

                // Get active tab url 'querySelectorAll(".app-tabs li.selected")

                let domCustomerKey = qsKeys['ck'];
                let domTabKey = qsKeys['tk'];

                let pgridRootNative = document.getElementById('pgrid-root');

                if (pgridRootNative) { //This can be null on initial pageload

                    let domInitCustTabKey = pgridRootNative.getAttribute('data-pgrid-root-initialized-cust-tab-key');

                    let expectedCombinedKey = domCustomerKey + ":" + domTabKey;

                    if (domInitCustTabKey != expectedCombinedKey) {


                        window.PGridClientDebugMode >= 2 && console.debug(`ReOrLoadInitialCustomerTabKey() DEBUG_STEP_PRE_3 data-pgrid-root-initialized-cust-tab-key = cust : tab = InitCustTabkey`);
                        pgridRootNative.setAttribute('data-pgrid-root-initialized-cust-tab-key', expectedCombinedKey);

                        try {

                            if (window.PGridVueStore) {

                                if (window.PGridVueStore.state.pgridSettings.initOfLastQuery_Timestamp) {
                                    //Reset if a grid load is existing
                                    window.PGridClientDebugMode >= 1 && console.debug(`ReOrLoadInitialCustomerTabKey() DEBUG_STEP_PRE_5-1_Reset vue store but customCss`);
                                    await window.PGridVueStore.dispatch("Action_PgridRESET", { type: "filter", source: "pgridUtils.js superwise()" });
                                }

                                window.PGridClientDebugMode >= 2 && console.debug(`ReOrLoadInitialCustomerTabKey() DEBUG_STEP_PRE_6 Call GetPGridDefinition`);
                                let resultPgridDefData = await GetPGridDefinition(domCustomerKey, domTabKey, window.PGridVueStore, `${source} > ReOrLoadInitialCustomerTabKey()`);

                                if (resultPgridDefData) {
                                    try {
                                        await PreFilterRendr(resultPgridDefData, window.PGridVueStore);

                                    } catch (err) {
                                        let errMsg = `> init() await PreFilterRendr() got exception: ${err.message || err}`;
                                        throw new Error(errMsg);
                                    }

                                    try {
                                        await window.PGridVueStore.dispatch('Action_InjectAndRendrFilters', { source: `${source} > ReOrLoadInitialCustomerTabKey` });

                                    } catch (err) {
                                        let errMsg = `> init() await PreFilterRendr() got exception: ${err.message || err}`;
                                        throw new Error(errMsg);
                                    }


                                    filterIsLoaded = true;
                                }
                            }

                            if (initInterv != null) {

                                let selectedHtmlTab2 = document.querySelectorAll(".app-tabs li");
                                selectedHtmlTab2.forEach(liEl => {

                                    window.PGridClientDebugMode >= 3 && console.log(`ReOrLoadInitialCustomerTabKey() addEventListener('click')`);
                                    liEl.childNodes[0].addEventListener('click', clickTabEvent, false);

                                });
                            }

                        } catch (initPgrid_error) {
                            alert("initPgrid_error: " + initPgrid_error);
                        }
                    }
                }
            }

        } catch (err) {
            console.warn(`ReOrLoadInitialCustomerTabKey() while loop got exception: ${err.message}`);
        }

        if (initInterv == null) {
            filterIsLoaded = true;
        } else {
            await sleep(initInterv);
        }
    }
}

/*
*   Load the grid and filter definitions from DB
*/
export async function GetPGridDefinition(customKey, tabKey, context, source = '(no source specified)') {

    let resultPgridDefData = null;

    try {
        const variables = {
            CustomerKey: customKey //container.getAttribute("data-pgrid-root-param-customerkey") //"3B20F0D6-1F7B-40BF-BD85-EB95F7EE8FA0",
            , TabKey: tabKey //container.getAttribute("data-pgrid-root-param-tabkey") // "E6E0E6AD-06BE-42FE-8C8B-D2F62CF7ABC6",
            , GridKey: '00000000-0000-0000-0000-000000000000' // GUID null. If null, will insted be looked up in the SQL procedure.
        }

        try {
            resultPgridDefData = await QueryPGridGetGrid(variables);
        } catch (err) {
            let errMsg = `> GetPGridDefinition() got exception: ${err.message || err}`;
            throw new Error(errMsg);
        }


    } catch (err) {
        let errMsg = `${source} > GetPGridDefinition() got exception: ${err.message || err}`;

        console.error(errMsg);

        if (errMsg.indexOf("> GetPGridDefinition() got exception: > init() QueryPGridGetGrid() got exception: > QueryPGridGetGrid() got error > QueryPGridGetGrid() requestQueryPGridGetGrid got error Failed to fetch") != -1) {
            //This usually happens on F5 reloading, not sure why
            console.error(`alert() muted  source: ${source}`);
        } else if (errMsg.indexOf("Returning 401 azureJwt.js verify() got exception: TokenExpiredError: jwt expired") != -1) {
            console.error("Detected jwt expired, reloading");
            location.reload();
        }

        else {
            alert(errMsg);
            context.commit('GetPGridDefinition', { prop: "isLoading", val: false, source: `${source} -> Action_Stage_Filter()` });
            context.commit('GetPGridDefinition', { prop: "isSaving", val: false, source: `${source} -> Action_Stage_Filter()` });
        }
        // throw (err);
    }

    return resultPgridDefData
}


/*
    Imput: pgridDef
 
    Sets:
        pgridVars
        clientDebugMode
 
        Filters with "Loadin..."
 
*/

export async function PreFilterRendr(pgridDefData, context) {

    try {

        window.PGridClientDebugMode >= 2 && console.debug("DEBUG_STEP_1_InitPGrid_Action_DeclareWindowPGridVueStore");

        if (!pgridDefData || pgridDefData.PGridGetGrid == null || pgridDefData.PGridGetGrid.length == 0) {
            throw "No grid assosiated with current customer and tab"

        }

        let gridTemplate = null;
        if (pgridDefData.PGridGetGrid.length > 1) {
            throw "Multiple grids assosiated with current customer and tab"
        }
        gridTemplate = pgridDefData.PGridGetGrid[0];

        let pgridVars = {
            "CustomerKey": gridTemplate['CustomerKey']
            , "TabKey": gridTemplate['TabKey']
            , "GridKey": gridTemplate['GridKey']
            , "VirtualQueryString": window.location.search //replace(/^\?/, "")
            , "GridName": gridTemplate['GridName']
            , "GridDescriptionSQL": gridTemplate['GridDescription']
            , "GridDefinition": JSON.parse(gridTemplate['GridDefinition'])
            , "GridDescription": null
            , "GridTitle": null
        }

        pgridVars.GridTitle = lodash.get(pgridVars, "GridDefinition.Title", "<no grid title>");
        pgridVars.GridDescription = lodash.get(pgridVars, "GridDefinition.Description", null);

        let clientDebugMode = gridTemplate['ClientDebugMode'];

        //Put pgridVars on the vuexStore
        context.commit('Mutation_UpdateRoot', { prop: 'pgridVars', val: pgridVars, source: 'PreFilterRendr' });

        //Client debug mode
        context.commit('Mutation_UpdatePGridSettings', { prop: 'window_PGridClientDebugMode', val: clientDebugMode, source: 'PreFilterRendr' });

        //Enable PGridPerformanceMode
        context.commit('Mutation_UpdatePGridSettings', { prop: 'window_PGridPerformanceMode', val: context.state.pgridSettings.window_PGridPerformanceMode, source: 'PreFilterRendr' });

        //Set title to Grid name
        let newTitle = `${pgridVars.GridTitle}`;
        if (document.title != newTitle) {
            document.title = newTitle;
        }

        //Load empty filter that show that it is loading...
        {
            let pgridDefs = context.state.pgridVars.GridDefinition;

            let filterNamesAndDS = Filter_ConvertPgridDefinitionToFilterNames(pgridDefs);

            let filtersWithNoDataOrSelection = filterNamesAndDS.map(o => {
                let { PGridFilter: filter } = Filter_ConvertPgridDefinitionToPGridFilter(pgridDefs, o.filtertitle, context.state.pgridDim, "", false /* false => dont load, only show "Loading..." */);
                return filter;
            });

            context.commit('Mutation_FiltersUpdate', { prop: "Filters", val: filtersWithNoDataOrSelection, source: 'PreFilterRendr' });
        }

        false && console.debug("DEBUG_STEP_2_InitPGrid_Mutation_UpdateRoot");

    }
    catch (err) {
        let errMsg = `> PreFilterRendr() got exception: ${err.message || err}`;
        throw new Error(errMsg)
    }
}

export async function handleOrDelayAfterChange_Clear(context, changes, source) {

    try {

        console.warn(`handleOrDelayAfterChange_Clear() was called!! source: ${source}`);

        if (context.state.pgridSettings.delayedAfterChangeActionTimeout != -1) {
            clearTimeout(context.state.pgridSettings.delayedAfterChangeActionTimeout);

            // context.state.pgridSettings.delayedAfterChangeActionTimeout = -1;
            context.commit("Mutation_UpdatePGridSettings", {
                prop: "delayedAfterChangeActionTimeout",
                val: -1,
                source: `${source} -> handleOrDelayAfterChange_Clear()`
            });
        }

        if (context.state.pgridSettings.delayedAfterChangeChanges.length > 0) {


            // context.state.pgridSettings.delayedAfterChangeChanges = [];
            context.commit("Mutation_UpdatePGridSettings", {
                prop: "delayedAfterChangeChanges",
                val: [],
                source: `${source} -> handleOrDelayAfterChange_Clear()`
            });
        }


        // if (context.state.pgridSettings.cellsThatAreReferencingLinkedRangeOverlays.length > 0) {


        //     // context.state.pgridSettings.delayedAfterChangeChanges = [];
        //     context.commit("Mutation_UpdatePGridSettings", {
        //         prop: "cellsThatAreReferencingLinkedRangeOverlays",
        //         val: {},
        //         source: `${source} -> handleOrDelayAfterChange_Clear()`
        //     });
        // }


    } catch (err) {
        let errMsg = `> handleOrDelayAfterChange_Clear() got exception: ${err.message || err}`;
        throw new Error(errMsg);
    }

}


export async function handleOrDelayAfterChange(context, changes, source, chages_fromUrl = window.location.href, stopAtZero = 2) {

    try {

        if (changes == null) {
            changes = []; //Usual case when intend is only to delay AfterChange processing (lika walking the cells);
        }

        window.PGridClientDebugMode >= 2 && console.debug(`handleOrDelayAfterChange() stopAtZero: ${stopAtZero}, changes.length: ${changes.length} source: ${source} chages_fromUrl: ${chages_fromUrl}`);

        if (context.state.pgridSettings.DisableEventsSetDataAtCellNTimes) {
            window.PGridClientDebugMode >= 3 && console.debug(`handleOrDelayAfterChange: halted`);
            return;
        }



        if (context.state.pgridSettings.delayedAfterChangeActionTimeout != -1) {
            clearTimeout(context.state.pgridSettings.delayedAfterChangeActionTimeout);

            context.commit("Mutation_UpdatePGridSettings", {
                prop: "delayedAfterChangeActionTimeout",
                val: -1,
                source: `${source} -> handleOrDelayAfterChange()`
            });
        }

        //A slight delay makes the cell edit more responsive

        if (chages_fromUrl != window.location.href) {
            console.warn(`handleOrDelayAfterChange() Detected changes from another url (chages_fromUrl: ${chages_fromUrl} != window.location.href: ${window.location.href})`);
            return;
        }

        let filteredSavedChanges = context.state.pgridSettings.delayedAfterChangeChanges;

        if (filteredSavedChanges.length == 0 && changes.length == 0) {
            return;
        }

        //Remove old changes with same coordinates


        // console.warn(`Remove old changes: changes = ${JSON.stringify(changes)}`);
        // console.warn(`Remove old changes: filteredSavedChanges = ${JSON.stringify(filteredSavedChanges)}`);

        changes.forEach(newChange => {

            filteredSavedChanges = filteredSavedChanges.filter(oldChange => {
                let keep = true;

                if (newChange[0] == oldChange[0] && newChange[1] == oldChange[1]) {
                    keep = false;
                }
                return keep;
            });
        });


        // console.warn(`Filtered filteredSavedChanges = ${JSON.stringify(filteredSavedChanges)}`);
        // console.warn(`Filtered changes = ${JSON.stringify(changes)}`);

        //Add new changes
        changes.forEach(newChange => {
            filteredSavedChanges.push(newChange);
        });


        let handleDelay = async function (chages_fromUrl) {

            window.PGridClientDebugMode >= 2 && console.debug("handleDelay()");

            if (chages_fromUrl != window.location.href) {
                console.warn(`handleOrDelayAfterChange() handleDelay() Detected changes from another url (chages_fromUrl: ${chages_fromUrl} != window.location.href: ${window.location.href})`);
                return;
            }

            let delayedHotChanges = context.state.pgridSettings.delayedAfterChangeChanges;
            //Must check that not in cell edit mode, to avoid "undefined" poping up into the cell edit field
            let mightBeOpen = true;

            try {
                if (context.state.hotRef != null) {

                    let actEditor = null;
                    if (context.state.hotRef.getActiveEditor != null) {
                        actEditor = context.state.hotRef.getActiveEditor();
                    }

                    if (actEditor != null) {

                        if (actEditor.isOpened != null) {

                            mightBeOpen = actEditor.isOpened();

                            if (mightBeOpen) {
                                console.warn("Detected open state");
                            }
                        }
                    } else {
                        mightBeOpen = false;
                    }
                }
            } catch (err) {
                console.warn("Can this be avoided?");
            }

            if (mightBeOpen) {

                console.warn("Detected open edit mode, don't dispatch");

                await handleOrDelayAfterChange(context, delayedHotChanges, `${changes} -> handleOrDelayAfterChange()`, chages_fromUrl, stopAtZero - 1);

            } else {

                // context.state.pgridSettings.delayedAfterChangeActionTimeout = -1;
                //  clearTimeout(context.state.pgridSettings.delayedAfterChangeActionTimeout);
                context.commit("Mutation_UpdatePGridSettings", {
                    prop: "delayedAfterChangeActionTimeout",
                    val: -1,
                    source: `${source} -> handleOrDelayAfterChange()`
                });

                // context.state.pgridSettings.delayedAfterChangeChanges = [];
                context.commit("Mutation_UpdatePGridSettings", {
                    prop: "delayedAfterChangeChanges",
                    val: [],
                    source: `${source} -> handleOrDelayAfterChange()`
                });


                if (delayedHotChanges.length > 0) {
                    false && console.debug("Dispatching afterChanges changes " + JSON.stringify(delayedHotChanges));
                    await context.dispatch("Action_HOT_ApplyGridChange", {
                        hotChanges: delayedHotChanges,
                        source: `${source} -> handleOrDelayAfterChange()`
                    });
                }
            }
        }


        // context.state.pgridSettings.delayedAfterChangeChanges = filteredSavedChanges;
        context.commit("Mutation_UpdatePGridSettings", {
            prop: "delayedAfterChangeChanges",
            val: filteredSavedChanges,
            source: `${source} -> handleOrDelayAfterChange()`
        });

        // context.state.pgridSettings.delayedAfterChangeActionTimeout = setTimeout(handleDelay, context.state.pgridSettings.delayedAfterChangeMiliseconds);
        let delayedAfterChangeActionTimeout = setTimeout(function () { handleDelay(chages_fromUrl) }, context.state.pgridSettings.delayedAfterChangeMiliseconds);
        context.commit("Mutation_UpdatePGridSettings", {
            prop: "delayedAfterChangeActionTimeout",
            val: delayedAfterChangeActionTimeout,
            source: `${source} -> handleOrDelayAfterChange()`
        });

    } catch (err) {
        let errMsg = `> handleOrDelayAfterChange() got exception: ${err.message || err}`;
        throw new Error(errMsg);
    }
}

export function spliceSplitOLD(str, index, count, add) {
    let ret = null;
    var ar = str.split('');
    ar.splice(index, count, add);
    ret = ar.join('');
    return ret;
}

export function spliceSplit(str, index, count, add) {
    let ret = [str.slice(0, index), add, str.slice(index)].join('')
    return ret;
}

//*FUB temporary ineffective
export function safeifyHtmlData(value) {
    let ret = null;

    var escaped = value; //Handsontable.helper.stringify(value);
    // escaped = strip_tags(escaped, '<em><b><strong><a><big>'); //be sure you only allow certain HTML tags to avoid XSS threats (you should also remove unwanted HTML attributes)
    ret = escaped;
    return ret;
}

export function escapeRegExp(stringToGoIntoTheRegex) {
    return stringToGoIntoTheRegex.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

export function beautifyErrorMessage(uglyMessage) {
    let prettyMessage = uglyMessage;

    let sqlStart = prettyMessage.indexOf("SqlContext Error.");

    if (sqlStart != -1) {
        prettyMessage = prettyMessage.slice(sqlStart);

        let atCallee = prettyMessage.indexOf("at _callee");
        if (atCallee != -1) {
            prettyMessage = prettyMessage.slice(0, atCallee);
        }
    }

    return prettyMessage;
}

export function AddInputBarClasses(context, y, x, cssClass) {

    let cellKey = `${y}:${x}`;
    if (!(cellKey in context.state.pgridSettings.inputBar_DirtyHighlights)) {
        if (context.state.hotRef) {
            let hotRef = context.state.hotRef;


            let hotCell = hotRef.getCell(y, x, true);
            let allreadyExists = false;

            if (hotCell != undefined /* might happen, actually*/ && !allreadyExists) {
                hotCell.classList.add(cssClass);
            }


            context.commit("Mutation_UpdatePGridSettings", {
                prop: "inputBar_DirtyHighlights",
                op: "addkey",
                key: cellKey,
                val: true,
                source: `AddInputBarClasses()`
            });
        }
    }
}

export function RemoveInputBarClasses(context) {

    let cellKeys = Object.keys(context.state.pgridSettings.inputBar_DirtyHighlights);

    if (cellKeys.length > 0) {

        if (context.state.hotRef) {
            let hotRef = context.state.hotRef;

            for (let i = 0; i < cellKeys.length; i++) {

                let cellKey = cellKeys[i];
                let [y, x] = cellKey.split(":");
                let hotCell = hotRef.getCell(y, x, true);

                if (hotCell && hotCell.classList) {

                    for (let j = 0; j < hotCell.classList.length; j++) {
                        let c = hotCell.classList[j];
                        if (c.indexOf("pg-inputbar") != -1) {
                            hotCell.classList.remove(c);
                        }
                    }
                }
            }
        }

        context.commit("Mutation_UpdatePGridSettings", {
            prop: "inputBar_DirtyHighlights",
            val: {},
            source: `RemoveInputBarClasses()`
        });
    }
}

export function RecurseHeighlightRefCells(context, y, x, depth = 0) {

    let cellRefKey = `${y}:${x}`;
    let cellsThatAreReferencedKeyList = Object.keys(context.state.pgridSettings.cellsThatAreReferenced);

    for (let k = 0; k < cellsThatAreReferencedKeyList.length; k++) {
        let searchRefKey = cellsThatAreReferencedKeyList[k];

        let searchRefs = context.state.pgridSettings.cellsThatAreReferenced[searchRefKey];

        let found = false;
        for (let i = 0; i < searchRefs.length; i++) {
            if (searchRefs[i] == cellRefKey) {
                found = true;
            }
        }

        if (found) {
            let [refY, refX] = searchRefKey.split(":");
            AddInputBarClasses(context, refY, refX, "pg-inputbar-refcell-" + depth);

            //Recursive call
            RecurseHeighlightRefCells(context, refY, refX, depth + 1);
        }
    }

}


export function CheckAttestRequirements(attestRequired, attestStatusOK, source = null) {

    let ret = { ok: true, tooltipMsg: null };

    if (attestRequired && !attestStatusOK) {
        ret.ok = false;
        ret.tooltipMsg = "Attestering saknas för sparaning eller publicering";
    }

    // console.debug(`ConfirmAttestRequirements() source ${source}: ret: ${JSON.stringify(ret)}`);

    return ret;
}

// export function CheckSaveButtonEnabledRequirements(ShowSaveButton, isPublished, source = null) {

//     let ret = { hasMissingAttest: false, tooltipMsg: null };

//     if (ShowSaveButton == "true") {
//         ret.ok = "true";
//     }
//     else if (ShowSaveButton == "auto") {
//         ret.ok = !isPublished;
//         ret.tooltipMsg = "Rapporten kan inte sparas efter publicering"
//     }

//     // console.debug(`CheckSaveButtonEnabledRequirements() source ${source}: ret: ${JSON.stringify(ret)}`);

//     return ret;
// }

// export function CalculateEnableSaveButtons(context) {

//     if (window.PGridClientDebugMode >= 3) {
//         console.log("\n\n****** /////////////// CalculateEnableSaveButtons() /////////////////***********\n")
//     }

//     let ret = { disable: false, tooltipMsg: [] };

//     let saveEnabTest = CheckSaveButtonEnabledRequirements(
//         context.state.pgridFilter.ShowSaveButton,
//         context.state.pgridSettings.isPublished,
//         "CalculateEnableSaveButtons()"
//     );

//     if (!saveEnabTest.ok) {
//         ret.disable = true;
//         ret.tooltipMsg.push(saveEnabTest.tooltipMsg);
//     }

//     if (!ret.disable) {
//         //If not ready disabled
//         let attestTest = CheckAttestRequirements(
//             context.state.pgridSettings.attestRequired,
//             context.state.pgridSettings.attestStatusOK,
//             "CalculateEnableSaveButtons()"
//         );

//         if (!attestTest.ok) {
//             ret.disable = true;
//             ret.tooltipMsg.push(attestTest.tooltipMsg);
//         }
//     }

//     return !ret.disable;
// }


export function CheckSavedFactRequirements(hasUnsavedFactChangesForUrl, source = null) {

    let ret = { hasUnsavedFacts: false, tooltipMsg: null };

    window.PGridClientDebugMode >= 2 && console.debug(`CheckSavedFactRequirements() source ${source}`);

    if (hasUnsavedFactChangesForUrl != null) {
        ret.tooltipMsg = "Det finns ej sparade faktaändringar i mallen";
        ret.hasUnsavedFacts = true;
    }

    return ret;
}


export function ConfirmNavigation(context, source, confirmMsg) {

    window.PGridClientDebugMode >= 2 && console.debug(`urlBeforeElmUpdate_searchPart() source ${source}`);

    if (!context) {
        console.warn(`ConfirmNavigation() context is null`);
        return true
    }

    let warnUnsavedFacts_BeforeContinue = true;

    let checkUnsavedFacts = CheckSavedFactRequirements(context.state.pgridSettings.hasUnsavedFactChangesForUrl);

    let finalComfirmMsg = [];


    if (checkUnsavedFacts.hasUnsavedFacts) {

        if (checkUnsavedFacts.tooltipMsg) {
            finalComfirmMsg.push(checkUnsavedFacts.tooltipMsg)
        }

        finalComfirmMsg.push(confirmMsg);

        warnUnsavedFacts_BeforeContinue = confirm(finalComfirmMsg.join(`\n\n`));

        // if (warnUnsavedFacts_BeforeContinue) {
        //     context.commit("Mutation_UpdatePGridSettings", {
        //         prop: "hasUnsavedFactChangesForUrl",
        //         val: null,
        //         source: `${source} -> ConfirmNavigation()`
        //     });
        // }
    }

    // if (CheckSavedFactRequirements(context.state.pgridSettings.hasUnsavedFactChangesForUrl).hasUnsavedFacts) {

    //     warnUnsavedFacts_BeforeContinue = confirm("Vill du byta flik utan att spara ändrade värden?");

    //     // if (warnUnsavedFacts_BeforeContinue) {
    //     //     context.commit("Mutation_UpdatePGridSettings", {
    //     //         prop: "hasUnsavedFactChangesForUrl",
    //     //         val: null,
    //     //         source: `${source} -> ConfirmNavigation()`
    //     //     });
    //     // }
    // }

    return warnUnsavedFacts_BeforeContinue;
}

var charIsAlpha = function (ch) {
    return typeof ch === "string" && ch.length === 1
        && (ch >= "a" && ch <= "z" || ch >= "A" && ch <= "Z");
}
var charIsNum = function (ch) {
    return typeof ch === "string" && ch.length === 1
        && (ch >= "0" && ch <= "9");
}


export function replaceAllDynAddr(lr, pgridDataDyn, containsDynAddr) {

    // Example: https://regex101.com/r/C48Ed0/2
    // const LABEL_PGRID_REF_3_CELL_EXTRACT_REGEXP = /(?<!\d)((\{[^}]*\}){0,1}(([A-Z]+|\[[^\[]+\])(\d+|\[[^\[]+\])|R\d+C\d+))(?!C)/gm; //Matches dynamic chuncs, not A1 example ={foobar}G[anko1]+{bar}[fast1]1+{baz}[FOO][admi1]+G[proj1]+G[220]+G[prod15]+G[prod16]+G[prod17]+G[arbe1]+G[ovri1]+G[inta1]+G[utankp1]

    const LABEL_PGRID_REF_3_CELL_EXTRACT_REGEXP = /((\{[^}]*\}){0,1}(([A-Z]+|\[[^\[]+\])(\d+|\[[^\[]+\])|R\d+C\d+))(?!C)/gm; //Matches dynamic chuncs, (and also A1) example ={foobar}G[anko1]+{bar}[fast1]1+{baz}[FOO][admi1]+G[proj1]+G[220]+G[prod15]+G[prod16]+G[prod17]+G[arbe1]+G[ovri1]+G[inta1]+G[utankp1]
    const LABEL_EXCEL_A1_REF_CELL_EXTRACT_REGEXP = /^[A-Za-z]+[0-9]+$/; //Matches A1 or AZ4711
    const LABEL_PGRID_REF_3_CELL_EXTRACT_REGEXP_IS_R0C0 = /R[\-\+]?\d+C[\-\+]*\d+/gm; //Matches R1C1 or R+1C-1

    let dynAddrReplaced = containsDynAddr.replace(LABEL_PGRID_REF_3_CELL_EXTRACT_REGEXP, a => {

        /* Pre-check is to avid slow RE when possible (does not seem to work...) */
        if (/*charIsAlpha(a[0]) && charIsNum(a[a.length - 1]) && */LABEL_EXCEL_A1_REF_CELL_EXTRACT_REGEXP.exec(a)) {
            return a; //ignore this normal "A1" address
        }

        if (LABEL_PGRID_REF_3_CELL_EXTRACT_REGEXP_IS_R0C0.exec(a)) {
            if (a.indexOf("{") == -1 && a.indexOf("}") == -1) {
                //Don´t extract DynAddr when a R0C0 type but not with an external reference {LRName}[R0C0]
                false && console.debug(`DEBUG a: ${a} Don´t extract DynAddr when a R0C0 type but not with an external reference {LRName}[R0C0] `);
                return a;
            }
        }

        let extAdd = extractDynAddr(lr, pgridDataDyn, a);

        return extAdd.labelA1;
    });


    return dynAddrReplaced;

}

export function extractDynAddr(lr, pgridDataDyn, dynAddr, relativStartAddr = null) {

    const LABEL_PGRID_DIMVAL_DIMVAL_CELL_EXTRACT_REGEXP = /^[\[]([^\]]*)[\]][\[]([^\]]*)[\]]$/;
    const LABEL_PGRID_A_DIMVAL_CELL_EXTRACT_REGEXP = /^([A-Z]+)[\][\[]([^\]]*)[\]]$/;
    const LABEL_PGRID_DIMVAL_1_CELL_EXTRACT_REGEXP = /^[\][\[]([^\]]*)[\]](\d+)$/;

    const LABEL_PGRID_REF_REST = /^[\{]([^\}]*)[\}](.*)$/; //Matches {foobarLR}G[anko1]


    let thisOrExtLR = lr;

    let ret = { y: null, x: null, labelA1: null }

    let ref_name_final = lr.name;
    let ref_corr_final = { y: lr.y, x: lr.x };


    //Has references to other epgrids in the grid
    if (dynAddr.indexOf('{') != -1 && dynAddr.indexOf('}') != -1) {

        //Has ref to other epivot in table

        let matchRefRest = LABEL_PGRID_REF_REST.exec(dynAddr);

        let [_, ref_name, dynAddr_rest] = matchRefRest;

        ref_name_final = ref_name;

        dynAddr = dynAddr_rest;

        // let foundLRcorr = findLRCoordinate(pgridDataDyn, ref_name);
        let foundLRcorr = PGridMatrices.Get_LRsFromTable(pgridDataDyn, { onlyThisLR: ref_name, source: `extractDynAddr() name: ${ref_name}` });

        ref_corr_final = foundLRcorr;
    }


    let foundLRMeta = lodash.get(pgridDataDyn[ref_corr_final.y][ref_corr_final.x], "Meta", null);
    thisOrExtLR = {
        name: ref_name_final,
        y: ref_corr_final.y,
        x: ref_corr_final.x,
        yLength: foundLRMeta.yLRLength,
        xLength: foundLRMeta.xLRLength
    };


    if (!foundLRMeta) {
        throw new Error("foundLRMeta is null")
    }

    dynAddr = dynAddr.replaceAll('[<<GRID_TABLE_EDGE_Y>>]', pgridDataDyn.length);
    dynAddr = dynAddr.replaceAll('[<<GRID_TABLE_EDGE_X>>]', pgridDataDyn[0].length);
    dynAddr = dynAddr.replaceAll('[<<LR_LENGTH_Y>>]', thisOrExtLR.yLength);
    dynAddr = dynAddr.replaceAll('[<<LR_LENGTH_X>>]', thisOrExtLR.xLength);
    dynAddr = dynAddr.replaceAll('[<<LR_LENGTH_Y_MINUS_ONE>>]', thisOrExtLR.yLength - 1);
    dynAddr = dynAddr.replaceAll('[<<LR_LENGTH_X_MINUS_ONE>>]', thisOrExtLR.xLength - 1);
    dynAddr = dynAddr.replaceAll('[<<LR_MAX_Y>>]', thisOrExtLR.y + thisOrExtLR.yLength);
    dynAddr = dynAddr.replaceAll('[<<LR_MAX_X>>]', thisOrExtLR.x + thisOrExtLR.xLength);


    if (relativStartAddr) {

        //No usecase as R0C0(a):R10C3(b) b is not relative to a, but this.y|x
        if (false) {
            dynAddr = dynAddr.replaceAll('[<<LR_DELTA_LENGTH_Y>>]', thisOrExtLR.yLength - (relativStartAddr.y - thisOrExtLR.y));
            dynAddr = dynAddr.replaceAll('[<<LR_DELTA_LENGTH_X>>]', thisOrExtLR.xLength - (relativStartAddr.x - thisOrExtLR.x));
        }
    }

    let matchResDimDim = LABEL_PGRID_DIMVAL_DIMVAL_CELL_EXTRACT_REGEXP.exec(dynAddr);
    let matchResADim = LABEL_PGRID_A_DIMVAL_CELL_EXTRACT_REGEXP.exec(dynAddr);
    let matchResDim1 = LABEL_PGRID_DIMVAL_1_CELL_EXTRACT_REGEXP.exec(dynAddr);

    let searchForY = (rowDimKey) => {
        //Search for Y (row) dimension key value index
        // if (rowDimKey) {
        //     throw new Error(`searchForX() rowDimKey is not defined`);
        // }
        let ret = { foundY: null, debug_searchedMetaDimVal_Cells: [] };


        for (let ySearch = thisOrExtLR.y; ySearch < thisOrExtLR.y + thisOrExtLR.yLength; ySearch++) {

            let xSearch = thisOrExtLR.x - 1;
            let cell = pgridDataDyn[ySearch][xSearch];
            if (cell) {
                let dimKeyVal = lodash.get(cell, "Meta.DimVal", null);

                if (dimKeyVal != null) {
                    if (rowDimKey == dimKeyVal) {
                        ret.foundY = ySearch;
                    } else {
                        if (window.PGridClientDebugMode >= 1) {
                            ret.debug_searchedMetaDimVal_Cells.push(`[${ySearch}:${xSearch}]${dimKeyVal}`);
                        }
                    }
                }
            }
        }

        // if (foundY == null) {
        //     throw new Error(`Could not find rowDimKey '${rowDimKey}' in pivot  in LR ${lr.name}`);
        // }
        return ret;
    }

    let searchForX = (colDimKey) => {
        //Search for X (column) dimension key value index

        // if (colDimKey) {
        //     throw new Error(`searchForX() colDimKey is not defined`);
        // }

        let ret = { foundY: null, debug_searchedMetaDimVal_Cells: [] };

        for (let xSearch = thisOrExtLR.x; xSearch < thisOrExtLR.x + thisOrExtLR.xLength; xSearch++) {

            let ySearch = thisOrExtLR.y - 1;
            let cell = pgridDataDyn[ySearch][xSearch];
            if (cell) {
                let dimKeyVal = lodash.get(cell, "Meta.DimVal", null);

                if (dimKeyVal != null) {
                    if (colDimKey == dimKeyVal) {
                        ret.foundX = xSearch;
                    } else {
                        if (window.PGridClientDebugMode >= 1) {
                            ret.debug_searchedMetaDimVal_Cells.push(`[${ySearch}:${xSearch}]${dimKeyVal}`);
                        }
                    }
                }
            }
        }

        // if (foundX == null) {
        //     throw new Error(`Could not find colDimKey '${colDimKey}' in LR ${lr.name}`);
        // }
        return ret;
    }


    if (matchResDimDim) {

        // if (window.PGridClientDebugMode >= 3) {
        //     console.debug(`DEBUGGING ${dynAddr}: matchResDimDim`);
        // }

        //[row dim key][col dim key]

        let [matchTxt, colDimKey, rowDimKey] = matchResDimDim;

        if (!colDimKey || !rowDimKey) {
            console.warn(`Linked Range (${lr.name}) found match in matchResDimDim, but ${JSON.stringify({ colDimKey: colDimKey, rowDimKey: rowDimKey })}`);
        }

        let foundY = searchForY(rowDimKey);
        let foundX = searchForX(colDimKey);

        if (!foundY.foundY) {
            let errMsg = `extractDynAddr() matchResDimDim: LR (${lr.name}) searchForY(rowDimKey) '${rowDimKey}' (from: '${dynAddr}') was not found in any cells in LR:s 'Meta.DimVal' metadata`;
            if (window.PGridClientDebugMode >= 3) {
                errMsg += ` - no match in "${foundY.debug_searchedMetaDimVal_Cells.join(',')}".`;
            }
            throw new Error(errMsg);
        }
        if (!foundX.foundX) {
            let errMsg = `extractDynAddr() matchResDimDim: LR (${lr.name}) searchForX(colDimKey) '${colDimKey}' (from: '${dynAddr}') was not found in any cells in LR:s 'Meta.DimVal' metadata`;
            if (window.PGridClientDebugMode >= 3) {
                errMsg += ` - no match in "${foundX.debug_searchedMetaDimVal_Cells.join(',')}".`;
            }
            throw new Error(errMsg);
        }


        let gridY = foundY.foundY;
        let gridX = foundX.foundX;

        let labelA1 = toLabel({ index: gridY }, { index: gridX });

        ret.y = gridY;
        ret.x = gridX;
        ret.labelA1 = labelA1;

    } else if (matchResADim) {

        false && console.debug(`DEBUGGING ${dynAddr}: matchResADim`);

        //[row dim key][col dim key]

        let [matchTxt, colLabel, rowDimKey] = matchResADim;

        let foundY = searchForY(rowDimKey);

        // foundX = searchForX(colDimKey);
        if (!foundY.foundY) {
            let errMsg = `extractDynAddr() matchResADim: LR (${lr.name}) searchForY(rowDimKey) '${rowDimKey}' (from: '${dynAddr}') was not found in any cells in LR:s 'Meta.DimVal' metadata`;
            if (window.PGridClientDebugMode >= 3) {
                errMsg += ` - no match in "${foundY.debug_searchedMetaDimVal_Cells.join(',')}".`;
                throw new Error(errMsg);
            }
        }

        let gridY = foundY.foundY;
        let gridX = columnLabelToIndex(colLabel);

        if (gridX == -1) {
            throw new Error(`matchResADim faild to find columnLabelToIndex() from ${colLabel}`);
        }

        let labelA1 = toLabel({ index: gridY }, { index: gridX });

        ret.y = gridY;
        ret.x = gridX;
        ret.labelA1 = labelA1;


    } else if (matchResDim1) {

        false && console.debug(`DEBUGGING ${dynAddr}: matchResDim1`);

        //[row dim key][col dim key]

        let [matchTxt, colDimKey, rowLabel] = matchResDim1;

        let foundY = null;

        foundX = searchForX(colDimKey);
        // foundX = searchForX(colDimKey);

        let gridY = rowLabelToIndex(rowLabel);
        let gridX = foundX;

        if (gridY == -1) {
            throw new Error(`matchResADim faild to find rowLabelToIndex() from ${rowLabel} in LR ${lr.name}`);
        }


        let labelA1 = toLabel({ index: gridY }, { index: gridX });

        ret.y = gridY;
        ret.x = gridX;
        ret.labelA1 = labelA1;


    } else {
        //R0C0 or A1 type
        false && console.debug(`DEBUGGING ${dynAddr}: R0C0 or A1 type`);

        if (dynAddr == "R0C1") {
            console.debug("Stop me");
        }
        if (dynAddr == "R0C+1") {
            console.debug("Stop me+");
        }

        let srcCell =
            [
                {
                    index: thisOrExtLR.y,
                },
                {
                    index: thisOrExtLR.x,
                },
            ];


        let extLabel = extractLabel(dynAddr, srcCell);

        if (extLabel == null) {
            throw new Error(`REF error for addr '${dynAddr}'`);
        }


        if (extLabel != null) {

            let gridY = extLabel[0].index;
            let gridX = extLabel[1].index;

            ret.y = gridY;
            ret.x = gridX;
            ret.labelA1 = toLabel({ index: gridY }, { index: gridX });
        }
    }

    return ret;

}


/* FUB Compensates for a bug in the the Fabric-UI implementation for panel */
export function hideGhostPanelHosts() {

    var elements = document.getElementsByClassName('ms-PanelHost');
    for (let i = 0; i < elements.length; i++) {

        if (i != elements.length - 1) { // All but last
            let ovlEls = elements[i].querySelectorAll('.ms-Overlay.is-visible');
            for (let j = 0; j < ovlEls.length; j++) {
                ovlEls[j].classList.remove("is-visible");
            }
        }
    }
}

export function InvertObjArr(in_ObjArray) {
    let retObjArr_Reversed = {};
    let in_ObjArray_Keys = Object.keys(in_ObjArray);
    for (let i = 0; i < in_ObjArray_Keys.length; i++) {
        let in_Obj_item = in_ObjArray[in_ObjArray_Keys[i]];

        for (let j = 0; j < in_Obj_item.length; j++) {

            let ref = in_Obj_item[j];

            if (!(ref in retObjArr_Reversed)) {
                retObjArr_Reversed[ref] = [];
            }

            if (retObjArr_Reversed[ref].indexOf(in_ObjArray_Keys[i]) == -1) {
                retObjArr_Reversed[ref].push(in_ObjArray_Keys[i]);
            }
        }
    }

    return retObjArr_Reversed;
}


export function SumAllRowForAxis(pgridLR, pgridAxisType) { //Calculete keywordsDB.COLUMNS_ALL_LEVELS_ROW_COUNT or for ROW
    let countAllRow = 0;
    let currAxisLvlDataSet = lodash.get(pgridLR.axisData, pgridAxisType, []);
    for (let l = 0; l < currAxisLvlDataSet.length; l++) {
        countAllRow = countAllRow + (l + 1) * currAxisLvlDataSet[l].DataSet.length;
    }
    return countAllRow;
}


function DebugDetectTableChanges_FindCells(pgridTable_Recurse_Before_Obj, DimValY, DimValX) {

    // let retFound = false;
    let found_cells = [];


    let pgridTable_Recurse_Before_In = null;


    pgridTable_Recurse_Before_In = pgridTable_Recurse_Before_Obj;


    let y_sb_col = 0;
    let x_sb_col = 0;
    let found_sb_col = -1;

    let y_sb_row = 0;
    let x_sb_row = 0;
    let found_sb_row = -1;


    search_before_loop_col:
    for (y_sb_col = 0; y_sb_col < pgridTable_Recurse_Before_In.length; y_sb_col++) {
        for (x_sb_col = 0; x_sb_col < pgridTable_Recurse_Before_In[0].length; x_sb_col++) {

            if (
                lodash.get(pgridTable_Recurse_Before_In[y_sb_col][x_sb_col], "Meta.DimVal", null) == "HyresIntakt1-Col9"
            ) {
                found_sb_col = x_sb_col;
                break search_before_loop_col;
            }
        }
    }
    search_before_loop_row:
    for (y_sb_row = 0; y_sb_row < pgridTable_Recurse_Before_In.length; y_sb_row++) {
        for (x_sb_row = 0; x_sb_row < pgridTable_Recurse_Before_In[0].length; x_sb_row++) {

            if (
                lodash.get(pgridTable_Recurse_Before_In[y_sb_row][x_sb_row], "Meta.DimVal", null) == "HyresIntakt1-Garage-2001"
            ) {
                found_sb_row = y_sb_row;

                let cellData = pgridTable_Recurse_Before_In[y_sb_row][found_sb_col];

                if (cellData != undefined) {
                    let pushCell = JSON.parse(JSON.stringify(cellData));
                    found_cells.push({ CellData: pushCell, y: y_sb_row, x: found_sb_col });
                }

                break search_before_loop_row;
            }

        }
    }

    // if (found_sb_row != -1 && found_sb_col != -1) {
    //     retFound = true;
    // }

    return found_cells;
}

export function DebugDetectTableChanges(source, tableAfterIn, pgridTable_Recurse_Before_In = null) {

    if (!("PGridDTC" in window)) {
        window.PGridDTC = { FindChangeAfterFunc: null, FindChangeAfterBeforeFunc: null, DimValY: null, DimValX: null, PropNameBefore: null, PropNameAfter: null, PropValBefore: null, PropValAfter: null, CallCount: 0 };
    }

    if ("CallStopAt" in window.PGridDTC) {
        if (window.PGridDTC.CallStopAt == window.PGridDTC.CallCount) {
            console.warn(`DebugDetectTableChanges() CallStopAt (${window.PGridDTC.CallStopAt} == ${window.PGridDTC.CallStopAt}) foundCellsAfter cells. source: ${source}`);
        }
    }

    let foundCellBefore_WasFound = false;
    let foundCellBefore = null;
    let foundPropValBefore = null;
    let foundCellAfter_WasFound = false;
    let foundPropValAfter = null;

    if ("FindChangeAfterFunc" in window.PGridDTC && window.PGridDTC.FindChangeAfterFunc) {

        let FindChangeAfterFunc_Ret = window.PGridDTC.FindChangeAfterFunc(tableAfterIn);

        if (FindChangeAfterFunc_Ret) {
            console.warn(`DebugDetectTableChanges() FindChangeAfterFunc foundCellsAfter cells. CallCount: ${window.PGridDTC.CallCount}, source: ${source}`);
            window.PGridDTC.FindChangeAfterFunc = null;
        }
    }

    if ("FindChangeAfterBeforeFunc" in window.PGridDTC && window.PGridDTC.FindChangeAfterBeforeFunc) {

        let FindChangeAfterBeforeFunc_Ret = window.PGridDTC.FindChangeAfterBeforeFunc(tableAfterIn, pgridTable_Recurse_Before_In);

        if (FindChangeAfterBeforeFunc_Ret) {
            console.warn(`DebugDetectTableChanges() FindChangeAfterBeforeFunc foundCellsAfter cells. CallCount: ${window.PGridDTC.CallCount}, source: ${source}`);
            // window.PGridDTC.FindChangeAfterBeforeFunc = null;
        }
    }


    if (pgridTable_Recurse_Before_In != null) {
        if (window.PGridDTC.DimValY != null
            && window.PGridDTC.DimValX != null
        ) {

            foundPropValBefore = false;

            let foundCellsBefore = DebugDetectTableChanges_FindCells(
                pgridTable_Recurse_Before_In
                , window.PGridDTC.DimValY
                , window.PGridDTC.DimValX
            );

            if (foundCellsBefore.length > 1) {
                console.warn(`DebugDetectTableChanges() found multiple (${foundCellsBefore.length}) foundCellsAfter cells. source: ${source}`);
            }

            if (foundCellsBefore.length == 1) {

                foundCellBefore_WasFound = true;

                let examinCell = foundCellsBefore[0].CellData;

                foundCellBefore = examinCell;

                let examinePropVal = lodash.get(examinCell, window.PGridDTC.PropNameBefore, `<nothing>`);

                if (examinePropVal == window.PGridDTC.PropValBefore) {
                    foundPropValBefore = true;
                }
            }
        }
    }


    if (tableAfterIn != null) {
        if (window.PGridDTC.DimValY != null
            && window.PGridDTC.DimValX != null
        ) {

            foundPropValAfter = false;

            let foundCellsAfter = DebugDetectTableChanges_FindCells(
                tableAfterIn
                , window.PGridDTC.DimValY
                , window.PGridDTC.DimValX
            );

            if (foundCellsAfter.length > 1) {
                console.warn(`DebugDetectTableChanges()  found multiple (${foundCellsAfter.length}) foundCellsAfter cells. source: ${source}`);
            }


            if (foundCellsAfter.length == 1) {

                let examinCell = foundCellsAfter[0].CellData;
                let examinCell_Y = foundCellsAfter[0].y;
                let examinCell_X = foundCellsAfter[0].x;

                let examinePropVal = lodash.get(examinCell, window.PGridDTC.PropNameAfter, `<nothing>`);


                if (examinePropVal == window.PGridDTC.PropValAfter) {
                    foundPropValAfter = true;
                }


                if (foundCellBefore_WasFound) {

                    let cellDiff = Diff_PgridData(foundCellBefore, examinCell);

                    if (Object.keys(cellDiff.added).length > 0 || Object.keys(cellDiff.deleted).length > 0 || Object.keys(cellDiff.updated).length > 0) {
                        // console.debug(`DebugDetectTableChanges()[${examinCell_Y}][${examinCell_X}] ${source} #${window.PGridDTC.CallCount} Diff:\n${JSON.stringify(cellDiff, null, 2)}`);
                        console.debug(`DebugDetectTableChanges()[${examinCell_Y}][${examinCell_X}] ${source} #${window.PGridDTC.CallCount} CellData:\n${JSON.stringify(examinCell, null, 2)}. source: ${source}`);
                    }

                }


                if (foundPropValBefore == null) {
                    if (foundPropValAfter) {
                        console.warn(`\n\nDebugDetectTableChanges() ****** Found after match in ${source} #${window.PGridDTC.CallCount}. source: ${source}\n\n`);
                    }
                } else {

                    //Requires before match
                    if (foundPropValBefore && foundPropValAfter) {
                        console.warn(`\n\nDebugDetectTableChanges() ****** Found before and after match in ${source} #${window.PGridDTC.CallCount}. source: ${source}\n\n`);
                    }
                }
            }
        }
    }

    window.PGridDTC.CallCount++;
}

export function extractCellLookupValuesFromDS(context, lookupDSName) {

    let ret = [];

    let srcDs = context.state.pgridDim[lookupDSName];


    if (srcDs) {
        for (let i = 1; i < srcDs.length; i++) {

            let row = srcDs[i];
            ret.push(row[5]); //FUB
        }
    }
    return ret;
}

export function removeClassesByPrefix(el, prefix) {
    if (el == null) {
        console.error("el == null");
    } else {
        for (var i = el.classList.length - 1; i >= 0; i--) {
            if (el.classList[i].startsWith(prefix)) {
                el.classList.remove(el.classList[i]);
            }
        }
    }
}

export function mobileCheck() {
    let check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};

function truncString(str, max, add = '...') {
    return (typeof str === 'string' && str.length > max ? str.substring(0, max) + add : str);
};


export function HandlePlannicaGridUrlUpdates(newUrl) {


    let context = lodash.get(window, "PGridVueStore", null);
    if (context == null) {
        console.warn("HandlePlannicaGridUrlUpdates(): context == null");
        return;
    }

    window.PGridClientDebugMode >= 3 && console.debug(`HandlePlannicaGridUrlUpdates(): BEGIN newUrl: ${JSON.stringify(newUrl)}`);

    if (window.location.href.indexOf("/grid") != -1) {
        let asyncLoadKeys = (async () => {
            try {

                let newUrl_SearchPart = newUrl.match(/(\?.*)/)[1]; // url.split('?');

                window.PGridClientDebugMode >= 3 && console.debug(`HandlePlannicaGridUrlUpdates(): searchPart ${JSON.stringify(newUrl_SearchPart)}`);

                if (newUrl_SearchPart == null) {

                    console.warn("HandlePlannicaGridUrlUpdates(): searchPart == null");

                    return;
                }



                // if (ConfirmNavigation(context)) {
                let urlBeforeElmUpdate_tabIdx = -1;
                let urlBeforeElmUpdateTabs = new Array(...document.querySelectorAll(".app-tabs li"));
                let urlBeforeElmUpdateTabs_Selected = urlBeforeElmUpdateTabs.find((o, idx) => {
                    let ret = false;
                    if (o.className.indexOf("selected") != -1) {
                        ret = true;
                        urlBeforeElmUpdate_tabIdx = idx;
                    }
                    return ret;
                });
                let urlBeforeElmUpdate = null;
                let urlBeforeElmUpdate_searchPart_Match = null;
                let urlBeforeElmUpdate_searchPart = null;

                urlBeforeElmUpdate = lodash.get(urlBeforeElmUpdateTabs_Selected, "childNodes[0].href", null);
                // = urlBeforeElmUpdateNode.childNodes[0].href
                if (urlBeforeElmUpdate == null) {
                    console.warn("HandlePlannicaGridUrlUpdates(): urlBeforeElmUpdate == null");
                } else {
                    // if (urlBeforeElmUpdate.indexOf("?") != -1) {
                    // urlBeforeElmUpdate_searchPart = urlBeforeElmUpdate.split('?')[1];
                    urlBeforeElmUpdate_searchPart_Match = urlBeforeElmUpdate.match(/(\?.*)/);

                    if (urlBeforeElmUpdate_searchPart_Match != null && urlBeforeElmUpdate_searchPart_Match.length > 1) {
                        urlBeforeElmUpdate_searchPart = urlBeforeElmUpdate_searchPart_Match[0];
                    }

                    window.PGridClientDebugMode >= 3 && console.debug(`HandlePlannicaGridUrlUpdates(): urlBeforeElmUpdate_searchPart: ${JSON.stringify({ urlBeforeElmUpdate_searchPart, urlBeforeElmUpdate_tabIdx })}`);
                }
                let urlAfterElmUpdate = null;
                let urlAfterElmUpdateTabs = null;
                let urlAfterElmUpdateTabs_Selected = null;
                let urlAfterElmUpdate_tabIdx = -1;
                // if (urlBeforeElmUpdate_searchPart == null || ConfirmNavigation(context, `port plannicaGridApplicationClick url: ${url}`, urlBeforeElmUpdate_searchPart, "Vill du ändå navigera bort?")) {


                let do_ReOrLoadInitialCustomerTabKey = false;

                if (urlBeforeElmUpdate_searchPart == null) {
                    window.PGridClientDebugMode >= 3 && console.debug(`HandlePlannicaGridUrlUpdates() do ReOrLoadInitialCustomerTabKey as urlBeforeElmUpdate_searchPart==null`);
                    do_ReOrLoadInitialCustomerTabKey = true;
                }
                else if (ConfirmNavigation(context, `HandlePlannicaGridUrlUpdates() url: ${newUrl}`, "Vill du ändå navigera bort?")) {
                    window.PGridClientDebugMode >= 3 && console.debug(`HandlePlannicaGridUrlUpdates() do ReOrLoadInitialCustomerTabKey as ConfirmNavigation() == true`);
                    do_ReOrLoadInitialCustomerTabKey = true;
                }

                // if (urlBeforeElmUpdate_searchPart == null || PGridUtils.ConfirmNavigation(context, `port plannicaGridApplicationClick url: ${newUrl}`, "Vill du ändå navigera bort?")) {
                if (do_ReOrLoadInitialCustomerTabKey) {
                    window.PGridClientDebugMode >= 3 && console.debug(`HandlePlannicaGridUrlUpdates() DEBUG A do_ReOrLoadInitialCustomerTabKey`);
                    await sleep(100); //Whait for ELM to update "selected" tab
                    window.PGridClientDebugMode >= 3 && console.debug(`HandlePlannicaGridUrlUpdates() DEBUG B do_ReOrLoadInitialCustomerTabKey`);
                    updateTabLinks(newUrl_SearchPart, `plannicaGridApplicationClick()`);
                    window.PGridClientDebugMode >= 3 && console.debug(`HandlePlannicaGridUrlUpdates() DEBUG C do_ReOrLoadInitialCustomerTabKey`);
                    await sleep(100);
                    window.PGridClientDebugMode >= 3 && console.debug(`HandlePlannicaGridUrlUpdates() DEBUG D do_ReOrLoadInitialCustomerTabKey`);

                    // urlAfterElmUpdate = new Array(...document.querySelectorAll(".app-tabs li")).find(o => o.className.indexOf("selected") != -1).childNodes[0].href
                    let urlAfterElmUpdateTabs = new Array(...document.querySelectorAll(".app-tabs li"));

                    if (urlAfterElmUpdateTabs == null) {
                        console.warn(`HandlePlannicaGridUrlUpdates() urlAfterElmUpdateTabs == null`);
                        return;
                    } else if (urlAfterElmUpdateTabs.length == 0) {
                        console.warn(`HandlePlannicaGridUrlUpdates() urlAfterElmUpdateTabs.length == 0`);
                        return;
                    }

                    urlAfterElmUpdateTabs_Selected = urlAfterElmUpdateTabs.find((o, idx) => {
                        let ret = false;
                        if (o.className.indexOf("selected") != -1) {
                            ret = true;
                            urlAfterElmUpdate_tabIdx = idx;
                        }
                        return ret;
                    });

                    if (urlAfterElmUpdateTabs_Selected == null) {
                        console.warn(`urlAfterElmUpdateTabs_Selected == null`);
                    }


                    window.PGridClientDebugMode >= 3 && console.debug(`HandlePlannicaGridUrlUpdates() DEBUG E do_ReOrLoadInitialCustomerTabKey`);
                    await ReOrLoadInitialCustomerTabKey();
                } else {
                    window.PGridClientDebugMode >= 3 && console.debug(`HandlePlannicaGridUrlUpdates() DEBUG HistoryPushStateIfNotSame`);
                    await sleep(100);
                    updateTabLinks(urlBeforeElmUpdate_searchPart, `HandlePlannicaGridUrlUpdates() keep old url`);

                    // console.log("plannicaGridApplicationClick() window.history.pushState: " + window.history.pushState);
                    // window.history.pushState({ path: urlBeforeElmUpdate }, "", urlBeforeElmUpdate);

                    HistoryPushStateIfNotSame(urlBeforeElmUpdate, `HandlePlannicaGridUrlUpdates()`);

                    await sleep(100);
                }

                false && console.debug(JSON.stringify({ urlBeforeElmUpdate: urlBeforeElmUpdate.split('&').filter(o => o.indexOf("tk=") != -1), urlAfterElmUpdate: urlAfterElmUpdate.split('&').filter(o => o.indexOf("tk=") != -1) }, null, 2));

            } catch (err) {
                let errMsg = `HandlePlannicaGridUrlUpdates() got exception: ${err.message}`;
                console.error(errMsg);
            }
        });

        asyncLoadKeys();
    }


}

export async function HandleButtonPress(dynBtn, context) {


    let EventArgs = lodash.get(dynBtn, "EventArgs", {});
    let IgnoreCellValidation = lodash.get(dynBtn, "IgnoreCellValidation", false);
    let ConfirmMessage = lodash.get(dynBtn, "ConfirmMessage", false);
    let AttestCheck = lodash.get(dynBtn, "AttestCheck", false);

    if (EventArgs == null) {
        throw new Error(`HandleButtonPress: invalid EventArgs: ${EventArgs}`);
    }

    if (AttestCheck) // buttonType == "save" || buttonType == "publish") {
    {
        let attestCheck = CheckAttestRequirements(
            context.state.pgridSettings.attestRequired,
            context.state.pgridSettings.attestStatusOK
        );

        if (attestCheck.hasMissingAttest) {
            //Not redy for save
            alert(attestCheck.tooltipMsg);

            return;
        }
    }


    if (ConfirmMessage != null) {
        let confirmResp = confirm(ConfirmMessage);
        if (!confirmResp) {
            return;
        }
    }

    // if (buttonType == "publish") {
    //     let userOKPublish = confirm("Är du säker på att du vill publicera?");

    //     if (!userOKPublish) {
    //         return;
    //     }
    // }

    // if (buttonType == "delete") {
    //     let userOKDelete = confirm("Är du säker på att du vill ta bort beräkningen?");

    //     if (!userOKDelete) {

    //         return;
    //     }
    // }
    //Will proceed

    let initTimestamp = null;
    initTimestamp = Date.now(); //mili seconds
    let initUrl = null;
    initUrl = window.location.href;

    context.commit("Mutation_UpdatePGridSettings", {
        prop: "initOfLastQuery_Timestamp",
        val: initTimestamp,
        source: `HandleButtonPress()`,
    });
    context.commit("Mutation_UpdatePGridSettings", {
        prop: "initOfLastQuery_Url",
        val: initUrl,
        source: `HandleButtonPress()`,
    });

    await context.dispatch("Action_Calc_AllOrChanges", {
        initTimestamp: initTimestamp,
        initUrl: initUrl,
        source: "uiButtonSaveFact",
    });

    window.PGridClientDebugMode >= 2 && console.debug("HandleButtonPress() forced a calculation");


    let StartTime_hotRef_validateCells = Date.now();

    context.state.hotRef.validateCells((valid) => {
        try {

            //Time of validation
            window.PGridClientDebugMode >= 2 && console.debug(`[pgrid-filters.vue: uiButtonSaveFact(): hotRef.validateCells()] elapsed ${Math.floor((Date.now() - StartTime_hotRef_validateCells) / 100)} 10th: s`); // in seconds

            if (valid || IgnoreCellValidation) {


                let asyncSaveAndReloadGrid = async function () {
                    try {
                        await context.dispatch("action_SavePgridFactToDatabase", EventArgs);

                        if (EventArgs.ButtonPushed == "DELETED") {
                            console.warn(`IGNORING DELETE HERE`);

                            let newOptSelected = {
                                "filterIdx": context.state.pgridFilter.Filters.length - 1 /* The Version filter is always the last */,
                                "newOptSelected": null
                            }
                            HandleFilterSelectionChange(context, newOptSelected);
                        }

                        // new Date(initTimestamp).toISOString().slice(0,10) + ' ' + new Date(initTimestamp).toLocaleTimeString('sv-SE')

                        context.commit("Mutation_UpdatePGridSettings", {
                            prop: "hasUnsavedFactChangesForUrl",
                            val: null,
                            source: "HandleButtonPress()",
                        });

                        if (lodash.get(EventArgs, "ForceGridReload", false)) {
                            await context.dispatch("Action_InjectAndRendrFilters", { source: "HandleButtonPress()" });
                        } else if (lodash.get(EventArgs, "ForceFilterRefresh", false)) {

                            // window.PGridClientDebugMode >= 2 && console.debug(`SavePGridFactToDatabase() sleeping (delay after AfterSaveFact) ${context.state.pgridSettings.delayedAfter_AfterSaveFact_Miliseconds} ms`);
                            // await sleep(context.state.pgridSettings.delayedAfter_AfterSaveFact_Miliseconds);

                            await context.dispatch("Action_PgridDataFetchFromDatabase", { initTimestamp, pgridVars: context.state.pgridVars, source: `HandleButtonPress() validateCells()` });
                            await context.dispatch("Action_PgridFiltersUpdateStates", { source: `HandleButtonPress() validateCells()` });
                        }

                    } catch (err) {

                        alert(`Fel upptäckta i tabellen. Sparning avbruten: asyncSaveAndReloadGrid(): ${err.message}`);
                        context.commit('Mutation_UpdatePGridSettings', { prop: "isSaving", val: false, source: `HandleButtonPress() validateCells()` });

                    }
                };

                asyncSaveAndReloadGrid();

            } else {
                alert("Fel upptäckta i tabellen. Sparning avbruten");
            }
        } catch (err) {

            alert(`Fel upptäckta i tabellen. Sparning avbruten: ${err.message}`);

        }
    });
}


export function PGridTimerStart(timerName) {
    if (window.PGridClientDebugMode >= 3) {
        if (!window.PGridTimers) {
            window.PGridTimers = {};
        }
        if (window.PGridTimers[`${timerName}`] && window.PGridTimers[`${timerName}`].Start) {
            console.warn(`PGridTimerStart() timer '${timerName}' allready exists`)
        } else {
            window.PGridTimers[`${timerName}`] = {};
            window.PGridTimers[`${timerName}`].Start = Date.now();
            delete window.PGridTimers[`${timerName}`].Stop;
        }
    }
}
export function PGridTimerStop(timerName) {
    if (window.PGridClientDebugMode >= 3) {
        if (window.PGridTimers[`${timerName}`]) {
            window.PGridTimers[`${timerName}`].Stop = Date.now();
        }
    }
}

export function PGridTimerPrint(timerName) {
    if (window.PGridClientDebugMode >= 3) {
        if (!window.PGridTimers) {
            window.PGridTimers = {};
        }
        let timerKeys = Object.keys(window.PGridTimers);

        let outTxt = "";

        timerKeys.forEach((key) => {
            if (window.PGridTimers[key].Start && window.PGridTimers[key].Stop) {
                outTxt += `${key}: ${window.PGridTimers[key].Stop - window.PGridTimers[key].Start} ms\n`
            } else {
                console.warn(`PGridTimerPrint() missing ${window.PGridTimers[key].Stop ? 'Start' : 'Stop'} for key ${key}`)
            }
        });

        console.debug(`PGridTimerPrint():\n${outTxt}`);
    }
}

export function PGridTimerReset() {
    window.PGridTimers = {};
}

function IsEmpty(str) {
    return (!str || 0 === str.length);
}

function IsSameUrlHost(urlA, urlB) {

    let isSameSite = true;

    let check_oldUrl = new URL(urlA);
    let check_newUrl = new URL(urlB);

    if (check_oldUrl.host != check_newUrl.host) {
        isSameSite = false;
    }

    return isSameSite;



}

export function HistoryPushStateIfNotSame(newUrl, source, replaceState = false) {

    let isSameSite = true;

    let [newUrlPathhPart, newUrlQS] = newUrl.split('?');
    let [currentUrlPathhPart, currentUrlQS] = window.location.href.split('?');

    let newUrlQS_Sorted = QueryString_Sort('?' + newUrlQS);
    let newUrlQS_KV_list = QueryString_GetKeyValuePairs(newUrlQS_Sorted);

    let currentUrlQS_Sorted = QueryString_Sort('?' + currentUrlQS);
    let currentUrlQS_KV_list = QueryString_GetKeyValuePairs(currentUrlQS_Sorted);

    let newUrlSorted = newUrlPathhPart + newUrlQS_Sorted;
    let currentUrlSorted = currentUrlPathhPart + currentUrlQS_Sorted;


    let lastUrlWasWitoutDefaultFilterSelected = true;


    currentUrlQS_KV_list.forEach(o => {
        let foundMatch = false;

        let foundNewObj = newUrlQS_KV_list.find(j => o.key == j.key);

        if (foundNewObj) {

            if (o.val == foundNewObj.val) {
                foundMatch = true;
            }
        }

        if (!foundMatch) {
            lastUrlWasWitoutDefaultFilterSelected = false;
        }
    });

    // let check_oldUrl = new URL(window.location.href);
    // let check_newUrl = new URL(newUrlSorted);

    // if (check_oldUrl.host != check_newUrl.host) {
    //     console.warn(`HistoryPushStateIfNotSame() new url is on another host, will not pushState`);
    //     isSameSite = false;
    // }
    isSameSite = IsSameUrlHost(window.location.href, newUrlSorted);


    if (newUrlQS == null) {
        // console.warn("Invalid new url");
        isSameSite = null;
        return isSameSite;
    }

    if (isSameSite) {

        if (currentUrlSorted == newUrlSorted) {
            console.debug(`HistoryPushStateIfNotSame() same as current, will not push to history`);
        } else {

            if (replaceState || lastUrlWasWitoutDefaultFilterSelected) {
                window.PGridClientDebugMode >= 2 && console.debug(`HistoryPushStateIfNotSame() replace state: ${newUrlSorted}`);
                window.history.replaceState({ path: newUrlSorted }, "", newUrlSorted);

            } else {
                window.PGridClientDebugMode >= 2 && console.debug(`HistoryPushStateIfNotSame()       pushing: ${newUrlSorted}`);
                window.history.pushState({ path: newUrlSorted }, "", newUrlSorted);

            }
        }
    }

    return;
}

export async function getIdTokenForGrid() {

    let ret = null;

    if ('checkIfLoggedIn_ELM_AND_GRID' in window) {
        let authContext = await window.checkIfLoggedIn_ELM_AND_GRID(true, false);

        if (authContext) {
            window.PGridClientDebugMode >= 2 && console.log('getIdTokenForGrid() authContext.idToken: ', authContext.idToken);
            ret = authContext.idToken
        }
    }
    return ret;
}

async function DirtyGridFlag(context, source) {
    let searchPart = window.location.href.match(/(\?.*)/)[1];

    if (searchPart == null) {
        throw new Error(`Could not find search path in window.location.href: ${window.location.href} `);
    }

    if (context.state.pgridSettings.hasUnsavedFactChangesForUrl != searchPart) {
        context.commit('Mutation_UpdatePGridSettings', { prop: 'hasUnsavedFactChangesForUrl', val: searchPart, source: `${source} -> DirtyGridFlag()` });

        window.PGridClientDebugMode >= 2 && console.debug("############## dirty facts detected ################");
    }
}

function SaveScrollAndCellPositionForCurrentPage(context, clickedCell = null) {
    if (context.state.hotRef) {

        let AutoRowSize_plugin = context.state.hotRef.getPlugin('AutoRowSize');

        let firstVisibleRow = AutoRowSize_plugin.getFirstVisibleRow();


        let firstVisibleColumn = AutoRowSize_plugin.getFirstVisibleColumn();

        window.PGridClientDebugMode >= 2 && console.debug(`Upper left cell is on firstVisibleColumn row ${firstVisibleRow} column ${firstVisibleColumn}`);

        let clickedCellFinal = null;
        if (clickedCell) {
            clickedCellFinal = { y: clickedCell[0], x: clickedCell[1] };
        }

        context.commit("Mutation_UpdatePGridSettings", {
            prop: "scollbackMemory",
            op: "addkey",
            key: `${location.search}`,
            val: {
                row: firstVisibleRow, column: firstVisibleColumn, clickedCell: clickedCellFinal,
                source: `SaveScrollAndCellPositionForCurrentPage()`
            }
        });
    }
}


export default {
    AddInputBarClasses,
    beautifyErrorMessage,
    Calculate_All_Formulas,
    // CalculateEnableSaveButtons,
    CleanupFilterKey,
    CleanupFilterKeyStr,
    ConfirmNavigation,
    CheckAttestRequirements,
    // CheckSaveButtonEnabledRequirements,
    Convert_PgridDataToHotTable,
    Convert_PgridDataToPGridRows,
    Convert_PGridRowsToPgridData,
    DebugCountLRs,
    Diff_PgridData,
    Extract_AccountTypeFromJWT,
    extractCellDataForPanel,
    extractRelativLRNameAndAddressForPanel,
    extractRefTypeFromCoord,
    extractDynAddr,
    extractCellLookupValuesFromDS,
    Filter_ConvertPgridDefinitionToFilterNames,
    Filter_ConvertPgridDefinitionToPGridFilter,
    Filter_ExtractFilterDefinition,
    Filter_ExtractFilterSelection,
    Filter_ExtractPGridFiltersSelection,
    Filter_NewValueFromFilter,
    Filter_ValidateFilterSelection,
    findLRCoordinateOFF,
    genCellFromTempls,
    Get_CurrentPGridData,
    Get_CurrentPGridData_ASYNC,
    Get_DynamicMode_PGridDataKey,
    Get_HotCellSelection,
    Get_HOTUncalcedDataAndSettings,
    getPGridCell,
    HandleDimensionOverrides,
    handleOrDelayAfterChange_Clear,
    handleOrDelayAfterChange,
    HandleFilterSelectionChange,
    GetPGridDefinition,
    HeighlightRefCells: RecurseHeighlightRefCells,
    hideGhostPanelHosts,
    HistoryPushStateIfNotSame,
    PreFilterRendr,
    Is_DynamicMode,
    IsNumeric,
    IsEmpty,
    IsSameUrlHost,
    JustifyDataKey,
    JustifyDataKeyExcludeFields,
    JustifyDataKeyIncludeFields,
    MakeNumericIfPossible,
    Merge_CellFromPanel,
    Merge_HotTableToPgridTable,
    Parse_FormatField,
    Parse_TrueFalseNull,
    QueryString_GetKeyValueDict,
    QueryString_GetKeyValuePairs,
    QueryString_Sort,
    QueryString_UpdateByKey,
    RemoveInputBarClasses,
    ReOrLoadInitialCustomerTabKey,
    replaceAllDynAddr,
    safeifyHtmlData,
    saveCellDataForPanel,
    sleep,
    spinningTreeNet,
    spinningTreeNetSYNC,
    spliceSplit,
    SumAllRowForAxis,
    Translate_ViewModeToMergeType,
    trimAndUpperCaseIfNotNull,
    updateTabLinks,
    escapeRegExp,
    applyKeywordsDb,
    DebugDetectTableChanges,
    DebugDetectTableChanges_FindCells,
    removeClassesByPrefix,
    mobileCheck,
    truncString,
    clickTabOrLinkEvent,
    HandlePlannicaGridUrlUpdates,
    HandleButtonPress,
    PGridTimerStart,
    PGridTimerStop,
    PGridTimerPrint,
    PGridTimerReset,
    GetRefsFromFormula,
    InvertObjArr,
    getIdTokenForGrid,
    DirtyGridFlag,
    SaveScrollAndCellPositionForCurrentPage
}